<template>
    <header>
    <div class="preloader" v-if="loading">
      <div class="circular-spinner">
        <img src="../assets/images/shiba-loading.png" width="150">
      </div>
    </div>
		<nav class="x-header navbar navbar-expand -logged py-0">
			<div class="container-fluid align-items-center h-100 position-relative">
				<div id="headerBrand">
				<!-- <button
					type="button"
					class="btn bg-transparent p-0 x-hamburger js-hamburger-toggle"
					@click="gotoMain()"
				>
					<span></span>
					<span></span>
					<span></span>
				</button> -->
				<div class="-branding-inner-wrapper">
					<router-link to="/" class="navbar-brand">
					<img
						class="-logo"
						src="../assets/images/logo-headline65x400.png"
						:alt="$t('funbeyond_main_alt')"
					/>
					</router-link>
				</div>
				</div>

				<div id="headerContent">
					<button v-if="hasActivePayBridgeTask" type="button" class="paybridge-task-button" @click.stop="reopenPayBridgeTask">
						<span class="paybridge-task-dot"></span>
						<span><strong>PayBridge</strong><small>{{ paybridgeTaskRemainingText }}</small></span>
					</button>
					<div class="x-language">
						<div class="current-lang -link-wrapper" @click="toggleDropdown">
							<div class="-image-wrapper">
								<img 
									class="img-fluid -ic-right-star-rank" 
									:src="getFlagImage()" 
									alt="Shiba888 change language"
								>
								<span class="lang-name" v-if="isDropdownOpen">{{ getLanguageName() }}</span>
							</div>
						</div>
						<div class="lang-dropdown" v-if="isDropdownOpen">
							<div 
								v-for="lang in languages" 
								:key="lang.code"
								class="lang-option"
								@click="selectLanguage(lang.code)"
							>
								<img 
								:src="require(`../assets/images/flags/${lang.code}.png`)" 
								:alt="lang.name"
								class="flag-icon"
								>
								<span class="lang-name">{{ lang.name }}</span>
							</div>
						</div>
					</div>
					<div class="x-ranking-entrance">
							<router-link to="/rewards" class="-link-wrapper">
								<div class="-image-wrapper">
									<img class="img-fluid -ic-right-star-rank" src="../assets/images/coin1.png" :alt="$t('rewards_exchange_alt')">
								</div>
								<div class="-text-wrapper">{{numberWithCommas2(user.coin)}}</div>
							</router-link>
					</div>
				<ul class="nav -menu-wrapper -logged">
					<li class="nav-item">
					<router-link to="/play" class="nav-link -partner">
						<div class="-img-wrapper">
						<img
							src="../assets/images/menu/play-1.png"
							class="-icon"
							:alt="$t('play_game_alt')"
						/>
						</div>
						<div class="-text">{{ $t('play') }}</div>
					</router-link>
					</li>

					<li class="nav-item">
					<router-link to="/promotion" class="nav-link -partner">
						<div class="-img-wrapper">
						<img
							src="../assets/images/menu/promotion-1.png"
							class="-icon"
							alt="Promotion"
						/>
						</div>
						<div class="-text">{{ $t('promotion') }}</div>
					</router-link>
					</li>

					<li class="nav-item">
					<router-link to="/partner" class="nav-link -partner">
						<div class="-img-wrapper">
						<img
							src="../assets/images/menu/friend-1.png"
							class="-icon"
							alt="Partner"
						/>
						</div>
						<div class="-text">{{ $t('partner') }}</div>
					</router-link>
					</li>

					<li class="nav-item">
					<router-link to="/cashback" class="nav-link -partner">
						<div class="-img-wrapper">
						<img
							src="../assets/images/menu/money-1.png"
							class="-icon"
							alt="Cashback"
						/>
						</div>
						<div class="-text">{{ $t('cashback') }}</div>
					</router-link>
					</li>
				</ul>

				<div class="navbar-nav">
					<div class="x-logged">
					<div class="-deposit-container d-none d-lg-block">
						<a
						href="#deposit"
						class="text-white js-account-approve-aware btn -btn-deposit"
						@click="handleDepositClick()"
						>
						<div class="f-7">{{ $t('deposit') }}</div>
						</a>
					</div>
					<div class="-withdraw-container d-none d-lg-block">
						<a
						href="#withdraw"
						class="text-white js-account-approve-aware btn -btn-withdraw"
						@click="handleWithdrawClick()"
						>
						<div class="f-7">{{ $t('withdraw') }}</div>
						</a>
					</div>
					<div class="-profile-container">
						<div class="d-none d-lg-block">
						<div class="-btn-wrapper">
							<div class="-inner-wrapper">
							<a
								href="#account"
								data-toggle="modal"
								data-target="#accountModal"
								class="text-decoration-none"
							>
								<div class="-profile-name2">{{user.code}}</div>
							</a>
							<div class="-balance-container">
								<div class="-text-username">
								{{user.code}}
								</div>

								<div class="-user-balance js-user-balance f-sm-6 f-7 ">
								<div class="-inner-box-wrapper2">
									<img
									class="img-fluid -ic-coin"
									src="../assets/images/shiba888-ic-coin.png"
									alt="customer image"
									width="26"
									height="21"
									/>

									<span id="customer-balance"
									><span class="-amount">{{ numberWithCommas(user.credit) }}</span>
									</span>
								</div>
								<button
									type="button"
									class="-btn-balance2"
									id="btn-customer-balance-reload"
									@click="reloadBalance()"
								>
									<i :class="{'fas':true, 'fa-sync-alt':true, 'f-10':true, 'fa-spin':fa_spin}"></i>
								</button>
								</div>
							</div>
							</div>

							<a
							href="#account"
							data-toggle="modal"
							data-target="#accountModal"
							>
							<div class="x-profile-image">
								<img
								class="img-fluid -profile-image"
								src="../assets/images/avatar.png"
								alt="customer image"
								/>
							</div>
							</a>
						</div>
						</div>

						<div class="d-lg-none">
						<div :class="{'js-ez-logged-sidebar':true, '-btn-mobile-wrapper':true , '-open':this.accountOpen }">
							<div class="-inner-wrapper" style="line-height:1;">
							<a href="javascript:void(0)" @click="showTabAccount()">
								<div class="-profile-name2">{{user.code}}</div>
							</a>
							<div class="-balance-container">
								<div class="-text-username">
								{{user.tel}}
								</div>

								<div class="-user-balance js-user-balance f-sm-6 f-7 ">
								<div class="-inner-box-wrapper2">
									<img
									class="img-fluid -ic-coin"
									src="../assets/images/shiba888-ic-coin.png"
									alt="customer image"
									width="26"
									height="21"
									/>

									<span id="customer-balance"
									><span class="-amount">{{ numberWithCommas(user.credit) }}</span>
									</span>
								</div>
								<button
									type="button"
									class="-btn-balance2"
									@click="reloadBalance()"
								>
									<i :class="{'fas':true, 'fa-sync-alt':true, 'f-10':true, 'fa-spin':fa_spin}"></i>
								</button>
								</div>
							</div>
							</div>

							<a href="javascript:void(0)" @click="showTabAccount()">
							<div class="x-profile-image">
								<img
								class="img-fluid -profile-image"
								src="../assets/images/avatar.png"
								alt="customer image"
								/>
							</div>
							</a>
						</div>

						<div :class="{'x-menu-account-list-sidebar':true,'-open':this.accountOpen}">
							<div class="x-modal-account-menu-mobile">
							<div class="-modal-profile-mobile d-xl-none d-block">
								<div class="text-right">
								<i class="fas fa-times f-5 js-close-account-sidebar" @click="showTabAccount()"></i>
								</div>

								<div class="x-profile-image">
								<img
									class="img-fluid -profile-image"
									src="../assets/images/avatar.png"
									alt="customer image"
								/>
								</div>

								<div class="-balance-container">
								<div class="-text-username">
									{{user.tel}}
								</div>

								<div
									class="-user-balance js-user-balance f-sm-6 f-7 "
								>
									<div class="-inner-box-wrapper2">
									<img
										class="img-fluid -ic-coin"
										src="../assets/images/shiba888-ic-coin.png"
										alt="customer image"
										width="26"
										height="21"
									/>

									<span id="customer-balance"
										><span class="-amount">{{numberWithCommas(user.credit)}}</span>
									</span>
									</div>
									<button
									type="button"
									class="-btn-balance2"
									@click="reloadBalance()"
									>
									<i :class="{'fas':true, 'fa-sync-alt':true, 'f-10':true, 'fa-spin':fa_spin}"></i>
									</button>
								</div>
								</div>
							</div>

							<div class="-lists-outer-wrapper">
								<ul class="navbar-nav">
								<!-- <li class="nav-item -join-promotion" v-if="!user.userId">
									<button
									type="button"
									class="nav-link js-close-account-sidebar "
									 @click="lineLogin()"
									>
									<img
										class="img-fluid -icon-image"
										src="../assets/images/icon-line.svg"
										alt="Line"
									/>
									<span class="-text-menu">{{ $t('login_with_line') }}</span>
									</button>
								</li>	 -->
								<li class="nav-item -account-profile" :class="{ 'active': mobileActiveTab === 'bank' }">
									<button type="button" class="nav-link js-close-account-sidebar" @click="setMobileActiveTab('bank')" data-toggle="modal" data-target="#accountModalMobile">
										<img class="img-fluid -icon-image" src="../assets/images/shiba888-ic-menu-user.png" alt="icon user" width="28" height="27">
										<span class="-text-menu" style="font-size:15px">
											{{ $t('header.account_info') }}
										</span>
									</button>
								</li>
								<!-- <li class="nav-item -coupon">
									<button
									type="button"
									class="nav-link js-close-account-sidebar js-account-approve-aware"
									data-toggle="modal"
									data-target="#couponModalMobile"
									>
									<img
										class="img-fluid -icon-image"
										src="../assets/images/shiba888-ic-menu-coupon.png"
										alt="ic-menu-coupon"
									/>
									<span class="-text-menu">{{ $t('use_coupon') }}</span>
									</button>
								</li> -->
								<li class="nav-item -join-promotion">
									<button
									type="button"
									class="nav-link js-close-account-sidebar "
									@click="$router.replace('/promotion')"
									>
									<img
										class="img-fluid -icon-image"
										src="../assets/images/shiba888-ic-menu-promotion.png"
										alt="ic-menu-promotion"
									/>
									<span class="-text-menu"
										>{{ $t('menu_promotion') }}</span
									>
									</button>
								</li>
								<li class="nav-item -logout">
									<a
									class="nav-link js-require-confirm"
									:data-title="$t('logout_confirmation')"
									@click="confirmLogout()"
									>
									<img
										class="img-fluid -icon-image"
										src="../assets/images/shiba888-ic-menu-logout.png"
										alt="ic-menu-logout"
									/>
									<span class="-text-menu">{{ $t('header.logout') }}</span>
									</a>
								</li>
								</ul>
								<!-- <ul class="navbar-nav -action-nav">
								<li class="nav-item">
									<a
									:href="adminContactLineLink"
									class="nav-link js-close-account-sidebar"
									target="_blank"
									>
									<img
										src="../assets/images/btn_hover.png"
										class="-img"
										width="100"
										height="100"
										style="display: initial;"
									/>
									<div class="-text" style="font-size:12px;">{{ $t('contact_admin') }}</div>
									</a>
								</li>
								</ul> -->
							</div>
							</div>
							<div class="-overlay"></div>
						</div>
						</div>
					</div>
					</div>
				</div>
				</div>
			</div>
			</nav>
			


		<div class="x-modal modal" id="accountModal" tabindex="-1" role="dialog" data-loading-container=".modal-body" data-container="#accountModal" aria-hidden="true">
			<div class="modal-dialog -modal-size  -modal-big -modal-main-account" role="document" style="padding-top: 74.8012px;">
			<div class="modal-content -modal-content">
				<button type="button" class="close f-1 " data-dismiss="modal" aria-label="Close">
					<i class="fas fa-times"></i>
				</button>
				<div class="modal-body -modal-body" style="top: 0px;">
					<div class="x-modal-account-menu">
						<ul class="navbar-nav">
							<!-- <li class="nav-item -account-profile" v-if="!user.userId">
								<button type="button" class="nav-link js-close-account-sidebar" @click="lineLogin()">
									<img class="img-fluid -icon-image" src="../assets/images/icon-line.svg" alt="Line" width="28" height="27">
									<span class="-text-menu" style="font-size:15px">
										{{ $t('login_with_line') }}
									</span>
								</button>
							</li> -->
							<li class="nav-item -account-profile" :class="{ 'active': accountActiveTab === 'bank' }">
								<button type="button" class="nav-link js-close-account-sidebar" @click="setAccountActiveTab('bank')">
									<img class="img-fluid -icon-image" src="../assets/images/shiba888-ic-menu-user.png" alt="icon user" width="28" height="27">
									<span class="-text-menu" style="font-size:15px">
										{{ $t('header.account_info') }}
									</span>
								</button>
							</li>
							<!-- <li class="nav-item -account-provider ">
								<button type="button" class="nav-link js-close-account-sidebar" data-container="#accountModal" data-active-menu="-account-provider" data-loading="_onLoading_" data-target=".js-profile-account-modal">
									<img class="img-fluid -icon-image" src="../assets/images/shiba888-ic-menu-provider.png" alt="icon phone" width="28" height="27">
									<span class="-text-menu">
										{{ $t('play_through_app') }}
									</span>
								</button>
							</li> -->
										<!-- <li class="nav-item -coupon ">
									<button type="button" class="nav-link js-close-account-sidebar js-account-approve-aware" data-container="#accountModal" data-active-menu="-coupon" data-loading="_onLoading_" data-target=".js-profile-account-modal">
										<img class="img-fluid -icon-image" src="../assets/images/shiba888-ic-menu-coupon.png" alt="icon coupon" width="28" height="27">
										<span class="-text-menu">
											{{ $t('use_coupon') }}
										</span>
									</button>
								</li> -->
									<li class="nav-item -join-promotion ">
								<button type="button" class="nav-link js-close-account-sidebar" data-container="#accountModal" data-active-menu="-join-promotion" data-loading="_onLoading_" data-target=".js-profile-account-modal" @click="gotoPromotion()">
									<img class="img-fluid -icon-image" src="../assets/images/shiba888-ic-menu-promotion.png" alt="icon promotion" width="28" height="27">
									<span class="-text-menu" style="font-size:15px">
										{{ $t('menu_promotion') }}
									</span>
								</button>
							</li>

							
							<li class="nav-item js-close-account-sidebar -logout">
								<a href="javascript:void(0)" class="nav-link js-require-confirm" :data-title="$t('logout_confirmation')" @click="confirmLogout()">
									<img class="img-fluid -icon-image" src="../assets/images/shiba888-ic-menu-logout.png" alt="icon logout" width="28" height="27">
									<span class="-text-menu" style="font-size:15px">
										{{ $t('header.logout') }}
									</span>
								</a>
							</li>
						</ul>
					</div>
					<div class="js-profile-account-modal -layout-account">
						<!-- Profile Tab -->
						<div class="x-account-profile -v2" v-if="accountActiveTab === 'profile'">
							<div data-animatable="fadeInModal" class="-profile-container animated fadeInModal">
							<div class="x-title-modal -v2 mx-auto text-center">
								{{ $t('header.account_info') }}
							</div>
				
							<div class="text-center">
								<div class="my-3">
									<div class="x-profile-image">
										<img class="img-fluid -profile-image" src="../assets/images/avatar.png" alt="customer image">
									</div>
							</div>

							<div class="my-3">
								<div class="-text-username">Username:  {{user.tel}}</div>
									<button type="button" class="-link-change-password btn-primary" @click="showChangePasswordFormMobile = !showChangePasswordFormMobile" style="color:#fff; padding: 8px 16px;">{{ $t('header.change_password') }}</button>
								</div>

								<div class="-change-password-container" v-if="showChangePasswordFormMobile">
									<div class="js-collapse-content">

									<div class="form-group mt-3">
										<input type="password" v-model="password" required="required" :placeholder="$t('current_password_placeholder')" class="x-form-control form-control">
									</div>
									<div class="form-group">
										<input type="password" v-model="password1" required="required" :placeholder="$t('new_password_placeholder')" class="x-form-control form-control">
									</div>
									<div class="form-group">
										<input type="password" v-model="password2" required="required" :placeholder="$t('confirm_new_password_placeholder')" class="x-form-control form-control">
									</div>

									<button type="button" @click="changePassword()" class="btn -submit btn-primary text-center m-auto js-user-confirm-deposit">
										<span>{{ $t('confirm') }}</span>
									</button>

									</div>
								</div>
							</div>

							<!-- <div class="-bank-info-container" v-if="getApprovedAccounts().length > 0">
								<div class="x-title-modal -v2 mx-auto text-center" style="font-size: 16px; margin-bottom: 15px;">
									{{ $t('header.approved_accounts') }}
								</div>
								<div class="x-customer-bank-info-container -v2" v-for="(account, index) in getApprovedAccounts()" :key="index" style="margin-bottom: 10px;">
									<div class="media m-auto">
										<img v-if="account.bank" :src="getBankImage(account.bank)" class="-img rounded-circle" width="50" height="50" :alt="getBankName(account.bank)">
										<div class="-content-wrapper">
											<span class="-name">{{account.firstname}} {{account.lastname}}</span>
											<span class="-number">{{account.account_no}}</span>
											<span class="-bank-name">{{getBankName(account.bank)}}</span>
										</div>
									</div>
								</div>
							</div> -->

					
							<div class="x-admin-contact text-center ">
								<span class="x-text-with-link-component">
									<label class="-text-message ">{{ $t('header.contact_support') }}</label>
									<a :href="adminContactLineLink" class="-link-message " target="_blank" rel="noopener">
										<u>{{ $t('header.contact_customer_service') }}</u>
									</a>
								</span>
							</div>

							<div class="js-has-info"></div>
						</div>
						</div>

						<!-- Bank Management Tab -->
						<div class="x-account-bank -v2" v-if="accountActiveTab === 'bank'">
							<div data-animatable="fadeInModal" class="-bank-container animated fadeInModal">
								<div class="x-title-modal -v2 mx-auto text-center">
									{{ $t('header.bank_management') }}
								</div>

								<!-- User Info -->
								<div class="text-center mb-3">
									<div class="-text-username">Username: {{user.tel}}</div>
									<div class="-text-username" v-if="user.firstname || user.lastname" style="margin-top: 8px; font-size: 16px; color: #fff; font-weight: 600;">
										Name: {{user.firstname}} {{user.lastname}}
									</div>
									<a href="#0" class="-link-change-password" data-toggle="collapse" data-target=".js-change-password-collapse"><u style="color:#fff">{{ $t('header.change_password') }}</u></a>
								</div>

								<div class="collapse -change-password-container js-change-password-collapse">
									<div class="js-collapse-content">
										<div class="form-group mt-3">
											<input type="password" v-model="password" required="required" :placeholder="$t('current_password_placeholder')" class="x-form-control form-control">
										</div>
										<div class="form-group">
											<input type="password" v-model="password1" required="required" :placeholder="$t('new_password_placeholder')" class="x-form-control form-control">
										</div>
										<div class="form-group">
											<input type="password" v-model="password2" required="required" :placeholder="$t('confirm_new_password_placeholder')" class="x-form-control form-control">
										</div>
										<button type="button" @click="changePassword()" class="btn -submit btn-primary text-center m-auto js-user-confirm-deposit" style="margin-bottom: 10px !important;">
											<span>{{ $t('confirm') }}</span>
										</button>
									</div>
								</div>

								<!-- Add New Account Form -->
								<div class="-add-account-container" v-if="showAddAccountForm">
									<div class="x-title-modal -v2 mx-auto text-center" style="font-size: 16px; margin-bottom: 15px;">
										{{ $t('header.add_new_account') }}
									</div>
									<div class="form-group">
										<select v-model="newAccount.bank" class="x-form-control form-control mb-3" @change="onBankChange()">
											<option value="">{{ $t('select_bank') }}</option>
											<option value="truewallet">Truewallet</option>
											<option value="bankokbank">BBL - ธนาคารกรุงเทพ</option>
											<option value="kbank">KBANK - ธนาคารกสิกรไทย</option>
											<option value="scb">SCB - ธนาคารไทยพาณิชย์</option>
											<option value="tisco">TISCO - ธนาคารทิสโก้</option>
											<option value="ttb">TTB - ทหารไทยธนชาต</option>
											<option value="ktb">KTB - ธนาคารกรุงไทย</option>
											<option value="krungsri">BAY - ธนาคารกรุงศรีอยุธยา</option>
											<option value="kiatnakin">KKP - ธนาคารเกียรตินาคิน</option>
											<option value="gsb">GSB - ธนาคารออมสิน</option>
											<option value="lh">LHBANK - ธนาคารแลนด์ แอนด์ เฮ้าส์</option>
											<option value="uob">UOB - ธนาคารยูโอบี</option>
											<option value="ธนาคารอิสลาม">IBANK - ธนาคารอิสลามแห่งประเทศไทย</option>
											<option value="ghbank">GHB - ธนาคารอาคารสงเคราะห์</option>
											<option value="cimb">CIMB - ธนาคารซีไอเอ็มบีไทย</option>
											<option value="baac">BAAC - ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (ธกส)</option>
											<option value="icbc">ICBC - ธนาคารไอซีบีซี (ไทย)</option>
											<option value="standard">STANDARD - ธนาคารสแตนดาร์ดชาร์เตอร์ดไทย</option>
										</select>
										<input type="text" v-model="newAccount.account_no" class="x-form-control form-control mb-3" :placeholder="newAccount.bank === 'truewallet' ? $t('phone_number') : $t('account_number')" @keypress="isNumber($event)" @input="onAccountNumberInput($event, 'desktop')" @paste="onAccountNumberPaste($event, 'desktop')" inputmode="numeric" maxlength="12">
										<div class="text-center">
											<button type="button" @click="addNewAccount()" class="btn -submit btn-primary mb-3 px-4 py-2">
												<span>{{ $t('header.add_account') }}</span>
											</button>
											<br>
											<button type="button" @click="cancelAddAccount()" class="btn btn-outline-light px-4 py-2" style="border: 2px solid #fff; color: #fff; font-weight: 500;">
												<span>{{ $t('cancel') }}</span>
											</button>
										</div>
									</div>
								</div>

								<!-- Add New Account Button -->
								<div class="text-center mb-3" v-if="!showAddAccountForm">
									<button type="button" @click="showAddAccountForm = true" class="btn -submit btn-primary">
										<i class="fas fa-plus"></i> {{ $t('header.add_new_account') }}
									</button>
								</div>

								<!-- Approved Accounts -->
								<div class="-approved-accounts" v-if="getApprovedAccounts().length > 0">
									<div class="x-title-modal -v2 mx-auto text-center" style="font-size: 16px; margin-bottom: 15px; color: #4CAF50;">
										<i class="fas fa-check-circle"></i> {{ $t('header.approved_accounts') }}
									</div>
									<div class="x-customer-bank-info-container -v2 approved-border" v-for="(account, index) in getApprovedAccounts()" :key="'approved-' + index" style="margin-bottom: 10px;">
										<div class="media m-auto">
											<img v-if="account.bank" :src="getBankImage(account.bank)" class="-img rounded-circle" width="50" height="50" :alt="getBankName(account.bank)">
											<div class="-content-wrapper">
												<span class="-name">{{account.firstname}} {{account.lastname}}</span>
												<span class="-number">{{account.account_no}}</span>
												<span class="-bank-name">{{getBankName(account.bank)}}</span>
												<span class="-status approved">{{ $t('approved_status') }}</span>
											</div>
										</div>
									</div>
								</div>

								<!-- Pending Accounts -->
								<div class="-pending-accounts" v-if="getPendingAccounts().length > 0">
									<div class="x-title-modal -v2 mx-auto text-center" style="font-size: 16px; margin-bottom: 15px; color: #FF5722;">
										<i class="fas fa-clock"></i> {{ $t('header.pending_accounts') }}
									</div>
									<div class="x-customer-bank-info-container -v2 pending-border" v-for="(account, index) in getPendingAccounts()" :key="'pending-' + index" style="margin-bottom: 10px;">
										<div class="media m-auto">
											<img v-if="account.bank" :src="getBankImage(account.bank)" class="-img rounded-circle" width="50" height="50" :alt="getBankName(account.bank)">
											<div class="-content-wrapper">
												<span class="-name">{{account.firstname}} {{account.lastname}}</span>
												<span class="-number">{{account.account_no}}</span>
												<span class="-bank-name">{{getBankName(account.bank)}}</span>
												<span class="-status pending">{{ $t('pending_approval_status') }}</span>
											</div>
										</div>
									</div>
								</div>

								<!-- No Accounts Message -->
								<div class="text-center" v-if="!user.accounts || user.accounts.length === 0">
									<p style="color: #fff; font-family: 'Kanit', sans-serif;">{{ $t('header.no_bank_account') }}</p>
								</div>

								<div class="x-admin-contact text-center mt-3">
									<span class="x-text-with-link-component">
										<label class="-text-message ">{{ $t('header.contact_support') }}</label>
										<a :href="adminContactLineLink" class="-link-message " target="_blank" rel="noopener">
											<u>{{ $t('header.contact_customer_service') }}</u>
										</a>
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			</div>
			</div>
		</div>


		<div class="x-modal modal show" id="accountModalMobile" tabindex="-1" role="dialog" data-loading-container=".modal-body" data-container="#accountModalMobile" aria-modal="true">
		<div class="modal-dialog -modal-size  -modal-mobile -account-modal -no-fixed-button" role="document" style="padding-top: 60px;">
			<div class="modal-content -modal-content">
				<button type="button" class="close f-1 " data-dismiss="modal" aria-label="Close" @click="resetMobileTabs()">
					<i class="fas fa-times"></i>
				</button>
				<div class="modal-header -modal-header">
					<div class="x-modal-mobile-header">
						<div class="-header-mobile-container">
							<h3 class="x-title-modal mx-auto text-center d-inline-block">
								<span v-if="mobileActiveTab === 'profile'">{{ $t('header.account_info') }}</span>
								<span v-else-if="mobileActiveTab === 'bank'">{{ $t('header.bank_management') }}</span>
								<span v-else>{{ $t('header.account_info') }}</span>
							</h3>
						</div>
					</div>
				</div>
				<div class="modal-body -modal-body" style="top: 76px;">
					<!-- Profile Tab Mobile -->
					<div class="x-account-profile -v2" v-if="mobileActiveTab === 'profile'">
						<div data-animatable="fadeInModal" class="-profile-container animated fadeInModal">
							<div class="text-center">
								<div class="my-3">
									<div class="x-profile-image">
										<img class="img-fluid -profile-image" src="../assets/images/avatar.png" alt="customer image">
									</div>
								</div>

								<div class="my-3">
									<div class="-text-username">Username:  {{user.tel}}</div>
									<a href="#0" class="-link-change-password" data-toggle="collapse" data-target=".js-change-password-collapse"><u style="color:#fff">{{ $t('header.change_password') }}</u></a>
								</div>

								<div class="collapse -change-password-container js-change-password-collapse">
									<div class="js-collapse-content">
										<div class="form-group mt-3">
											<input type="password" v-model="password" required="required" :placeholder="$t('current_password_placeholder')" class="x-form-control form-control">
										</div>
										<div class="form-group">
											<input type="password" v-model="password1" required="required" :placeholder="$t('new_password_placeholder')" class="x-form-control form-control">
										</div>
										<div class="form-group">
											<input type="password" v-model="password2" required="required" :placeholder="$t('confirm_new_password_placeholder')" class="x-form-control form-control">
										</div>
										<button type="button" @click="changePassword()" class="btn btn-block btn-primary -submit">
											<span>{{ $t('confirm') }}</span>
										</button>
									</div>
								</div>
							</div>

							<div class="x-admin-contact text-center mt-3">
								<span class="x-text-with-link-component">
									<label class="-text-message ">{{ $t('header.contact_support') }}</label>
									<a :href="adminContactLineLink" class="-link-message " target="_blank" rel="noopener">
										<u>{{ $t('header.contact_customer_service') }}</u>
									</a>
								</span>
							</div>

							<div class="js-has-info"></div>
						</div>
					</div>

					<!-- Bank Management Tab Mobile -->
					<div class="x-account-bank -v2" v-if="mobileActiveTab === 'bank'">
						<div data-animatable="fadeInModal" class="-bank-container animated fadeInModal">
							<!-- User Info Mobile -->
							<div class="text-center mb-3">
								<div class="-text-username">Username: {{user.tel}}</div>
								<div class="-text-username" v-if="user.firstname || user.lastname" style="margin-top: 8px; font-size: 16px; color: #fff; font-weight: 600;">
									Name: {{user.firstname}} {{user.lastname}}
								</div>
								<button type="button" class="-link-change-password btn-primary" @click="showChangePasswordFormMobile = !showChangePasswordFormMobile" style="color:#fff; padding: 8px 16px;">{{ $t('header.change_password') }}</button>
							</div>

							<div class="-change-password-container" v-if="showChangePasswordFormMobile">
								<div class="js-collapse-content">
									<div class="form-group mt-3">
										<input type="password" v-model="password" required="required" :placeholder="$t('current_password_placeholder')" class="x-form-control form-control">
									</div>
									<div class="form-group">
										<input type="password" v-model="password1" required="required" :placeholder="$t('new_password_placeholder')" class="x-form-control form-control">
									</div>
									<div class="form-group">
										<input type="password" v-model="password2" required="required" :placeholder="$t('confirm_new_password_placeholder')" class="x-form-control form-control">
									</div>
									<button type="button" @click="changePassword()" style="background: linear-gradient(130deg, #6bd9ff 11%, #3498ff 88%);" class="btn btn-block btn-primary">
										<span>{{ $t('confirm') }}</span>
									</button>
								</div>
							</div>

							<!-- Add New Account Form Mobile -->
							<div class="-add-account-container" v-if="showAddAccountFormMobile">
								<div class="x-title-modal -v2 mx-auto text-center" style="font-size: 16px; margin-bottom: 15px;">
									{{ $t('header.add_new_account') }}
								</div>
								<div class="form-group">
									<select v-model="newAccountMobile.bank" class="x-form-control form-control mb-3" @change="onBankChangeMobile()">
										<option value="">{{ $t('select_bank') }}</option>
										<option value="truewallet">Truewallet</option>
										<option value="bankokbank">BBL - ธนาคารกรุงเทพ</option>
										<option value="kbank">KBANK - ธนาคารกสิกรไทย</option>
										<option value="scb">SCB - ธนาคารไทยพาณิชย์</option>
										<option value="tisco">TISCO - ธนาคารทิสโก้</option>
										<option value="ttb">TTB - ทหารไทยธนชาต</option>
										<option value="ktb">KTB - ธนาคารกรุงไทย</option>
										<option value="krungsri">BAY - ธนาคารกรุงศรีอยุธยา</option>
										<option value="kiatnakin">KKP - ธนาคารเกียรตินาคิน</option>
										<option value="gsb">GSB - ธนาคารออมสิน</option>
										<option value="lh">LHBANK - ธนาคารแลนด์ แอนด์ เฮ้าส์</option>
										<option value="uob">UOB - ธนาคารยูโอบี</option>
										<option value="ธนาคารอิสลาม">IBANK - ธนาคารอิสลามแห่งประเทศไทย</option>
										<option value="ghbank">GHB - ธนาคารอาคารสงเคราะห์</option>
										<option value="cimb">CIMB - ธนาคารซีไอเอ็มบีไทย</option>
										<option value="baac">BAAC - ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (ธกส)</option>
										<option value="icbc">ICBC - ธนาคารไอซีบีซี (ไทย)</option>
										<option value="standard">STANDARD - ธนาคารสแตนดาร์ดชาร์เตอร์ดไทย</option>
									</select>
									<input type="text" v-model="newAccountMobile.account_no" class="x-form-control form-control mb-3" :placeholder="newAccountMobile.bank === 'truewallet' ? $t('phone_number') : $t('account_number')" @keypress="isNumber($event)" @input="onAccountNumberInput($event, 'mobile')" @paste="onAccountNumberPaste($event, 'mobile')" inputmode="numeric" maxlength="12">
									<div class="text-center">
										<button type="button" @click="addNewAccountMobile()" class="btn btn-block btn-outline-light py-2" style="border: 2px solid rgb(255, 255, 255); color: rgb(255, 255, 255); font-weight: 500; background-color: #4CAF50;">
											<span>{{ $t('header.add_account') }}</span>
										</button>
										<button type="button" @click="cancelAddAccountMobile()" class="btn btn-block btn-outline-light py-2" style="border: 2px solid #fff; color: #fff; font-weight: 500;">
											<span>{{ $t('cancel') }}</span>
										</button>
									</div>
								</div>
							</div>

							<!-- Add New Account Button Mobile -->
							<!-- <div class="text-center mb-3" v-if="!showAddAccountFormMobile">
								<button type="button" @click="showAddAccountFormMobile = true" class="btn btn-block btn-primary -submit">
									<i class="fas fa-plus"></i> {{ $t('header.add_new_account') }}
								</button>
							</div> -->

							<!-- Approved Accounts Mobile -->
							<div class="-approved-accounts" v-if="getApprovedAccounts().length > 0">
								<div class="x-title-modal -v2 mx-auto text-center" style="font-size: 16px; margin-bottom: 15px; color: #4CAF50;">
									<i class="fas fa-check-circle"></i> {{ $t('header.approved_accounts') }}
								</div>
								<div class="x-customer-bank-info-container -v2 approved-border" v-for="(account, index) in getApprovedAccounts()" :key="'approved-mobile-' + index" style="margin-bottom: 10px;">
									<div class="media m-auto">
										<img v-if="account.bank" :src="getBankImage(account.bank)" class="-img rounded-circle" width="50" height="50" :alt="getBankName(account.bank)">
										<div class="-content-wrapper">
											<span class="-name">{{account.firstname}} {{account.lastname}}</span>
											<span class="-number">{{account.account_no}}</span>
											<span class="-bank-name">{{getBankName(account.bank)}}</span>
											<span class="-status approved">{{ $t('approved_status') }}</span>
										</div>
									</div>
								</div>
								<div class="text-center mb-3" v-if="!showAddAccountFormMobile">
									<button type="button" @click="showAddAccountFormMobile = true" class="btn btn-block btn-outline-light py-2" style="border: 2px solid rgb(255, 255, 255); color: rgb(255, 255, 255); font-weight: 500; background-color: #4CAF50;">
										<i class="fas fa-plus"></i> {{ $t('header.add_new_account') }}
									</button>
								</div>
							</div>

							<!-- Pending Accounts Mobile -->
							<div class="-pending-accounts" v-if="getPendingAccounts().length > 0">
								<div class="x-title-modal -v2 mx-auto text-center" style="font-size: 16px; margin-bottom: 15px; color: #FF5722;">
									<i class="fas fa-clock"></i> {{ $t('header.pending_accounts') }}
								</div>
								<div class="x-customer-bank-info-container -v2 pending-border" v-for="(account, index) in getPendingAccounts()" :key="'pending-mobile-' + index" style="margin-bottom: 10px;">
									<div class="media m-auto">
										<img v-if="account.bank" :src="getBankImage(account.bank)" class="-img rounded-circle" width="50" height="50" :alt="getBankName(account.bank)">
										<div class="-content-wrapper">
											<span class="-name">{{account.firstname}} {{account.lastname}}</span>
											<span class="-number">{{account.account_no}}</span>
											<span class="-bank-name">{{getBankName(account.bank)}}</span>
											<span class="-status pending">{{ $t('pending_approval_status') }}</span>
										</div>
									</div>
								</div>
							</div>

							<!-- No Accounts Message Mobile -->
							<div class="text-center" v-if="!user.accounts || user.accounts.length === 0">
								<p style="color: #fff; font-family: 'Kanit', sans-serif;">{{ $t('header.no_bank_account') }}</p>
							</div>

							<div class="x-admin-contact text-center mt-3">
								<span class="x-text-with-link-component">
								<label class="-text-message ">{{ $t('header.contact_support') }}</label>
								<a :href="adminContactLineLink" class="-link-message " target="_blank" rel="noopener">
									<u>{{ $t('header.contact_customer_service') }}</u>
								</a>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		</div>

		<div
			class="x-modal modal -v2 -with-half-size"
			id="withdrawModal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
			data-loading-container=".modal-body"
			data-container="#withdrawModal"
     	 >
<div class="modal-dialog -modal-size " role="document">
  <div class="modal-content -modal-content">
    <button
      type="button"
      class="close f-1 "
      data-dismiss="modal"
      aria-label="Close"
    >
      <i class="fas fa-times"></i>
    </button>
    <div class="modal-header -modal-header">
      <h3 class="x-title-modal -v2 m-auto">
{{ $t('withdraw') }}
      </h3>
    </div>
    <div
      class="modal-body -modal-body"
      :style="withdrawModalBodyStyle"
    >
      <div class="x-withdraw-form -v2">
  <div
    data-animatable="fadeInModal"
    class="-animatable-container animated fadeInModal"
  >
    <div class="text-center d-flex flex-column">
      <div
class="-x-input-icon x-input-operator mb-3 flex-column"
      >
<button
  type="button"
  class="-icon-left -btn-icon js-adjust-amount-by-operator"
  @click="setWithdraw('minus')"
>
  <i class="fas fa-minus-circle"></i>
</button>
<input
  type="text"
  v-model="withdraw"
  :class="{'x-form-control':true,'text-center':true, 'js-withdraw-input-amount':true ,'-no':true,'form-control':true,'is-invalid':(error)?true:false}"
  :placeholder="$t('withdraw_amount')"
  @keypress="isNumber($event)"

/>
						<div class="invalid-feedback " v-if="error">
							<ul class="list-unstyled mb-0"><li>{{error}}</li></ul>
						</div>
<button
  type="button"
  class="-icon-right -btn-icon js-adjust-amount-by-operator"
  @click="setWithdraw('plus')"
>
  <i class="fas fa-plus-circle"></i>
</button>
      </div>
					<!-- <div  v-if="lastbonus.canwithdraw || lastbonus.turncredit">
					<p class="glow" style="font-size:14px;">
						{{lastbonus.canwithdraw}}/{{lastbonus.turncredit}}
					</p>
					</div> -->
      <div
class="x-select-amount js-quick-amount -v2"
data-target-input="#withdraw_amount"
      >
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(200)"
  >
    <span class="-no">200</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(300)"
  >
    <span class="-no">300</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(500)"
  >
    <span class="-no">500</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(1000)"
  >
    <span class="-no">1000</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(2000)"
  >
    <span class="-no">2000</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(5000)"
  >
    <span class="-no">5000</span>
  </button>
</div>
      </div>
    </div>
	<div><p class="-title" style="font-family: 'Kanit', sans-serif; font-size: 12px; padding-bottom:10px;color:#fff">{{ $t('withdraw_min_max', { min: condition.minimum || 200, max: condition.maximum || 150000 }) }}</p></div>
	<div><p class="-title" style="font-family: 'Kanit', sans-serif; font-size: 12px; padding-bottom:10px;color:#fff">{{ $t('withdraw_daily_limit', { max: condition.maximumperday || 450000, qtyperday: condition.qtyperday || 3 }) }}</p></div>
	<div><p class="-title" style="font-family: 'Kanit', sans-serif; font-size: 12px; padding-bottom:10px;color:#fff" v-html="$t('withdraw_bank_close', { detail: condition.detail || $t('withdraw_bank_close_default') })"></p></div>
	<div class="mt-3 -spacer">
		<!-- Bank Selection for multiple accounts -->
		<div class="mb-3" v-if="getApprovedAccounts().length > 1">
			<label class="form-label" style="color: #fff; font-family: 'Kanit', sans-serif; font-size: 14px; margin-bottom: 10px;">{{ $t('select_withdraw_account') }}</label>
			<select v-model="selectedWithdrawAccount" class="x-form-control form-control mb-3" @change="onWithdrawAccountChange()">
				<option value="">{{ $t('select_account_to_receive') }}</option>
				<option 
					v-for="(account, index) in getApprovedAccounts()" 
					:key="'withdraw-account-' + index"
					:value="account"
				>
					{{getBankName(account.bank)}} - {{account.firstname}} {{account.lastname}} ({{account.account_no}})
				</option>
			</select>
		</div>

		<div class="x-deposit-bank-info-container -v2">
		<div class="media m-auto" v-if="getApprovedAccounts().length > 0">
			<img
			v-if="getSelectedWithdrawAccount().bank" :src="getBankImage(getSelectedWithdrawAccount().bank)"
			class="-img rounded-circle"
			width="50"
			height="50"
			alt="bank-bay"
			/>
			<div class="-content-wrapper">
			<span class="-own-name"
				>{{getSelectedWithdrawAccount().firstname}} {{getSelectedWithdrawAccount().lastname}}</span
			>
			<span id="depositBankNumber" class="-number"
				>{{getSelectedWithdrawAccount().account_no}}</span
			>
			</div>
			<div class="-copy-wrapper">
			<a
				href="javascript:void(0);"
				style="cursor: default;"
				class="btn -btn js-copy-to-clipboard"
				>{{ $t('to_this_account') }}</a
			>
			</div>
		</div>
		<div class="text-center" v-else>
			<p style="color: #fff; font-family: 'Kanit', sans-serif; font-size: 14px;">
				{{ $t('add_bank_before_withdraw') }}
			</p>
		</div>
		</div>
	</div>
    <div class="text-center">
      <button
type="button"
class="btn -submit btn-primary my-0 my-lg-3 f-5 f-lg-6"
						@click="withdrawConfirm()"
      >
{{ $t('confirm') }}
      </button>
    </div>
  </div>

  <input
    type="hidden"
    id="withdraw__token"
    name="withdraw[_token]"
    value="bllExR5-OWRJU6oF0VySYE94ynEFuTfZGWIxep2iqUo"
  />
      </div>
    </div>
  </div>
</div>
      	</div>

		<div
			class="x-modal modal -v2 -with-backdrop -with-separator -with-half-size"
			id="depositModal"
			ref="depositModal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
			data-loading-container=".modal-body"
			data-container="#depositModal"
      >
<div
	class="modal-dialog -modal-size"
	:class="{ 's3pay-modal-dialog--active': !!activeUnifiedDepositView }"
	role="document"
>
  <div
	class="modal-content -modal-content"
	:class="{ 's3pay-modal-content--active': !!activeUnifiedDepositView }"
  >
      <button
		v-if="!activeUnifiedDepositView"
		type="button"
		class="close f-1 "
		data-dismiss="modal"
		:disabled="!!(activeUnifiedDepositView && (activeUnifiedDepositView.cancelling || activeUnifiedDepositView.uploading))"
		aria-label="Close"
      >
<i class="fas fa-times"></i>
      </button>
      <div
		ref="depositModalBody"
		class="modal-body -modal-body"
		:class="{
			's3pay-modal-body--active': !!activeUnifiedDepositView,
			'deposit-form-modal-body--scrollable': !activeUnifiedDepositView
		}"
		:style="{ 'top': '0px', 'min-height': showBankSelectionForDeposit ? 'auto' : '400px', 'height': showBankSelectionForDeposit ? 'auto' : 'auto' }"
	  >
<UnifiedDepositPaymentPanel
  v-if="activeUnifiedDepositView"
  :customer-account="unifiedDepositCustomerAccount"
  :receiver-account="activeUnifiedDepositView.receiverAccount"
  :qr-image="activeUnifiedDepositView.qrImage"
  :qr-payload="activeUnifiedDepositView.qrPayload"
  :payment-url="activeUnifiedDepositView.paymentUrl"
  :amount="activeUnifiedDepositView.amount"
  :amount-pending="activeUnifiedDepositView.amountPending || false"
  :remaining-text="activeUnifiedDepositView.remainingText"
  :expires-at="activeUnifiedDepositView.expiresAt"
  :fallback-countdown-seconds="activeUnifiedDepositView.fallbackCountdownSeconds"
  :checking="activeUnifiedDepositView.checking"
  :cancelling="activeUnifiedDepositView.cancelling"
  :uploading="activeUnifiedDepositView.uploading"
  :show-cancel="activeUnifiedDepositView.showCancel"
  :show-upload="activeUnifiedDepositView.showUpload"
  @cancel="cancelUnifiedDepositView"
  @upload="uploadUnifiedDepositSlip"
/>
<div class="x-pending -v2" v-else>
  <div
    class="js-content text-center -animated-wrapper animated fadeInModal"
    data-animatable="fadeInModal"
  >
    <div class="-fake-bg-bottom-wrapper">
      <div class="x-modal-separator-container ">
		<!-- Step 1: Bank Selection for Customer (when multiple approved accounts) -->
		<div class="mt-3 -spacer" v-if="showBankSelectionForDeposit && !depositAmount" style="padding: 20px 15px;">
			<div class="text-center mb-3">
				<label class="form-label" style="color: #fff; font-family: 'Kanit', sans-serif; font-size: 16px; margin-bottom: 15px;">
					{{ $t('please_select_bank_for_deposit') }}
				</label>
			</div>
			<div class="mb-3">
				<select v-model="selectedDepositAccount" class="x-form-control form-control mb-3" @change="onDepositBankSelected()" :disabled="isBankLoading" style="padding: 12px 15px; font-size: 15px; font-family: 'Kanit', sans-serif;">
					<option value="">{{ isBankLoading ? $t('loading_status') : $t('select_your_bank') }}</option>
					<option 
						v-for="(account, index) in getApprovedAccounts()" 
						:key="'deposit-account-' + index"
						:value="account"
					>
						{{getBankName(account.bank)}} - {{account.firstname}} {{account.lastname}} ({{account.account_no}})
					</option>
				</select>
				
				<!-- Slip Upload Button for Step 1 -->
				<div class="mb-3">
					<input type="file" ref="fileInputStep1" accept="image/*" @change="uploadSlip" style="display: none;">
					<button 
						type="button" 
						@click="openBrowseFileStep1()" 
						class="btn btn-block w-100"
						style="background: linear-gradient(135deg, #ff8c42 0%, #f48d1f 100%); border: none; font-family: 'Kanit', sans-serif; font-size: 16px; padding: 14px; border-radius: 10px; color: white; font-weight: 500; box-shadow: 0 2px 10px rgba(244, 141, 31, 0.3);"
					>
						<i class="fas fa-cloud-upload-alt mr-2"></i>
						<span style="font-size:14px;">{{ $t('deposit_slip') }}</span>
					</button>
				</div>
				
				<div class="text-center" v-if="isBankLoading">
					<div style="color: #fff; font-family: 'Kanit', sans-serif; font-size: 14px; margin: 10px 0;">
						<i class="fas fa-spinner fa-spin"></i> {{ $t('loading_bank_data') }}
					</div>
				</div>
				<div class="text-center mt-3" v-else>
					<button type="button" @click="cancelBankSelection()" class="btn btn-outline-light px-4 py-2" style="border: 2px solid #fff; color: #fff; font-weight: 500; font-family: 'Kanit', sans-serif; font-size: 14px;">
						<span>{{ $t('skip_for_now') }} ({{ $t('use_first_account') }})</span>
					</button>
				</div>
			</div>
		</div>

		<!-- Step 2: Amount Input -->
		<div class="mt-3 -spacer" v-if="!showBankSelectionForDeposit && !depositAmount && !corepaypage" style="padding: 15px;">
			
			<!-- Promotion Selection for Amount Input Page -->
			<div class="mb-3" v-if="promotions && promotions.name">
				<div class="text-center mb-2">
					<label class="form-label deposit-promotion-hint" style="color: #fff; font-family: 'Kanit', sans-serif; font-size: 14px; margin-bottom: 10px; display: block;">
						{{ $t('deposit_promotion') }}
					</label>
				</div>
				<div class="d-flex align-items-center justify-content-between mb-3" :style="{background: gotpro ? '#64fc7ecc' : '#f74040cc', borderRadius: '10px', padding: '15px'}">
					<div class="d-flex align-items-center">
						<img src="../assets/images/ic-gift.png" class="mr-3" :alt="promotions.name" width="32" height="32" style="filter: brightness(1.2);">
						<div>
							<div class="font-weight-bold" style="color: white; font-family: 'Kanit', sans-serif; font-size: 16px; line-height: 1.2;">
								{{promotions.name}}
							</div>
							<div class="mt-1" style="color: rgba(255,255,255,0.9); font-family: 'Kanit', sans-serif; font-size: 13px;">
								{{gotpro ? $t('select_receive_promotion') : $t('no_promotion')}}
								<span @click="showPromotionTerms" class="ml-2" style="color: #ffeb3b; cursor: pointer; text-decoration: underline; font-size: 15px;">{{ $t('terms') }}</span>
							</div>
						</div>
					</div>
					<div class="ml-3">
						<label class="rocker rocker-small" style="transform: scale(0.9);">
							<input type="checkbox" v-model="gotpro">
							<span class="switch-left" style="background: #4CAF50; color: white; font-family: 'Kanit', sans-serif; font-size: 12px;">{{ $t('receive') }}</span>
							<span class="switch-right" style="background: #f44336; color: white; font-family: 'Kanit', sans-serif; font-size: 12px;">{{ $t('not_receive') }}</span>
						</label>
					</div>
				</div>
			</div>
			<!-- Promotion Terms Info Box -->
			<div class="promotion-terms-info" style="background: linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 152, 0, 0.1) 100%); border: 1px solid rgba(255, 193, 7, 0.3); border-radius: 10px; padding: 15px; margin: 15px 0; font-family: 'Kanit', sans-serif;">
				<div style="display: flex; align-items: center; margin-bottom: 10px;">
					<i class="fas fa-info-circle" style="color: #ffc107; font-size: 16px; margin-right: 8px;"></i>
					<span style="color: #ffc107; font-weight: 600; font-size: 14px;">{{ $t('promotion_terms_info') }}</span>
				</div>
				<ul style="margin: 0; padding-left: 20px; list-style: none; color: rgba(255, 255, 255, 0.9); font-size: 13px; line-height: 1.6;">
					<li style="margin-bottom: 6px;">
						<span style="color: #4CAF50;">✓</span> {{ $t('promotion_term_1') }}
					</li>
					<li class="promotion-term-single-line" style="margin-bottom: 6px;">
						<span style="color: #FF5722;">⚠</span> {{ $t('promotion_term_2') }}
					</li>
					<li style="margin-bottom: 0;">
						<span style="color: #f44336;">⛔</span> {{ $t('promotion_term_3') }}
					</li>
				</ul>
			</div>
			<div class="text-center mb-3">
				<label class="form-label" style="color: #fff; font-family: 'Kanit', sans-serif; font-size: 18px; margin-bottom: 20px; display: block;">
					{{ $t('specify_deposit_amount') }}
				</label>
			</div>
			<!-- Quick Amount Buttons -->
			<!-- <div class="row mb-3" style="margin: 0 -5px;">
				<div class="col-4 px-1 mb-2">
					<button 
						type="button" 
						@click="setDepositAmount(200)" 
						class="btn btn-block w-100"
						style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; font-family: 'Kanit', sans-serif; font-size: 15px; padding: 14px 8px; border-radius: 10px; border: none; min-height: 50px; font-weight: 500; white-space: nowrap; overflow: hidden;"
					>200</button>
				</div>
				<div class="col-4 px-1 mb-2">
					<button 
						type="button" 
						@click="setDepositAmount(300)" 
						class="btn btn-block w-100"
						style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; font-family: 'Kanit', sans-serif; font-size: 15px; padding: 14px 8px; border-radius: 10px; border: none; min-height: 50px; font-weight: 500; white-space: nowrap; overflow: hidden;"
					>300</button>
				</div>
				<div class="col-4 px-1 mb-2">
					<button 
						type="button" 
						@click="setDepositAmount(500)" 
						class="btn btn-block w-100"
						style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; font-family: 'Kanit', sans-serif; font-size: 15px; padding: 14px 8px; border-radius: 10px; border: none; min-height: 50px; font-weight: 500; white-space: nowrap; overflow: hidden;"
					>500</button>
				</div>
				<div class="col-4 px-1 mb-2">
					<button 
						type="button" 
						@click="setDepositAmount(1000)" 
						class="btn btn-block w-100"
						style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; font-family: 'Kanit', sans-serif; font-size: 15px; padding: 14px 8px; border-radius: 10px; border: none; min-height: 50px; font-weight: 500; white-space: nowrap; overflow: hidden;"
					>1000</button>
				</div>
				<div class="col-4 px-1 mb-2">
					<button 
						type="button" 
						@click="setDepositAmount(2000)" 
						class="btn btn-block w-100"
						style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; font-family: 'Kanit', sans-serif; font-size: 15px; padding: 14px 8px; border-radius: 10px; border: none; min-height: 50px; font-weight: 500; white-space: nowrap; overflow: hidden;"
					>2000</button>
				</div>
				<div class="col-4 px-1 mb-2">
					<button 
						type="button" 
						@click="setDepositAmount(5000)" 
						class="btn btn-block w-100"
						style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; font-family: 'Kanit', sans-serif; font-size: 15px; padding: 14px 8px; border-radius: 10px; border: none; min-height: 50px; font-weight: 500; white-space: nowrap; overflow: hidden;"
					>5000</button>
				</div>
			</div> -->
			
			<!-- Custom Amount Input -->
			<div class="mb-3">
				<!-- <label style="color: rgba(255,255,255,0.7); font-family: 'Kanit', sans-serif; font-size: 14px; margin-bottom: 8px; display: block;">
					{{ $t('deposit_amount') }}
				</label> -->
				<div class="input-group">
					<input 
						type="number" 
						v-model="inputDepositAmount" 
						class="form-control" 
						:placeholder="$t('amount_baht_placeholder')" 
						min="1"
						style="padding: 12px 15px; font-size: 18px; font-family: 'Kanit', sans-serif; text-align: center; background: rgba(255,255,255,0.1); color: #fff; border: 1px solid rgba(255,255,255,0.3); border-radius: 10px 0 0 10px;"
					/>
					<span class="input-group-text" style="background: rgba(255,255,255,0.1); color: #fff; border: 1px solid rgba(255,255,255,0.3); border-radius: 0 10px 10px 0; font-family: 'Kanit', sans-serif;">{{ $t('baht_unit') }}</span>
				</div>
			</div>
			
			<small class="s3pay-deposit-range" v-if="paymentOnlyDepositRangeText">
				ระบบรองรับยอดฝาก {{ paymentOnlyDepositRangeText }} บาท ต่อรายการเท่านั้น
			</small>

			<!-- Action Buttons -->
			<div class="row mt-4" style="margin: 0 -5px;">
				<div class="col-6 px-1">
					<button 
						type="button" 
						@click="submitDepositAmount()" 
						class="btn btn-block w-100" 
						:disabled="!inputDepositAmount || inputDepositAmount <= 0 || isBankLoading"
						style="background: linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%); border: none; font-weight: 500; font-family: 'Kanit', sans-serif; font-size: 16px; padding: 14px; border-radius: 10px; min-height: 52px;"
					>
						<span v-if="!isBankLoading">{{ $t('confirm_amount') }}</span>
						<span v-else><i class="fas fa-spinner fa-spin"></i> {{ $t('processing_status') }}</span>
					</button>
				</div>
				<div class="col-6 px-1">
					<button 
						type="button" 
						data-dismiss="modal"
						class="btn btn-block w-100" 
						style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); border: none; font-weight: 500; font-family: 'Kanit', sans-serif; font-size: 16px; padding: 14px; border-radius: 10px; min-height: 52px; color: white;"
					>
						{{ $t('close_window') }}
					</button>
				</div>
			</div>
			
			<!-- Upload Slip Button for Step 2 -->
			<div class="mt-4 mb-3">
				<input type="file" ref="fileInputStep2" accept="image/*" @change="uploadSlip" style="display: none;">
				<button 
					type="button" 
					@click="openBrowseFileStep2()" 
					class="btn btn-block w-100"
					style="background: linear-gradient(135deg, #ff8c42 0%, #f48d1f 100%); border: none; font-family: 'Kanit', sans-serif; font-size: 16px; padding: 14px; border-radius: 10px; color: white; font-weight: 500; box-shadow: 0 2px 10px rgba(244, 141, 31, 0.3);"
				>
					<i class="fas fa-cloud-upload-alt mr-2"></i>
					<span style="font-size:14px;">{{ $t('deposit_slip') }}</span>
				</button>
			</div>
		</div>

		<!-- PayBridge recipient -->
		<div class="mt-3 -spacer" v-if="paybridgeMatch && !corepaypage" style="padding: 20px 15px;">
			<div class="paybridge-panel">
				<div class="paybridge-panel-header">
					<span class="paybridge-badge"><span class="paybridge-mark"></span>PayBridge</span>
					<h3>{{ paybridgeAcknowledged ? 'บัญชีโอนเงินของรายการนี้' : 'อ่านก่อนรับบัญชีโอนเงิน' }}</h3>
					<p>{{ paybridgeAcknowledged ? 'โอนยอดตามนี้ แล้วแนบสลิปเพื่อให้ระบบตรวจอัตโนมัติ' : 'ทำตาม 4 ข้อนี้เพื่อให้เครดิตเข้าถูกต้อง' }}</p>
					<div class="paybridge-route">
						<span>{{ paybridgeAcknowledged ? 'Matched' : 'Lock' }}</span>
						<span>{{ paybridgeAcknowledged ? 'Held' : 'Match' }}</span>
						<span>{{ paybridgeAcknowledged ? 'Ready' : 'Verify' }}</span>
					</div>
				</div>
				<div class="paybridge-customer-warning">
					<div class="paybridge-customer-warning-head"><span>สำคัญมาก ก่อนโอนเงิน</span></div>
					<div class="paybridge-customer-warning-grid">
						<div class="paybridge-customer-warning-item"><b>1</b><span><strong>ห้ามฝากซ้ำบัญชีเดิม</strong><small>บัญชีนี้ใช้ได้ครั้งเดียวสำหรับรายการนี้</small></span></div>
						<div class="paybridge-customer-warning-item"><b>2</b><span><strong>ฝากภายในเวลา</strong><small>หมดเวลาแล้วห้ามโอนเด็ดขาด</small></span></div>
						<div class="paybridge-customer-warning-item"><b>3</b><span><strong>ฝากตรงกับยอด</strong><small>ห้ามโอนขาดหรือเกิน</small></span></div>
						<div class="paybridge-customer-warning-item"><b>4</b><span><strong>ผิดเงื่อนไขไม่รับผิดชอบ</strong><small>ตรวจบัญชี ยอด และเวลาก่อนโอน</small></span></div>
					</div>
					<div class="paybridge-customer-warning-footer">หลังโอนแล้วให้อัปโหลดสลิปทันทีเพื่อยืนยันรายการ</div>
				</div>
				<div class="paybridge-agreement-card" v-if="!paybridgeAcknowledged">
					<div class="paybridge-agreement-list">
						<div class="paybridge-agreement-item -one">
							<strong>1</strong>
							<span><b>บัญชีใช้ได้ครั้งเดียว</b><small>ห้ามบันทึกหรือโอนซ้ำ</small></span>
						</div>
						<div class="paybridge-agreement-item -two">
							<strong>2</strong>
							<span><b>โอนยอดให้ตรง</b><small>ห้ามโอนขาดหรือเกิน</small></span>
						</div>
						<div class="paybridge-agreement-item -three">
							<strong>3</strong>
							<span><b>ต้องอัปโหลดสลิป</b><small>ไม่แนบสลิป เครดิตไม่เข้า</small></span>
						</div>
					</div>
					<div class="paybridge-agreement-final">
						หากโอนผิดยอด ใช้บัญชีซ้ำ หรือไม่แนบสลิป ระบบไม่สามารถรับผิดชอบได้
					</div>
					<button type="button" class="paybridge-ack-button" @click="acknowledgePayBridgeTerms()">
						<i class="fas fa-check-circle"></i>
						รับทราบและแสดงบัญชีโอนเงิน
					</button>
					<button type="button" class="paybridge-cancel-button" data-dismiss="modal">
						ปิดหน้าต่าง
					</button>
				</div>
				<template v-else>
					<div class="paybridge-amount-card">
						<div>
							<span>ยอดที่ต้องโอน</span>
							<strong>
								{{ Number(depositAmount || 0).toLocaleString('th-TH') }} บาท
								<button
									type="button"
									class="paybridge-icon-copy"
									v-clipboard:copy="String(Number(depositAmount || 0))"
									v-clipboard:success="clipboardSuccessHandler"
									aria-label="คัดลอกยอดโอน"
								>
									<i class="fas fa-copy"></i>
								</button>
							</strong>
						</div>
						<div class="paybridge-timer">
							<span>เวลาคงเหลือ</span>
							<strong>{{ paybridgeTaskRemainingText || '0:00' }}</strong>
						</div>
					</div>
					<div class="paybridge-account-card">
						<div class="paybridge-bank-mark">
							<img :src="getBankImage((paybridgeMatch.recipientAccount || {}).bankCode)" alt="paybridge bank">
						</div>
						<div class="paybridge-account-detail">
							<span class="paybridge-bank-name">{{ (paybridgeMatch.recipientAccount || {}).bankName || (paybridgeMatch.recipientAccount || {}).bankCode || 'ธนาคาร' }}</span>
							<strong class="paybridge-account-name">{{ (paybridgeMatch.recipientAccount || {}).accountName }}</strong>
							<div class="paybridge-account-number">
								{{ (paybridgeMatch.recipientAccount || {}).accountNo }}
								<button
									type="button"
									class="paybridge-icon-copy"
									v-clipboard:copy="((paybridgeMatch.recipientAccount || {}).accountNo || '').toString().replace(/-/g,'')"
									v-clipboard:success="clipboardSuccessHandler"
									aria-label="คัดลอกเลขบัญชี"
								>
									<i class="fas fa-copy"></i>
								</button>
							</div>
						</div>
					</div>
					<div class="paybridge-critical-warning">
						<div class="paybridge-warning-icon">
							<i class="fas fa-exclamation-triangle"></i>
						</div>
						<div class="paybridge-warning-copy">
							<span>บัญชีนี้ใช้ได้เฉพาะรายการนี้เท่านั้น หากโอนไปบัญชีเดิมซ้ำ ทางเว็บจะไม่รับผิดชอบใดๆ</span>
						</div>
					</div>
					<input class="paybridge-file-input" type="file" ref="fileInputPayBridge" accept="image/*" @change="uploadPayBridgeSlip">
					<button type="button" @click="openBrowsePayBridgeFile()" class="paybridge-upload-button">
						<i class="fas fa-cloud-upload-alt mr-2"></i>
						<span>อัปโหลดสลิป PayBridge</span>
					</button>
					<button type="button" data-dismiss="modal" class="paybridge-cancel-button -after-account">
						ปิดหน้าต่าง
					</button>
				</template>
			</div>
		</div>

		<!-- Step 3: Show Bank Details with Decimal -->
		<div class="mt-3 -spacer" v-if="depositAmount && assignedBank && !corepaypage && !paybridgeMatch" style="padding: 20px 15px;">
			<div class="text-center mb-3">
				<!-- Selected Customer Account Info -->
				<div style="margin-top: 0px; background: #fff; border: 1px solid #4CAF50; border-radius: 8px; padding: 12px; margin-bottom: 10px;">
					<div style="color: #000;padding-bottom: 5px;">{{ $t('deposit_from_this_account_only') }}</div>
					<div style="display: flex; align-items: center; justify-content: space-between; font-family: 'Kanit', sans-serif;">
						<div style="display: flex; align-items: center;">
							<img
								v-if="(currentDepositAccount || getApprovedAccounts()[0] || {}).bank"
								:src="getBankImage((currentDepositAccount || getApprovedAccounts()[0] || {}).bank)"
								style="width: 24px; height: 24px; border-radius: 50%; margin-right: 8px;"
								:alt="(currentDepositAccount || getApprovedAccounts()[0] || {}).bank"
							/>
							<div>
								<div style="color: #4CAF50; font-size: 14px; font-weight: 600; margin-bottom: 2px;">
									{{ getBankName((currentDepositAccount || getApprovedAccounts()[0] || {}).bank) }}
								</div>
								<div style="color: #333; font-size: 11px;">
									{{ (currentDepositAccount || getApprovedAccounts()[0] || {}).firstname }} {{ (currentDepositAccount || getApprovedAccounts()[0] || {}).lastname }}
								</div>
							</div>
						</div>
						<div style="text-align: right;">
							<div style="color: #333; font-size: 14px; font-weight: 600; font-family: monospace;">
								{{ (currentDepositAccount || getApprovedAccounts()[0] || {}).account_no }}
							</div>
						</div>
					</div>
				</div>
				<div style="background: rgba(76, 175, 80, 0.2); border: 2px solid #4CAF50; border-radius: 10px; padding: 15px; margin-bottom: 15px;">
					<h5 style="color: #4CAF50; font-family: 'Kanit', sans-serif; margin-bottom: 10px;">
						{{ $t('amount_to_transfer') }}
					</h5>
					<h3 style="color: #fff; font-family: 'Kanit', sans-serif; font-size: 32px; margin: 0;">
						฿ {{ depositAmountWithDecimal }}
					</h3>
					<p style="color: #ffc107; font-family: 'Kanit', sans-serif; font-size: 14px; margin-top: 10px; margin-bottom: 5px;">
						<i class="fas fa-clock"></i> กรุณาทำรายการก่อน {{ deadlineTime }}
					</p>
					<div v-if="depositTimer" style="color: #fff; font-size: 18px; font-weight: bold;">
						{{ $t('time_remaining') }}: {{ formatTime(depositTimer) }}
					</div>
				</div>
				
				<div class="x-deposit-bank-info-container -v2">
					<div class="media m-auto" v-if="assignedBank.bank_name">
						<img
							:src="getBankImage(assignedBank.bank_name)"
							class="-img rounded-circle"
							width="50"
							height="50"
							:alt="assignedBank.bank_name"
						/>
						<div class="-content-wrapper">
							<span class="-name">{{getBankName(assignedBank.bank_name)}}</span>
							<span class="-own-name">{{assignedBank.firstname}} {{assignedBank.lastname}}</span>
							<span class="-number">{{assignedBank.account_no}}</span>
						</div>
						<div class="-copy-wrapper">
							<a
								href="javascript:void(0);"
								class="btn -btn js-copy-to-clipboard"
								v-clipboard:copy="assignedBank.account_no ? assignedBank.account_no.replace(/-/g,'') : ''"
								v-clipboard:success="clipboardSuccessHandler"
							>{{ $t('copy_button') }}</a>
						</div>
					</div>
					<!--div-- class="media m-auto" v-if="assignedBank.bank_name === 'truewallet'">
						<img
							:src="getBankImage(assignedBank.bank_name)"
							class="-img rounded-circle"
							width="50"
							height="50"
							:alt="assignedBank.bank_name"
						/>
						<div class="-content-wrapper">
							<span class="-name">{{getBankName(assignedBank.bank_name)}}</span>
							<span class="-own-name">{{assignedBank.firstname}} {{assignedBank.lastname}}</span>
							<span class="-number">{{assignedBank.mobile}}</span>
						</div>
						<div class="-copy-wrapper">
							<a
								href="javascript:void(0);"
								class="btn -btn js-copy-to-clipboard"
								v-clipboard:copy="assignedBank.mobile ? assignedBank.mobile.replace(/-/g,'') : ''"
								v-clipboard:success="clipboardSuccessHandler"
							>{{ $t('copy_button') }}</a>
						</div>
					</!--div-->
				</div>
				
				<div style="margin-top: 10px;background: rgba(76, 175, 80, 0.2); border: 2px solid #f44336; border-radius: 10px; padding: 15px; margin-bottom: 15px;" v-html="$t('auto_credit_adjustment_warning')"></div>
				<!-- Upload Slip Button for Step 3 -->
				<div class="mt-4 mb-3">
					<input type="file" ref="fileInputStep3" accept="image/*" @change="uploadSlip" style="display: none;">
					<button 
						type="button" 
						@click="openBrowseFileStep3()" 
						class="btn btn-block w-100"
						style="background: linear-gradient(135deg, #ff8c42 0%, #f48d1f 100%); border: none; font-family: 'Kanit', sans-serif; font-size: 16px; padding: 14px; border-radius: 10px; color: white; font-weight: 500; box-shadow: 0 2px 10px rgba(244, 141, 31, 0.3);"
					>
						<i class="fas fa-cloud-upload-alt mr-2"></i>
						<span style="font-size:14px;">{{ $t('deposit_slip') }}</span>
					</button>
				</div>
				
				<div class="text-center mt-4">
					<button
						type="button"
						class="btn btn-block w-100"
						:disabled="isCancellingBankDeposit"
						style="margin-bottom: 10px; background: #fee2e2; border: none; font-family: 'Kanit', sans-serif; font-size: 16px; padding: 12px; border-radius: 10px; color: #b91c1c; font-weight: 600;"
						@click="confirmCancelBankDeposit()"
					>
						<i :class="isCancellingBankDeposit ? 'fas fa-spinner fa-spin mr-2' : 'fas fa-times-circle mr-2'"></i>
						<span>{{ isCancellingBankDeposit ? 'กำลังยกเลิกรายการ' : 'ยกเลิกรายการเดิมและสร้างรายการใหม่' }}</span>
					</button>
					<button 
						type="button" 
						data-dismiss="modal"
						class="btn btn-block w-100" 
						style="background: #e2e8f0; border: none; font-family: 'Kanit', sans-serif; font-size: 16px; padding: 12px; border-radius: 10px; color: #334155; font-weight: 600;"
					>
						<i class="fas fa-times mr-2"></i>
						<span>{{ $t('close_window') }}</span>
					</button>
				</div>
			</div>
		</div>

		<!-- Old deposit system - hidden for new flow -->
		<div class="-top " v-if="false">
	<div class="mt-3 -spacer" v-if="papaya && user.bank !== 'truewallet'">
		<div class="x-deposit-bank-info-container -v2">
		<div class="media m-auto" @click="showCorepayPage()">
			<img
			src="https://play-lh.googleusercontent.com/UIdkgBTFEFYTbE-_hUnekG5Aq16au9J7C6RI5gnoAeEZV2zMC3XgOnjL-0aYdmyWk6k=w240-h480-rw"
			class="-img rounded-circle"
			width="50"
			height="50"
			alt="bank-bay"
			/>
			<div class="-content-wrapper">
				<span class="-name" style="font-size: large;">{{ $t('deposit_promptpay') }}</span>
			</div>
			<div class="-copy-wrapper">
			<a
				href="javascript:void(0);"
				class="btn -btn js-copy-to-clipboard"
				style="padding: 10px;"
				>Click</a
			>
			</div>
		</div>
		</div>
	</div>
	<!-- Bank Loading Skeleton -->
	<div class="mt-3 -spacer" v-if="isBankLoading && !bank.bank_name">
		<div class="x-deposit-bank-info-container -v2">
			<div class="media m-auto">
				<div style="width: 50px; height: 50px; background: linear-gradient(90deg, #f0f0f0 25%, rgba(255,255,255,.5) 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite;" class="rounded-circle"></div>
				<div class="-content-wrapper">
					<div style="height: 18px; background: linear-gradient(90deg, #f0f0f0 25%, rgba(255,255,255,.5) 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; border-radius: 4px; margin-bottom: 8px; width: 120px;"></div>
					<div style="height: 16px; background: linear-gradient(90deg, #f0f0f0 25%, rgba(255,255,255,.5) 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; border-radius: 4px; margin-bottom: 8px; width: 160px;"></div>
					<div style="height: 16px; background: linear-gradient(90deg, #f0f0f0 25%, rgba(255,255,255,.5) 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; border-radius: 4px; width: 140px;"></div>
				</div>
				<div class="-copy-wrapper">
					<div style="width: 60px; height: 32px; background: linear-gradient(90deg, #f0f0f0 25%, rgba(255,255,255,.5) 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; border-radius: 4px;"></div>
				</div>
			</div>
		</div>
	</div>

	<!-- Debug Info (สำหรับ development) -->
	<div v-if="false" style="color: white; background: rgba(0,0,0,0.8); padding: 10px; margin: 10px 0; font-size: 12px;">
		Debug: hideBankSection={{ hideBankSection }}, isBankLoading={{ isBankLoading }}, 
		bank.bank_name={{ bank.bank_name }}, banks={{ bank }}
	</div>

	<!-- No Bank Available Message -->
	<div class="mt-3 -spacer" v-if="hideBankSection && !isBankLoading">
		<div class="x-deposit-bank-info-container -v2">
			<div class="text-center" style="padding: 20px;">
				<div style="color: #ff6b6b; font-size: 48px; margin-bottom: 15px;">
					<i class="fas fa-clock"></i>
				</div>
				<h5 style="color: #fff; font-family: 'Kanit', sans-serif; margin-bottom: 10px;">
					{{ $t('no_deposit_channel_available') }}
				</h5>
				<p style="color: #ccc; font-family: 'Kanit', sans-serif; font-size: 14px; margin-bottom: 15px;">
					{{ $t('bank_closed_now') }}
				</p>
				<div style="background: rgba(255,255,255,0.1); border-radius: 8px; padding: 15px; margin-bottom: 15px;">
					<p style="color: #4CAF50; font-family: 'Kanit', sans-serif; font-size: 13px; margin-bottom: 8px;">
						<i class="fas fa-info-circle"></i> {{ $t('service_hours') }}
					</p>
					<p style="color: #fff; font-family: 'Kanit', sans-serif; font-size: 12px; margin: 0;">
						• SCB: 01:00 - 23:50<br>
						• KBANK: 00:00 - 23:50<br>
						• {{ $t('truewallet_24hrs') }}
					</p>
				</div>
				<div class="text-center">
					<button type="button" @click="retryBankLoad()" 
					        class="btn btn-outline-light px-3 py-2 mr-2" 
					        style="border: 2px solid #fff; color: #fff; font-weight: 500;">
						<i class="fas fa-sync-alt"></i> {{ $t('try_again') }}
					</button>
					<a :href="adminContactLineLink" target="_blank" 
					   class="btn btn-outline-light px-3 py-2" 
					   style="border: 2px solid #4CAF50; color: #4CAF50; font-weight: 500; text-decoration: none;">
						<i class="fab fa-line"></i> {{ $t('contact_admin') }}
					</a>
				</div>
			</div>
		</div>
	</div>

	<!-- Bank Data -->
	<div class="mt-3 -spacer" v-if="bank && bank.bank_name && bank.bank_name !== 'truewallet' && !isBankLoading && !hideBankSection">
    <div class="x-deposit-bank-info-container -v2">
      <div class="media m-auto">
		<img
		:src="getBankImage(bank.bank_name)"
		class="-img rounded-circle"
		width="50"
		height="50"
		alt="bank-bay"
		/>
		<div class="-content-wrapper">
		<span class="-name">{{getBankName(bank.bank_name)}}</span>
		<span class="-own-name"
			>{{bank.firstname}} {{bank.lastname}}</span
		>
		<span id="depositBankNumber" class="-number"
			>{{bank.account_no}}</span
		>
		</div>
		<div class="-copy-wrapper">
		<a
			href="javascript:void(0);"
			class="btn -btn js-copy-to-clipboard"
			v-clipboard:copy="bank.account_no ? bank.account_no.replace(/-/g,'') : ''"
											v-clipboard:success="clipboardSuccessHandler"
			>{{ $t('copy_button') }}</a>
		
		</div>
      </div>
    </div>
  </div>
  <!-- <div class="mt-3 -spacer" v-if="bank && bank.scb && bank.scb.accountno && user && (config.scb || config.scb2 || config.scb3)">
    <div class="x-deposit-bank-info-container -v2">
      <div class="media m-auto">
		<img
		src="../assets/images/bank/scb.jpg"
		class="-img rounded-circle"
		width="50"
		height="50"
		alt="bank-bay"
		/>
		<div class="-content-wrapper">
		<span class="-name">ธนาคารไทยพาณิชย์</span>
		<span class="-own-name"
			>{{bank.scb.firstname}} {{bank.scb.lastname}}</span
		>
		<span id="depositBankNumber" class="-number"
			>{{bank.scb.accountno}}</span
		>
		</div>
		<div class="-copy-wrapper">
		<a
			href="javascript:void(0);"
			class="btn -btn js-copy-to-clipboard"
			v-clipboard:copy="bank.scb.accountno.replace(/-/g,'')"
											v-clipboard:success="clipboardSuccessHandler"
			>{{ $t('copy_button') }}</a>
		
		</div>
      </div>
    </div>
  </div> -->

  <!-- <div class="mt-3 -spacer" v-if="bank.kbank && bank.kbank.accountno && user && (user.bank !== 'kbank' || config_kbank) && config.kbank">
				<div class="x-deposit-bank-info-container -v2">
				<div class="media m-auto">
					<img
					src="../assets/images/bank/kbank.jpg"
					class="-img rounded-circle"
					width="50"
					height="50"
					alt="bank-bay"
					/>
					<div class="-content-wrapper">
					<span class="-name">ธนาคารกสิกร</span>
					<span class="-own-name"
						>{{bank.kbank.firstname}} {{bank.kbank.lastname}}</span
					>
					<span id="depositBankNumber" class="-number"
						>{{bank.kbank.accountno}}</span
					>
					</div>
					<div class="-copy-wrapper">
					<a
						href="javascript:void(0);"
						class="btn -btn js-copy-to-clipboard"
						v-clipboard:copy="bank.kbank.accountno.toString().replace(/-/g,'')"
														v-clipboard:success="clipboardSuccessHandler"
						>{{ $t('copy_button') }}</a>
					
					</div>
				</div>
				</div>
			</div>	 -->
  
						  <div class="mt-3 -spacer" v-if="bank && bank.bank_name == 'truewallet' && !hideBankSection">
    <div class="x-deposit-bank-info-container -v2">
      <div class="media m-auto">
<img
  src="../assets/images/bank/tmw.png"
  class="-img rounded-circle"
  width="50"
  height="50"
  alt="bank-bay"
/>
<div class="-content-wrapper">
  <span class="-name">ทรูมันนี่ วอลเล็ท</span>
  <span class="-own-name"
    >{{bank.firstname}}  {{bank.lastname}}</span
  >
  <span id="depositBankNumber2" class="-number"
    >{{bank.account_no}}</span
  >
</div>
<div class="-copy-wrapper">
  <a
    href="javascript:void(0);"
	v-clipboard:copy="bank.account_no ? bank.account_no.replace(/-/g,'') : ''"
	v-clipboard:success="clipboardSuccessHandler"
    class="btn -btn js-copy-to-clipboard"
    >{{ $t('copy_button') }}</a>
  
</div>
      </div>
    </div>
  </div>
							<!-- <div class="-spacer">
								<div class="x-danger-zone -v2 ">
								<span
									>{{ $t('deposit_account') }}</span
								>
								</div>
							</div> -->
						  	<div class="-spacer">
								<hr class="-liner">
							</div>
							

							<div class="x-deposit-promotion-outer-container js-scroll-ltr -fade -on-left -on-right" v-if="promotions && promotions.name">
								<div><p class="-title" style="font-family: 'Kanit', sans-serif; font-size: 12px; padding-bottom:10px;color:#fff">{{ $t('deposit_promotion') }}</p></div>
								<div class="x-deposit-promotion -v2 -slide pt-0" data-scroll-booster-container=".x-deposit-promotion-outer-container" data-scroll-booster-content=".x-deposit-promotion" style="transform: translate(0px, 0px);">
									<div :class="{'-promotion-box-wrapper':true,'-active':this.gotpro}">
										<button type="button" :class="{'btn -promotion-box-apply-btn js-promotion-apply':true,'-active':this.gotpro}">
											<img src="../assets/images/ic-gift.png" class="-img" :alt="promotions.name" width="26" height="26">
											<span class="-title" style="font-size: 12px;">{{promotions.name}}</span>
										</button>
										<div class="mid">
										 <label class="rocker rocker-small" style="box-sizing: inherit;margin:0;padding:0;">
											<input type="checkbox" v-model="this.gotpro">
											<span class="switch-left">{{ $t('receive') }}</span>
											<span class="switch-right">{{ $t('not_receive') }}</span>
										</label>
										</div>
										<!-- <a href="javascript:void(0)" :class="{'-promotion-box-cancel-btn js-cancel-promotion':true,'-show':this.gotpro}">
											<i class="fas fa-times"></i>
										</a> -->
									</div>

									<div class="-promotion-box-wrapper -active" style="font-family: Kanit, sans-serif;min-width: 65%;background: transparent;align-items: flex-start;justify-content: flex-start;" v-if="promotions.detail">
										<span style="font-size:16px">{{ $t('details') }}</span>
										<span style="font-size:13px;text-align: left;" v-html="nl2br(promotions.detail)"></span>
									</div>

									<!-- <div class="-promotion-box-wrapper -active">
										<button type="button" class="btn -promotion-box-apply-btn js-promotion-apply -active" data-url="/promotion/27/apply" data-type="deposit" data-display-slide-mode="true">
											<img src="../assets/images/ic-gift.png" class="-img" :alt="$t('bonus_2_percent_deposit')" width="26" height="26">
											<span class="-title" style="font-size: 12px;">{{ $t('bonus_2_percent_deposit') }}</span>
										</button>
										<a href="javascript:void(0)" class="-promotion-box-cancel-btn js-cancel-promotion -show" data-url="/promotion-active/cancel" data-display-slide-mode="true">
											<i class="fas fa-times"></i>
										</a>
									</div> -->
    							</div>
 							</div>
							<div><p class="-description" style="font-family: 'Kanit', sans-serif;">{{ $t('no_bonus_description') }}</p></div>
							<div class="-spacer" style="cursor:pointer" @click="openBrowseFileOld()">
								<input type="file" ref="fileInputOld" accept="image/*" @change="uploadSlip">
								<div class="x-danger-zone -v2" style="background:#f48d1f;color:#fff;">
								<span style="font-size:13px;">{{ $t('deposit_slip') }}</span>
								</div>
							</div>

</div>
<div class="-top" v-else-if="corepayimage">
	<iframe :src="corepayimage" width="100%" style="height:90vh;"></iframe>
</div>
<div class="-top" v-else-if="corepaymessage">
	{{corepaymessage}}
</div>
<div class="-top" style="padding-bottom: 30px;" v-else-if="corepaypage">
  <div class="x-deposit-bank-info-container -v2" style="background-color: transparent;">
		<div class="media m-auto">
        <div
          data-animatable="fadeInModal"
          class="-animatable-container animated fadeInModal" style="width:80%"
        >
          <div class="text-center d-flex flex-column" style="bottom: 30px;">
          <div
            class="-x-input-icon x-input-operator mb-3 flex-column"
          >
        <button
        type="button"
        class="-icon-left -btn-icon js-adjust-amount-by-operator"
        @click="setWithdraw2('minus')"
        >
        <i class="fas fa-minus-circle"></i>
        </button>
        <input
        type="text"
        v-model="deposit_value"
        :class="{'x-form-control':true,'text-center':true, 'js-withdraw-input-amount':true ,'-no':true,'form-control':true,'is-invalid':(error)?true:false}"
        :placeholder="$t('deposit_amount')"
        @keypress="isNumber($event)"

        />
                    <div class="invalid-feedback " v-if="error">
                      <ul class="list-unstyled mb-0"><li>{{error}}</li></ul>
                    </div>
        <button
        type="button"
        class="-icon-right -btn-icon js-adjust-amount-by-operator"
        @click="setWithdraw2('plus')"
        >
        <i class="fas fa-plus-circle"></i>
        </button>
          </div>
          <div
        class="x-select-amount js-quick-amount -v2"
        data-target-input="#withdraw_amount"
          >
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(300)"
        >
          <span class="-no">300</span>
        </button>
        </div>
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(500)"
        >
          <span class="-no">500</span>
        </button>
        </div>
		<div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(800)"
        >
          <span class="-no">800</span>
        </button>
        </div>
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(1000)"
        >
          <span class="-no">1000</span>
        </button>
        </div>
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(2000)"
        >
          <span class="-no">2000</span>
        </button>
        </div>
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(5000)"
        >
          <span class="-no">5000</span>
        </button>
        </div>
          </div>
          </div>
        </div>
		</div>
	</div>
	<div>
                  <p class="glow" style="font-size:14px;">
                    {{ $t('deposit_instruction') }}
                  </p>
                  </div>
</div>
<div class="-bottom ">
	<!-- Hidden old buttons for new deposit system -->
	<div class="my-3 -spacer" v-if="false">
		<button
		type="button"
		class="btn -submit btn-primary text-center m-auto js-user-confirm-deposit"
		data-dismiss="modal"
		aria-label="Close"
		>
		{{ $t('close_window') }}
		</button>
  	</div>
	<div class="my-3 -spacer" v-if="false">
		<button
		type="button"
		class="btn -submit btn-primary text-center m-auto js-user-confirm-deposit"
		@click="genQrCodeCorePay()"
		>
		{{ $t('confirm_deposit') }}
		</button>
	</div>
</div>
    </div>
  </div>
</div>
      </div>
    </div>
  </div>
</div>
      	</div>
<!--Anoucement-->
<div id="open-modal" class="modal-window">
  <div>
    <a href="#" id="an-close" title="Close" style="display:none" class="modal-close">Close</a>
    <h1>{{announcement_user.title}}</h1>
    <div v-html="nl2br(announcement_user.detail)" style="font-size:15px;font-family: 'Kanit', sans-serif;"></div>
	<font size="2" style="font-family: 'Kanit', sans-serif;">{{showDateTime(announcement_user.createdate)}}</font>
    <div style=" display: flex; justify-content: space-between;padding-top:20px;">
		<button style="border: 2px solid #C320D6;background-color: #000;color:#fff; border-radius: 50px;font-family: 'Kanit', sans-serif;" @click="closeAnnouncement(1)">{{ $t('acknowledged') }}</button>
		<button style="border: 2px solid #C320D6;background-color: #000;color:#fff; border-radius: 50px;font-family: 'Kanit', sans-serif;" @click="closeAnnouncement(2)">{{ $t('skip_for_now') }}</button>
	</div>
  </div>
</div>
<!-- Promotion -->
		  <div data-loading-container=".modal-body" data-container=".promotion-detail-modal-27" data-ajax-modal-always-reload="true" tabindex="-1" class="modal x-modal -promotion-detail-modal promotion-detail-modal-27 show" aria-modal="true" :style="`display: ${(promotion && promotion.name)?`block`:'none'}; padding-right: 8px;`"><div class="modal-dialog -modal-size  " role="document" style="padding-top: 152.8px;">
    <div class="modal-content -modal-content" :style="{ 'background-image': `url(${require('../assets/images/Shiba-BG.jpg')})`}">
                    <button type="button" class="close f-1 " data-dismiss="modal" aria-label="Close" @click="closePromotion()">
                <i class="fas fa-times"></i>
            </button>
                                <div class="modal-body -modal-body" style="top: 0px;">
                            
        <div class="container">
            <div class="row">
                <div class="col-12 mt-4">
                    <div class="x-page-title-component ">
    <div class="-inner-wrapper">
        <h1 class="-title">{{ $t('menu_promotion') }}</h1>
            </div>
</div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-column">
                            <div class="-real-content">
                    
    <div class="x-card card -card-promotion-detail ">
                                            
            <div class="card-body">
                <div class="-img-container">
                    <img :src="promotion.image" :alt="promotion.name" class="-img-promotion img-fluid">
                </div>


                <div class="x-promotion-content"><h2>{{promotion.name}}</h2>

<p><br>
<div v-html="nl2br(promotion.detail)" style="font-size:15px;font-family: 'Kanit', sans-serif;">
</div>
<br>
<!-- <a href="/term-and-condition">{{ $t('promotion_terms') }}</a> -->
</p></div>
            </div>

                            <div class="card-footer">
                    <!-- <button class="btn -btn -get-promotion-btn js-promotion-apply " data-toggle="modal" data-target="#depositModal" data-promotion-target="promotion-detail-modal-27" data-type="deposit" data-dismiss="modal" data-url="/promotion/27/apply">
                        <span>{{ $t('get_promotion') }}</span>
                    </button> -->
                </div>
                        </div>
                </div>
            
                                                        
                                    <div class="mx-3 mb-3">
                        <div class="x-admin-contact -no-fixed">
                            <span class="x-text-with-link-component" style="font-size:15px;font-family: 'Kanit', sans-serif;">
     <label class="-text-message ">{{ $t('header.contact_support') }}&nbsp;</label>&nbsp;
     <a :href="adminContactLineLink" class="-link-message " target="_blank" rel="noopener">
        <u>{{ $t('header.contact_customer_service') }}</u>
    </a>
</span>
                        </div>
                    </div>
                                    </div>
            </div>
    </div>
</div></div>
<a class="btn" href="#open-modal" id="a-modal" style="display: none;">👋 Basic CSS-Only Modal</a>
	</header>
</template>
<script>
import queryString from 'querystring'
import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/firestore'
import 'firebase/storage'
import router from './../router'
import moment from 'moment'
import settingsMixin from '@/mixins/settingsMixin'
import dypayDepositMixin from '@/mixins/dypayDepositMixin'
import paykumoDepositMixin from '@/mixins/paykumoDepositMixin'
import s3payDepositMixin from '@/mixins/s3payDepositMixin'
import copayDepositMixin from '@/mixins/copayDepositMixin'
import kisspayDepositMixin from '@/mixins/kisspayDepositMixin'
import UnifiedDepositPaymentPanel from '@/components/payment/UnifiedDepositPaymentPanel.vue'
import { assertLegacyDepositReceiverBank, isLegacyDepositReceiverBank, isPaymentProviderBank } from '@/utils/depositReceiverGuard'
import {
	buildLockedDepositCandidates,
	clearDepositChannelLock,
	saveDepositChannelLock
} from '@/utils/depositChannelSelection'
import { isPaymentBankBlocked, normalizePaymentBankCode } from '@/utils/paymentBankAvailability'
import { ensureLatestBuild } from '@/utils/buildVersionGuard'
import { getPendingWithdrawalStatus, getWithdrawConditionOnce } from '@/utils/withdrawConditionCache'
import { getBankPublicOptionsOnce } from '@/utils/bankPublicOptions'
const audio = new Audio(require('../assets/money.mp3'))
const audio2 = new Audio(require('../assets/moneyout.mp3'))
const audio3 = new Audio(require('../assets/coin.mp3'))
const axios = require('axios').default
const qs = require('qs')
const PAYBRIDGE_FRONTEND_ENABLED = true
const CLOUD_FUNCTIONS_API_KEY = 'LosnQ8W6uWoVs8N-ik_'
export default {
  name: "Header",
  components: { UnifiedDepositPaymentPanel },
  mixins: [settingsMixin, dypayDepositMixin, paykumoDepositMixin, s3payDepositMixin, copayDepositMixin, kisspayDepositMixin],
	  mounted () {
	this.$root.$on('request-deposit', this.handleDepositClick)
	if (typeof window !== 'undefined') {
		this.handleViewportChange()
		window.addEventListener('resize', this.handleViewportChange)
		this.paybridgeTaskTimer = window.setInterval(() => {
			this.paybridgeNow = Date.now()
			this.expirePayBridgeTaskIfNeeded()
		}, 1000)
	}
   	const user = localStorage.getItem('userData');
	if(user){
		  const _user = JSON.parse(user);
		  this.restorePayBridgeTask();
		  if(!_user.lastlogin || _user.lastlogin !== moment().tz('Asia/Bangkok').format('YYYY-MM-DD')){
			  _user.lastlogin = moment().tz('Asia/Bangkok').format('YYYY-MM-DD')
			  localStorage.setItem('userData', JSON.stringify(_user))
			  this.addLogin(_user)
		  }
		  			$('#depositModal').on('hidden.bs.modal',  (e)=> {
			if (this.hasActiveDepositInProgress()) {
				this.corepaypage = false;
				this.corepayimage = '';
				return;
			}
			this.corepaypage = false;
			this.corepayimage = '';
			// Reset all deposit states
			this.showBankSelectionForDeposit = false;
			this.selectedDepositAccount = null;
			this.inputDepositAmount = null;
			this.depositAmount = null;
			this.depositAmountWithDecimal = null;
			this.assignedBank = null;
			this.depositDecimal = null;
			this.depositTransactionId = null;
			if(!this.hasActivePayBridgeTask){
				this.clearPayBridgeTask();
			}
			
			// Clear timer if exists
			if (this.depositTimerInterval) {
				clearInterval(this.depositTimerInterval);
				this.depositTimerInterval = null;
			}
			this.depositTimer = null;
			
			if(this.unsubscribe){
				this.unsubscribe()
			}
			});

			// Add event listener for when modal is shown to reset state properly on mobile
			$('#depositModal').on('show.bs.modal', async (e) => {
				this.restoreDepositCustomerAccount();
				if (this.hasActiveDepositInProgress()) {
					this.corepaypage = false;
					this.corepayimage = '';
					return;
				}
				// Reset all deposit states when modal is shown
				this.showBankSelectionForDeposit = false;
				this.selectedDepositAccount = null;
				this.corepaypage = false;
				this.corepayimage = '';
				this.inputDepositAmount = null;
				this.depositAmount = null;
				this.depositAmountWithDecimal = null;
				this.assignedBank = null;
				this.depositDecimal = null;
				this.paybridgeMatch = null;
				this.paybridgeLocalDepositId = '';
				this.paybridgeMessage = '';
				this.paybridgeAcknowledged = false;
				const restoredSecurePay = await this.restoreSecurePayDepositFromCache();
				if (restoredSecurePay) return;

				const restoredCopay = await this.restoreCopayDeposit();
				if (restoredCopay) return;

				const restoredDyPay = await this.restoreDyPayDeposit();
				if (restoredDyPay) return;

				const restoredPaykumo = await this.restorePaykumoDeposit();
				if (restoredPaykumo) return;

				const restoredS3Pay = await this.restoreS3PayDeposit();
				if (restoredS3Pay) return;

				const restoredKissPay = await this.restoreKissPayDeposit();
				if (restoredKissPay) return;
				
				// Clear timer if exists
				if (this.depositTimerInterval) {
					clearInterval(this.depositTimerInterval);
					this.depositTimerInterval = null;
				}
				this.depositTimer = null;
				
				// Check if user has multiple approved accounts
				const approvedAccounts = this.getApprovedAccounts();
				if (approvedAccounts.length > 1) {
					this.showBankSelectionForDeposit = true;
				}

				this.resetDepositFormScrollPosition();
			});

			$('#depositModal').on('shown.bs.modal', () => {
				this.resetDepositFormScrollPosition();
			});
			
			// Reset mobile tabs when modal is closed
			$('#accountModalMobile').on('hidden.bs.modal', (e) => {
				this.resetMobileTabs();
			});
			
			  this.getAnnouncementUser(_user.key);
	  } else {
		firebase.auth().signOut()
		localStorage.removeItem('userData')
		router.replace('/login')
	  }
	  },
  beforeDestroy () {
	this.$root.$off('request-deposit', this.handleDepositClick)
	this.stopSecurePayTransactionListener()
	if (typeof window !== 'undefined') {
		window.removeEventListener('resize', this.handleViewportChange)
	}
	if (this.paybridgeTaskTimer) {
		clearInterval(this.paybridgeTaskTimer)
		this.paybridgeTaskTimer = null
	}
  },
  async created(){
	  //$("#depositChoosePromotionModal").modal('show')
	const user = localStorage.getItem('userData');
	if(user){
		const _user = JSON.parse(user);
		this.$store.dispatch('user/setUser',_user).catch(err => { console.error(err) });
	}else{
		firebase.auth().signOut()
		localStorage.removeItem('userData')
		router.replace('/login')
	}
	const { code } = queryString.parse(window.location.search.replace('?', ''))
	if (!code) return
	const result = await this.getToken(code)
	if (result && result.access_token) {
		const { data } = await this.getProfile(result.access_token)
		this.checkLineLogin(data)
	}
	
	
  },
  data() {
    return {
		condition:{
			detail:'',
			maximum:0,
			minimum:0,
			maximumperday:0,
			disableDeposit: false,
			disableWithdraw: false,
		},
		isDropdownOpen: false,
		languages: [
			{ code: 'th', name: 'ไทย' },
			{ code: 'en', name: 'English' },
			{ code: 'my', name: 'မြန်မာ' },
		],
		viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
		viewportHeight: typeof window !== 'undefined' ? window.innerHeight : 0,
      disabled: false,
      deposit_value:'',
      corepaymessage:'',
      corepayimage:'',
      corepaypage:false,
      papaya: false,
      config_kbank:false,
      config:{
        scb:false,
        scb2:false,
        scb3:false,
        kbank:false,
        truewallet:false,
        withdraw:false,
      },
      announcement_user:{
        close:false,
        createdate:'',
        detail:'',
        title:'',
      },
      password:'',
      password1:'',
      password2:'',
      fa_spin:false,
      accountOpen:false,
      withdraw: '',
      error: '',
      copyfield:'',
      canwithdraw: 'ยืนยัน',
      clientId: '1656935750',
      callbackUri: 'https://funbeyond.cc',
      clientSecret: '4b4c6d35256b0034244f1a0056ddb640',
      bank:{
        scb:{
          firstname:'',
          lastname:'',
          accountno:'',
        },
        kbank:{
          firstname:'',
          lastname:'',
          accountno:'',
        },
        truewallet:{
          firstname:'',
          lastname:'',
          mobile:'',
        }
      },
      // New properties for multiple accounts management
      accountActiveTab: 'profile',
      mobileActiveTab: 'profile',
      showAddAccountForm: false,
      showAddAccountFormMobile: false,
      showChangePasswordForm: false,
      showChangePasswordFormMobile: false,
      newAccount: {
        bank: '',
        account_no: '',
        firstname: '',
        lastname: '',
      },
      newAccountMobile: {
        bank: '',
        account_no: '',
        firstname: '',
        lastname: '',
      },
      // Add selected withdraw account for withdrawal modal
      selectedWithdrawAccount: null,
      // Add selected deposit account for deposit modal
      selectedDepositAccount: null,
      showBankSelectionForDeposit: false,
      // Current deposit account for transaction storage
      currentDepositAccount: null,
      // Add loading state (removed cache for real-time data)
      isBankLoading: false,
      isCancellingBankDeposit: false,
      // New deposit system properties
      inputDepositAmount: null,
      depositAmount: null,
      depositAmountWithDecimal: null,
      assignedBank: null,
      depositTimer: null,
      depositTimerInterval: null,
      depositDeadline: null,
      depositDecimal: null,
      depositTransactionId: null,
      paybridge: false,
      paybridgeChecking: false,
      paybridgeMatch: null,
      paybridgeLocalDepositId: '',
      paybridgeMessage: '',
      paybridgeAcknowledged: false,
      paybridgeNow: Date.now(),
      paybridgeTaskTimer: null,
		paybridgeExpiredNotified: false,
		securePayConfig: null,
		securePayTransaction: null,
		securePayPageUrl: '',
		securePayRefId: '',
		securePayPaymentLinkId: '',
		securePayTransactionUnsubscribe: null,
		securePayCompletionHandled: false,
		isSlipUploading: false,
      hideBankSection: false,
      bankNames: {
        'truewallet': 'Truewallet',
        'bankokbank': 'BBL - ธนาคารกรุงเทพ',
        'kbank': 'KBANK - ธนาคารกสิกรไทย',
        'scb': 'SCB - ธนาคารไทยพาณิชย์',
        'tisco': 'TISCO - ธนาคารทิสโก้',
        'ttb': 'TTB - ทหารไทยธนชาต',
        'ktb': 'KTB - ธนาคารกรุงไทย',
        'krungsri': 'BAY - ธนาคารกรุงศรีอยุธยา',
        'kiatnakin': 'KKP - ธนาคารเกียรตินาคิน',
        'gsb': 'GSB - ธนาคารออมสิน',
        'lh': 'LHBANK - ธนาคารแลนด์ แอนด์ เฮ้าส์',
        'uob': 'UOB - ธนาคารยูโอบี',
        'ธนาคารอิสลาม': 'IBANK - ธนาคารอิสลามแห่งประเทศไทย',
        'ghbank': 'GHB - ธนาคารอาคารสงเคราะห์',
        'cimb': 'CIMB - ธนาคารซีไอเอ็มบีไทย',
        'baac': 'BAAC - ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (ธกส)',
        'icbc': 'ICBC - ธนาคารไอซีบีซี (ไทย)',
		'standard': 'STANDARD - ธนาคารสแตนดาร์ดชาร์เตอร์ดไทย',
		'securepay': 'SecurePay'
      }
    }
  },
  watch: {
	'user.language': {
		immediate: true,
		handler(newLang) {
		if (newLang) {
			this.$i18n.locale = newLang;
		} else {
			this.$i18n.locale = 'th'; // default to Thai
		}
		}
	},
	coin_voice(newVoice,oldVoice) {
		if(newVoice){
			audio3.volume = 0.5;
			audio3.play();
			this.$store.commit("user/SET_COIN_VOICE", false) 
		}
	},
    // whenever question changes, this function will run
    creditincrese(newQuestion, oldQuestion) {
		if(newQuestion){
			audio.volume = 0.5;
			audio.play();
			this.$store.commit("user/SET_CREDIT_INCREASE", false) 
		}
    },
	creditdecrese(newQuestion, oldQuestion) {
		if(newQuestion){
			audio2.volume = 0.5;
			audio2.play();
			this.$store.commit("user/SET_CREDIT_DECREASE", false) 
		}
    },
	
	alertwithdraw(newalert, oldwithdraw) {
		if(newalert){
			if(!this.lastbonus.withdrawBlocked){
				// ตรวจสอบจำนวนบัญชีที่อนุมัติแล้ว
				const approvedAccounts = this.getApprovedAccounts();
				const promoSummary = this.getPromoWithdrawSummary();
				
				// ปิด withdraw modal ก่อน
				$("#withdrawModal").modal('hide')
				
				if(approvedAccounts.length > 1) {
					// มีหลายบัญชี - แสดง dropdown เลือกบัญชี
					this.showWithdrawConfirmWithAccountSelection();
				} else if(approvedAccounts.length === 1) {
					this.$swal({
						icon: 'question',
						title: this.$t('withdraw'),
						html: this.buildPromoWithdrawSummaryHTML(),
						showCancelButton: true,
						confirmButtonText: this.$t('confirm')
					}).then((result) => {
						if(result.isConfirmed){
							// ตั้งค่าบัญชีที่จะใช้ (บัญชีเดียว)
							this.selectedWithdrawAccount = approvedAccounts[0];
							this.withdraw = promoSummary.withdrawAmount;
							this.withdrawConfirm();
						}
					});
				} else {
					// ไม่มีบัญชีที่อนุมัติ
					this.$swal({ 
						icon: 'error', 
						title: this.$t('withdraw'), 
						text: 'กรุณาเพิ่มบัญชีธนาคารและรอการอนุมัติก่อนทำการถอนเงิน' 
					});
				}
			}else if(Number(this.user.credit)>5){
				$("#withdrawModal").modal('hide')
				this.$swal({ icon: 'error', title: this.$t('withdraw'), text: `คุณต้องทำยอด ${this.lastbonus.turncredit} ค่ะ`}).then((result) => {
				});
			}
			this.$store.commit("user/SET_ALERT_WITHDRAWALL", false) 
		}
	},
	// Watch for user data changes
	'user.key': {
		immediate: true,
		handler(newKey) {
			if (newKey && !this.condition.maximum) {
				// Only call if condition data hasn't been loaded yet
				this.callGetWithdrawCondition();
			}
		}
	}
  },
  computed: {
	user(){
		return this.$store.state.user.user;
    },
	creditincrese(){
		return this.$store.state.user.creditincrese;
	},
	creditdecrese(){
		return this.$store.state.user.creditdecrese;
	},
	lastbonus () {
      return this.$store.state.user.lastbonus;
    },
	alertwithdraw (){
		return this.$store.state.user.alertwithdraw;
	},
	promotions (){
		return this.$store.state.user.promotions;
	},
	gotpro: {
		get() {
			return this.$store.state.user.gotpro;
		},
		set(value) {
			if(this.user && this.user.key){
				this.$store.commit("user/SET_GOT_PRO", value);
				firebase.database().ref(`users/${this.user.key}`).update({bonus: value ? 'Y' : 'N'});
			}
		}
	},
	promotion(){
		return this.$store.state.user.promotion;
	},
	coin_voice(){
		return this.$store.state.user.coin_voice;
	},
	loading () {
      return this.$store.state.user.loading
    },
	paymentOnlyDepositRangeText() {
		if (!this.condition || !this.condition.disableDeposit) return '';
		const account = this.currentDepositAccount || this.selectedDepositAccount || this.getApprovedAccounts()[0] || null;
		return this.formatConfiguredPaymentDepositRange(
			this.getAvailableConfiguredPaymentChannels(account)
		);
	},
	unifiedDepositCustomerAccount() {
		const transactionAccount =
			(this.securePayTransaction && this.securePayTransaction.account) ||
			(this.copayTransaction && this.copayTransaction.account) ||
			(this.paykumoTransaction && this.paykumoTransaction.account) ||
			(this.s3PayTransaction && this.s3PayTransaction.account) ||
			(this.kisspayTransaction && this.kisspayTransaction.account) ||
			(this.dypayTransaction && this.dypayTransaction.account) ||
			null;
		const account = this.currentDepositAccount || transactionAccount || this.selectedDepositAccount || this.getApprovedAccounts()[0] || {};
		const bank = account.bank || account.bank_name || '';
		const bankName = bank ? this.getBankName(bank) : '';
		const rawBankCode = String(bank || '').trim();
		const bankNamePrefix = String(bankName || '').split(/\s*[-–]\s*/)[0].trim();
		const bankCode = /^[A-Za-z0-9]+$/.test(rawBankCode)
			? rawBankCode.toUpperCase()
			: (/^[A-Za-z0-9]+$/.test(bankNamePrefix) ? bankNamePrefix.toUpperCase() : '');
		const accountName = String(account.account_name || account.accountName || '').trim();
		const accountOwnerName = [account.firstname, account.lastname].filter(Boolean).join(' ').trim();
		const customerName = [this.user && this.user.firstname, this.user && this.user.lastname].filter(Boolean).join(' ').trim();
		return {
			bankName,
			bankCode,
			bankImage: bank ? this.getBankImage(bank) : '',
			accountName: accountName && accountName !== '-' ? accountName : (accountOwnerName || customerName),
			accountNo: account.account_no || account.accountNo || account.account || ''
		};
	},
	activeUnifiedDepositView() {
		const base = {
			kind: '', receiverAccount: {}, qrImage: '', qrPayload: '', paymentUrl: '',
			amount: this.depositAmountWithDecimal || this.depositAmount || '', remainingText: '',
			expiresAt: null, fallbackCountdownSeconds: 0, checking: false,
			cancelling: false, uploading: false, showCancel: true, showUpload: false
		};

		if (this.hasActiveCopayDeposit) {
			const paymentInfo = (this.copayTransaction && this.copayTransaction.payment_info) || {};
			return {
				...base, kind: 'copay', qrImage: paymentInfo.promptpay_qr || '',
				receiverAccount: paymentInfo.account_no ? this.normalizeUnifiedReceiverAccount({
					bank: paymentInfo.bank_code || paymentInfo.bank_name,
					accountNo: paymentInfo.account_no,
					accountName: paymentInfo.account_name
				}) : {},
				amount: paymentInfo.amount || base.amount,
				expiresAt: this.resolveCopayPaymentExpiresAt(paymentInfo),
				fallbackCountdownSeconds: 10 * 60,
				checking: this.copayStatusChecking,
				cancelling: this.copayCancelling
			};
		}

		if (this.hasActiveKissPayDeposit) {
			const transaction = this.kisspayTransaction || {};
			return {
				...base, kind: 'kisspay',
				qrImage: transaction.qr_code_url || transaction.qrCodeUrl || '',
				paymentUrl: transaction.redirect_url || transaction.showurl || this.kisspayRedirectUrl || '',
				amount: this.kisspayPayableAmount || '',
				amountPending: this.kisspayPayableAmount === null,
				expiresAt: this.resolveTimestampWithDuration(transaction.provider_created_at, 5 * 60),
				fallbackCountdownSeconds: 5 * 60,
				checking: this.kisspayStatusChecking
			};
		}

		if (this.hasActivePaykumoDeposit) {
			const transaction = this.paykumoTransaction || {};
			return {
				...base, kind: 'paykumo',
				receiverAccount: this.normalizeUnifiedReceiverAccount({
					bank: transaction.receiver_bank,
					accountNo: transaction.receiver_account,
					accountName: transaction.receiver_name
				}),
				paymentUrl: this.paykumoRedirectUrl || transaction.redirect_url || transaction.address || '',
				qrImage: transaction.qr_image || '',
				expiresAt: transaction.expires_at || null,
				amount: transaction.actual_amount || transaction.amount || base.amount,
				checking: this.paykumoStatusChecking
			};
		}

		if (this.hasActiveS3PayDeposit) {
			const transaction = this.s3PayTransaction || {};
			return {
				...base, kind: 's3pay',
				qrPayload: transaction.qr_data || (transaction.qr && transaction.qr.qr_data) || '',
				paymentUrl: this.s3PayShowUrl || '',
				amount: transaction.amount || transaction.amount_requested || base.amount,
				expiresAt: transaction.expires_at || null,
				fallbackCountdownSeconds: 15 * 60,
				checking: this.s3PayStatusChecking
			};
		}

		if (this.hasActiveDyPayDeposit) {
			const transaction = this.dypayTransaction || {};
			return {
				...base, kind: 'dypay',
				qrPayload: transaction.payment_value || transaction.paymentValue || '',
				paymentUrl: transaction.payment_url || '',
				amount: transaction.recommended_amount || transaction.request_amount || base.amount,
				expiresAt: transaction.expires_at || null,
				checking: this.dypayStatusChecking
			};
		}

		if (this.hasActiveSecurePayDeposit) {
			const transaction = this.securePayTransaction || {};
			const qrPayload = transaction.qr_code_text || transaction.qrCodeText || '';
			const destinationAccount = transaction.destination_account_number ? this.normalizeUnifiedReceiverAccount({
				bank: transaction.destination_bank_code || transaction.destination_bank_name,
				bankName: transaction.destination_bank_name,
				accountNo: transaction.destination_account_number,
				accountName: transaction.destination_account_name
			}) : {};
			return {
				...base, kind: 'securepay', receiverAccount: destinationAccount, qrPayload,
				paymentUrl: this.securePayPageUrl || '',
				amount: transaction.amount_generated || transaction.amount || base.amount,
				remainingText: this.depositTimer ? this.formatTime(this.depositTimer) : '',
				expiresAt: transaction.expired_at || null,
				cancelling: this.isCancellingBankDeposit,
				uploading: this.isSlipUploading,
				showUpload: Boolean(destinationAccount.accountNo && !qrPayload)
			};
		}

		if (this.depositAmount && this.assignedBank) {
			return {
				...base, kind: 'bank',
				receiverAccount: this.normalizeUnifiedReceiverAccount({
					bank: this.assignedBank.bank_name,
					accountNo: this.assignedBank.account_no || this.assignedBank.mobile,
					accountName: [this.assignedBank.firstname, this.assignedBank.lastname].filter(Boolean).join(' ').trim()
				}),
				remainingText: this.depositTimer ? this.formatTime(this.depositTimer) : '',
				cancelling: this.isCancellingBankDeposit,
				uploading: this.isSlipUploading,
				showUpload: true
			};
		}

		return null;
	},
	deadlineTime() {
		if (!this.depositDeadline) return '';
		const deadline = new Date(this.depositDeadline);
		if (Number.isNaN(deadline.getTime())) return '';
		return deadline.toLocaleTimeString('th-TH', { 
			hour: '2-digit', 
			minute: '2-digit',
			hour12: false 
		});
	},
	withdrawModalBodyStyle () {
		const style = {
			top: '0px',
			overflowY: 'auto'
		}
		const defaultHeight = '470px'
		const viewportWidth = this.viewportWidth || 0
		const viewportHeight = this.viewportHeight || 0

		if (viewportWidth <= 575) {
			const verticalMargin = 120
			const availableHeight = Math.max(viewportHeight - verticalMargin, 320)
			const heightValue = `${availableHeight}px`
			style.height = heightValue
			style.maxHeight = heightValue
			style.paddingBottom = '16px'
		} else {
			style.height = defaultHeight
			style.maxHeight = defaultHeight
		}

		return style
	},
	hasActivePayBridgeTask() {
		return !!this.paybridgeMatch && !this.isPayBridgeTaskExpired();
	},
	hasActiveSecurePayDeposit() {
		const transaction = this.securePayTransaction || {};
		return Boolean(
			this.securePayTransaction &&
			this.securePayRefId &&
			(
				this.securePayPageUrl ||
				transaction.qr_code_text ||
				transaction.qrCodeText ||
				transaction.destination_account_number
			)
		);
	},
	paybridgeTaskRemainingSeconds() {
		if (!this.paybridgeMatch || !this.paybridgeMatch.expiresAt) return 0;
		const expiresAtMs = Date.parse(this.paybridgeMatch.expiresAt);
		if (!expiresAtMs) return 0;
		return Math.max(0, Math.ceil((expiresAtMs - this.paybridgeNow) / 1000));
	},
	paybridgeTaskRemainingText() {
		if (!this.paybridgeTaskRemainingSeconds) return '';
		const minutes = Math.floor(this.paybridgeTaskRemainingSeconds / 60);
		const seconds = this.paybridgeTaskRemainingSeconds % 60;
		return `${minutes}:${seconds.toString().padStart(2, '0')}`;
	}
  },
  methods: {
	normalizeUnifiedReceiverAccount({ bank = '', bankName = '', accountNo = '', accountName = '' } = {}) {
		const rawBank = String(bank || bankName || '').trim();
		const bankAliases = {
			'002': 'bankokbank', BBL: 'bankokbank', BKKB: 'bankokbank',
			BANGKOKBANK: 'bankokbank',
			'004': 'kbank', KBNK: 'kbank', KBANK: 'kbank', KASI: 'kbank', KASIKORN: 'kbank',
			KASIKORNBANK: 'kbank', KARIKORN: 'kbank', KARIKORNBANK: 'kbank',
			'006': 'ktb', KTB: 'ktb', KRUNGTHAI: 'ktb', KRUNGTHAIBANK: 'ktb',
			'014': 'scb', SCB: 'scb', SICO: 'scb', SIAMCOMMERCIALBANK: 'scb',
			'025': 'krungsri', BAY: 'krungsri', KRUNGSRI: 'krungsri', BANKOFAYUDHYA: 'krungsri',
			KKP: 'kiatnakin', KIATNAKINPHATRA: 'kiatnakin', KIATNAKINPHATRABANK: 'kiatnakin',
			GSB: 'gsb', GOVERNMENTSAVINGSBANK: 'gsb',
			TTB: 'ttb', TMB: 'ttb', TMBTHANACHART: 'ttb', TMBTHANACHARTBANK: 'ttb',
			TISCO: 'tisco', TISCOBANK: 'tisco',
			LHBANK: 'lh', LANDANDHOUSES: 'lh', LANDANDHOUSESBANK: 'lh',
			UOB: 'uob', UNITEDOVERSEASBANK: 'uob',
			BAAC: 'baac', BANKFORAGRICULTUREANDAGRICULTURALCOOPERATIVES: 'baac',
			GHB: 'ghbank', GHBANK: 'ghbank', GOVERNMENTHOUSINGBANK: 'ghbank',
			CIMB: 'cimb', CIMBTHAI: 'cimb', CIMBTHAIBANK: 'cimb',
			ICBC: 'icbc', ICBCTHAI: 'icbc',
			STANDARDCHARTERED: 'standard', STANDARDCHARTEREDBANK: 'standard',
			STANDARDCHARTEREDTHAI: 'standard'
		};
		const canonicalBankKeys = new Set([
			'bankokbank', 'kbank', 'ktb', 'scb', 'krungsri', 'kiatnakin', 'gsb',
			'ttb', 'tisco', 'lh', 'uob', 'baac', 'ghbank', 'cimb', 'icbc', 'standard'
		]);
		const resolveBankKey = (value) => {
			const normalizedValue = String(value || '').trim();
			if (!normalizedValue) return '';
			const canonicalKey = normalizedValue.toLowerCase();
			if (canonicalBankKeys.has(canonicalKey)) return canonicalKey;
			const compactKey = normalizedValue.toUpperCase().replace(/[^A-Z0-9ก-๙]/g, '');
			return bankAliases[compactKey] || bankAliases[compactKey.replace(/^THA/, '')] || '';
		};
		const bankKey = resolveBankKey(bank) || resolveBankKey(bankName) || rawBank.toLowerCase();
		const normalizedBankName = this.getBankName(bankKey);
		return {
			bankName: normalizedBankName !== bankKey ? normalizedBankName : (bankName || rawBank),
			bankImage: bankKey ? this.getBankImage(bankKey) : '',
			accountNo: String(accountNo || '').trim(),
			accountName: String(accountName || '').trim()
		};
	},
	resolveTimestampWithDuration(value, durationSeconds) {
		if (!value) return null;
		const timestamp = Date.parse(String(value));
		return Number.isFinite(timestamp) ? timestamp + Number(durationSeconds || 0) * 1000 : null;
	},
	resolveCopayPaymentExpiresAt(paymentInfo = {}) {
		const timeout = paymentInfo.timeout || {};
		const value = timeout.days && timeout.time ? `${timeout.days} ${timeout.time}` : timeout.date;
		if (!value) return null;
		const text = String(value).trim();
		const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(text);
		const parsed = hasTimezone ? moment.parseZone(text) : moment.utc(text);
		return parsed.isValid() ? parsed.valueOf() : null;
	},
	getDepositCustomerAccountStorageKey() {
		return `funbeyond_deposit_customer_account_${(this.user && this.user.key) || 'guest'}`;
	},
	persistDepositCustomerAccount(account) {
		if (typeof window === 'undefined' || !window.localStorage || !account) return;
		localStorage.setItem(this.getDepositCustomerAccountStorageKey(), JSON.stringify({
			bank: account.bank || account.bank_name || '',
			account_no: account.account_no || account.accountNo || account.account || '',
			firstname: account.firstname || '',
			lastname: account.lastname || '',
			account_name: account.account_name || '',
			stored_at: Date.now()
		}));
	},
	restoreDepositCustomerAccount() {
		if (typeof window === 'undefined' || !window.localStorage) return null;
		try {
			const cached = JSON.parse(localStorage.getItem(this.getDepositCustomerAccountStorageKey()) || 'null');
			if (!cached || !cached.account_no) return null;
			const approved = this.getApprovedAccounts();
			const match = approved.find(account =>
				String(account.account_no || '').replace(/\D/g, '') === String(cached.account_no || '').replace(/\D/g, '') &&
				String(account.bank || '').toLowerCase() === String(cached.bank || '').toLowerCase()
			);
			this.currentDepositAccount = match || cached;
			return this.currentDepositAccount;
		} catch (error) {
			return null;
		}
	},
	async cancelUnifiedDepositView() {
		const view = this.activeUnifiedDepositView;
		if (!view) return;
		if (view.kind === 'copay') return this.cancelCopayDeposit();
		if (view.kind === 'kisspay') return this.cancelKissPayDeposit();
		if (view.kind === 'paykumo') return this.cancelPaykumoDeposit();
		if (view.kind === 's3pay') return this.cancelS3PayDeposit();
		if (view.kind === 'dypay') return this.cancelDyPayDeposit();
		if (view.kind === 'securepay') return this.confirmCancelSecurePayDeposit();
		if (view.kind === 'bank') return this.confirmCancelBankDeposit();
	},
	uploadUnifiedDepositSlip(event) {
		const view = this.activeUnifiedDepositView;
		if (!view) return;
		if (view.kind === 'securepay') return this.uploadSecurePaySlip(event);
		if (view.kind === 'bank') return this.uploadSlip(event);
	},
	isPayBridgeAllowedUser() {
		return PAYBRIDGE_FRONTEND_ENABLED;
	},
	handleViewportChange () {
		if (typeof window === 'undefined') {
			return
		}
		this.viewportWidth = window.innerWidth
		this.viewportHeight = window.innerHeight
	},
	showPromotionTerms() {
		// ใช้ข้อความจาก promotions.detail หากมี ถ้าไม่มีใช้ fallback text
		const termsMessage = this.promotions && this.promotions.detail 
			? this.promotions.detail 
			: this.$t('promotion_terms_message');

		this.$swal({
			icon: 'info',
			title: this.$t('promotion_terms_title'),
			html: termsMessage.replace(/\n/g, '<br>').replace(/\\n/g, '<br>'),
			confirmButtonText: this.$t('acknowledge'),
			customClass: {
				popup: 'swal-wide',
				content: 'text-left'
			}
		});
	},
	getLocalizedImage(item) {
      if (!item) return '';
      
      const currentLang = this.$i18n.locale;
      const imageField = `image_${currentLang}`;
      
      // ใช้รูปตามภาษา ถ้าไม่มีใช้รูปภาษาไทย ถ้าไม่มีอีกใช้รูปปกติ
      return item[imageField] || item.image_th || item.image;
    },
	toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    selectLanguage(langCode) {
      // Update user language in database
      if(this.user && this.user.key) {
        firebase.database().ref(`users/${this.user.key}`).update({
          language: langCode
        });
        
        // Update local user data
        const userData = JSON.parse(localStorage.getItem('userData'));
        userData.language = langCode;
        localStorage.setItem('userData', JSON.stringify(userData));
        
        // Update Vuex store
        this.$store.dispatch('user/setUser', userData);
		this.$i18n.locale = langCode;
      }
      
      this.isDropdownOpen = false;
    },
	getLanguageName () {
		const language = this.user.language;
		const validLanguages = ['my', 'en', 'lo', 'th'];
		if (validLanguages.includes(language)) {
			const lang = this.languages.find(lang => lang.code === language);
			return lang ? lang.name : this.$t('thai_lang');
		}
		return this.$t('thai_lang');
	},
	getFlagImage() {
		const language = this.user.language;
		const validLanguages = ['my', 'en', 'lo', 'th'];
		
		if (validLanguages.includes(language)) {
		return require(`../assets/images/flags/${language}.png`);
		}
		
		return require('../assets/images/flags/th.png');
	},
	setWithdraw2 (value) {
		  if (value === 'plus') {
			  this.deposit_value = (this.deposit_value) ? this.deposit_value + 10 : 10
		  } else if (value === 'minus') {
			  if (this.deposit_value) { this.deposit_value = (this.deposit_value) ? this.deposit_value - 10 : 0 }
		  } else if (value > 0) { this.deposit_value = value } else { this.deposit_value = 0 }
	},
	genQrCodeCorePay(){
		if(this.papaya){
			if(this.deposit_value < 300){
				this.$swal({ icon: 'error', title: this.$t('promptpay_deposit_title'), text: this.$t('amount_must_exceed_300')}).then((result) => {});
			}else{
				this.$store.commit('user/SET_LOADING', true)
				firebase.firestore().collection('papaya').add({
					userkey:this.user.key,
					code:this.user.code,
					createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
					status:false,
					amount:this.deposit_value,
				}).then(async (result)=>{
					this.unsubscribe = firebase.firestore().collection('papaya').doc(result.id).onSnapshot(async (doc) => {
					if(doc.data().papaya && doc.data().status){
						this.corepayimage = doc.data().papaya.payurl;
						this.unsubscribe()
					}else if(doc.data().papaya && !doc.data().status){
						this.$store.commit('user/SET_LOADING', false)
						if(doc.data().papaya)
						this.$swal({ icon: 'error', title: this.$t('promptpay_problem'), text: this.$tWithSettings('please_contact_admin')}).then((result) => {
						});
						this.unsubscribe()
					}else if(doc.data().papaya && doc.data().status){
						this.$store.commit('user/SET_LOADING', false)
						this.$swal({ icon: 'success', title: 'Success', text: this.$t('promptpay_success')})
						this.unsubscribe()
						$("#depositModal").modal('hide')
					}
					});
					axios.get(`https://api.funbeyond.cc/sonic/${result.id}`).then((result)=>{
					this.$store.commit('user/SET_LOADING', false)
					})
				})
			}
		}
    },
	showCorepayPage(){
      if(this.corepaypage)
        this.corepaypage = false;
      else
        this.corepaypage = true;
    },
	showDateTime(date){
		return moment(date,'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY HH:mm');
	},
	async closeAnnouncement(type){
		if(type===1){
			firebase.database().ref(`/announcement_users/${this.user.key}`).update({
				status: this.$t('acknowledged_status'),
				updatetime:moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
				close:true
			});
		}
		document.getElementById("an-close").click();
	},
	async getAnnouncementUser(key){
		if(key){
			const announcement = (await firebase.database().ref(`/announcement_users/${key}`).once('value')).val();
			if(announcement && !announcement.close && announcement.title && (!announcement.status || announcement.status !== this.$t('acknowledged_status'))){
				this.announcement_user = announcement;
				document.getElementById("a-modal").click();
			}
		}
	},
	resizeImage(file, maxWidth = 800, maxHeight = 800) {
		return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = (event) => {
			const img = new Image();
			img.onload = () => {
			let width = img.width;
			let height = img.height;

			// คำนวณขนาดใหม่
			if (width > maxWidth || height > maxHeight) {
				if (width / height > maxWidth / maxHeight) {
				height = Math.round((height * maxWidth) / width);
				width = maxWidth;
				} else {
				width = Math.round((width * maxHeight) / height);
				height = maxHeight;
				}
			}

			const canvas = document.createElement('canvas');
			canvas.width = width;
			canvas.height = height;
			const ctx = canvas.getContext('2d');
			ctx.drawImage(img, 0, 0, width, height);

			canvas.toBlob((blob) => {
				resolve(blob);
			}, file.type, 0.85); // 0.85 คือ quality (jpeg/png)
			};
			img.onerror = reject;
			img.src = event.target.result;
		};
		reader.onerror = reject;
		reader.readAsDataURL(file);
		});
	},
	formatPromotionBalanceAmount(amount) {
		return Number(amount || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	},
	showPromotionBalanceBlockedAlert(result) {
		const rawLimit = Number(result && result.limit ? result.limit : 10);
		const limit = rawLimit % 1 === 0 ? rawLimit.toLocaleString('en-US') : this.formatPromotionBalanceAmount(rawLimit);
		const lineLink = this.adminContactLineLink || 'https://lin.ee/xalM4XE';
		return this.$swal({
			icon: 'warning',
			title: 'ขออภัยค่ะ',
			html: `เครดิตคงเหลือมากกว่า ${limit} บาท ไม่สามารถฝากแบบรับโปรโมชั่นได้ค่ะ<br><br>สอบถามข้อมูลเครดิตเพิ่มเติม กรุณาติดต่อแอดมิน`,
			showCancelButton: true,
			confirmButtonText: 'ตกลง',
			cancelButtonText: 'ติดต่อแอดมิน',
			reverseButtons: false
		}).then((swalResult) => {
			if (swalResult && swalResult.dismiss === 'cancel' && lineLink) {
				window.open(lineLink, '_blank');
			}
			return swalResult;
		});
	},
	showActivePromotionDepositBlockedAlert() {
		const lineLink = this.adminContactLineLink || 'https://lin.ee/xalM4XE';
		return this.$swal({
			icon: 'warning',
			title: 'ยังไม่สามารถฝากเงินเพิ่มได้',
			html: 'ขณะนี้มีโปรโมชั่นเดิมที่ยังไม่จบเงื่อนไข จึงยังไม่สามารถฝากเงินเพิ่มได้ค่ะ<br>ท่านยังสามารถเข้าเล่นในค่ายที่โปรโมชั่นกำหนดได้ตามปกติ<br><br>กรุณากดเมนู “ทางเข้าเล่น” เพื่อเล่นต่อ หรือยกเลิกโปรโมชั่นก่อนฝากครั้งใหม่',
			showCancelButton: true,
			confirmButtonText: 'ตกลง',
			cancelButtonText: 'ติดต่อแอดมิน',
			reverseButtons: false
		}).then((swalResult) => {
			if (swalResult && swalResult.dismiss === 'cancel' && lineLink) {
				window.open(lineLink, '_blank');
			}
			return swalResult;
		});
	},
	async ensureActivePromotionDepositAllowed() {
		try {
			const result = await this.$store.dispatch('user/checkActivePromotionDepositBlock');
			if(result && result.blocked){
				await this.showActivePromotionDepositBlockedAlert(result);
				return false;
			}
			if(result && result.status === false){
				this.$swal({
					icon: 'error',
					title: 'ไม่สามารถตรวจสอบเงื่อนไขโบนัสได้',
					text: 'กรุณาลองใหม่อีกครั้ง'
				});
				return false;
			}
			return true;
		} catch (err) {
			console.error(err);
			this.$swal({
				icon: 'error',
				title: 'ไม่สามารถตรวจสอบเงื่อนไขโบนัสได้',
				text: 'กรุณาลองใหม่อีกครั้ง'
			});
			return false;
		}
	},
	async ensureDepositPromotionAllowed() {
		if(!this.gotpro) return true;
		try {
			const result = await this.$store.dispatch('user/checkBonusClaimEligibility', { type: 'deposit-promo' });
			if(result && result.blocked){
				await this.showPromotionBalanceBlockedAlert(result);
				return false;
			}
			if(result && result.status === false){
				this.$swal({
					icon: 'error',
					title: 'ไม่สามารถตรวจสอบ balance ได้',
					text: 'กรุณาลองใหม่อีกครั้ง'
				});
				return false;
			}
			return true;
		} catch (err) {
			console.error(err);
			this.$swal({
				icon: 'error',
				title: 'ไม่สามารถตรวจสอบ balance ได้',
				text: 'กรุณาลองใหม่อีกครั้ง'
			});
			return false;
		}
	},
	setPromotionChoice(value) {
		if(!this.user || !this.user.key) return;

		this.$store.commit("user/SET_GOT_PRO", value);
		firebase.database().ref(`users/${this.user.key}`).update({bonus: value ? 'Y' : 'N'});
	},
	getLocalizedImage(item) {
      if (!item) return '';
      
      const currentLang = this.$i18n.locale;
      const imageField = `image_${currentLang}`;
      
      // ใช้รูปตามภาษา ถ้าไม่มีใช้รูปภาษาไทย ถ้าไม่มีอีกใช้รูปปกติ
      return item[imageField] || item.image_th || item.image;
    },
	toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    selectLanguage(langCode) {
      // Update user language in database
      if(this.user && this.user.key) {
        firebase.database().ref(`users/${this.user.key}`).update({
          language: langCode
        });
        
        // Update local user data
        const userData = JSON.parse(localStorage.getItem('userData'));
        userData.language = langCode;
        localStorage.setItem('userData', JSON.stringify(userData));
        
        // Update Vuex store
        this.$store.dispatch('user/setUser', userData);
		this.$i18n.locale = langCode;
      }
      
      this.isDropdownOpen = false;
    },
	getLanguageName () {
		const language = this.user.language;
		const validLanguages = ['my', 'en', 'lo', 'th'];
		if (validLanguages.includes(language)) {
			const lang = this.languages.find(lang => lang.code === language);
			return lang ? lang.name : this.$t('thai_lang');
		}
		return this.$t('thai_lang');
	},
	getFlagImage() {
		const language = this.user.language;
		const validLanguages = ['my', 'en', 'lo', 'th'];
		
		if (validLanguages.includes(language)) {
		return require(`../assets/images/flags/${language}.png`);
		}
		
		return require('../assets/images/flags/th.png');
	},
	setWithdraw2 (value) {
		  if (value === 'plus') {
			  this.deposit_value = (this.deposit_value) ? this.deposit_value + 10 : 10
		  } else if (value === 'minus') {
			  if (this.deposit_value) { this.deposit_value = (this.deposit_value) ? this.deposit_value - 10 : 0 }
		  } else if (value > 0) { this.deposit_value = value } else { this.deposit_value = 0 }
	},
	genQrCodeCorePay(){
		if(this.papaya){
			if(this.deposit_value < 300){
				this.$swal({ icon: 'error', title: this.$t('promptpay_deposit_title'), text: this.$t('amount_must_exceed_300')}).then((result) => {});
			}else{
				this.$store.commit('user/SET_LOADING', true)
				firebase.firestore().collection('papaya').add({
					userkey:this.user.key,
					code:this.user.code,
					createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
					status:false,
					amount:this.deposit_value,
				}).then(async (result)=>{
					this.unsubscribe = firebase.firestore().collection('papaya').doc(result.id).onSnapshot(async (doc) => {
					if(doc.data().papaya && doc.data().status){
						this.corepayimage = doc.data().papaya.payurl;
						this.unsubscribe()
					}else if(doc.data().papaya && !doc.data().status){
						this.$store.commit('user/SET_LOADING', false)
						if(doc.data().papaya)
						this.$swal({ icon: 'error', title: this.$t('promptpay_problem'), text: this.$tWithSettings('please_contact_admin')}).then((result) => {
						});
						this.unsubscribe()
					}else if(doc.data().papaya && doc.data().status){
						this.$store.commit('user/SET_LOADING', false)
						this.$swal({ icon: 'success', title: 'Success', text: this.$t('promptpay_success')})
						this.unsubscribe()
						$("#depositModal").modal('hide')
					}
					});
					axios.get(`https://api.funbeyond.cc/sonic/${result.id}`).then((result)=>{
					this.$store.commit('user/SET_LOADING', false)
					})
				})
			}
		}
    },
	showCorepayPage(){
      if(this.corepaypage)
        this.corepaypage = false;
      else
        this.corepaypage = true;
    },
	showDateTime(date){
		return moment(date,'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY HH:mm');
	},
	async closeAnnouncement(type){
		if(type===1){
			firebase.database().ref(`/announcement_users/${this.user.key}`).update({
				status: this.$t('acknowledged_status'),
				updatetime:moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
				close:true
			});
		}
		document.getElementById("an-close").click();
	},
	async getAnnouncementUser(key){
		if(key){
			const announcement = (await firebase.database().ref(`/announcement_users/${key}`).once('value')).val();
			if(announcement && !announcement.close && announcement.title && (!announcement.status || announcement.status !== this.$t('acknowledged_status'))){
				this.announcement_user = announcement;
				document.getElementById("a-modal").click();
			}
		}
	},
	async uploadSlip(event){
		if(this.paybridgeMatch){
			return this.uploadPayBridgeSlip(event);
		}
		if(!(await this.ensureActivePromotionDepositAllowed())){
			if(event && event.target){
				event.target.value = '';
			}
			return;
		}
		const imageData = event.target.files[0];
		this.$store.commit('user/SET_LOADING', true)
		const resizedImage = await this.resizeImage(imageData, 800, 800);
		
		// Get approved accounts to get bank information
		const approvedAccounts = this.getApprovedAccounts();
		if (approvedAccounts.length === 0) {
			this.$store.commit('user/SET_LOADING', false)
			this.$swal({ icon: 'error', title: 'ข้อผิดพลาด', text: 'กรุณาเพิ่มบัญชีธนาคารที่ได้รับการอนุมัติก่อนแจ้งสลิป'});
			return;
		}
		
		// Use the selected/current deposit account when the user has multiple accounts.
		const selectedAccount = this.currentDepositAccount || this.selectedDepositAccount || approvedAccounts[0];
		
		await firebase.firestore().collection('slip').where('userkey','==',this.user.key).where('status','==','กำลังดำเนินการ').limit(1).get().then((result)=>{
			if(result.empty){
				firebase.firestore().collection('slip').add({
					userkey:this.user.key,
					code:this.user.code,
					user:{
						code:this.user.code,
						firstname: selectedAccount.firstname || this.user.firstname,
						lastname: selectedAccount.lastname || this.user.lastname,
						bank: selectedAccount.bank,
						//tel:this.user.tel,
						account_no: selectedAccount.account_no,
						bonus:this.user.bonus,
					},
					slip_bank: selectedAccount.bank,
					selected_account: {
						bank: selectedAccount.bank,
						account_no: selectedAccount.account_no,
						firstname: selectedAccount.firstname || this.user.firstname,
						lastname: selectedAccount.lastname || this.user.lastname,
					},
					created_at: firebase.firestore.FieldValue.serverTimestamp(),
					createdate_client: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
					createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
					status:'กำลังดำเนินการ',
					auto_read_status:'not_started',
					auto_read_reason:'',
				}).then(async (result)=>{
					const imagetype = imageData.name.split('.');
					const storageRef = firebase.storage().ref(`images/slip/${result.id}.${imagetype[imagetype.length-1]}`).put(resizedImage);
					await storageRef.on(`state_changed`,snapshot=>{
						this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
					}, error=>{console.log(error.message)},
					()=>{
						storageRef.snapshot.ref.getDownloadURL().then((url)=>{
							firebase.firestore().collection('slip').doc(result.id).update({
								image:url,
							})
						});
					});
					this.$store.commit('user/SET_LOADING', false)
					this.$swal({ icon: 'success', title: 'แจ้งสลิปเรียบร้อย', text: `ทีมงานขออภัยในความล่าช้าและจะรีบดำเนินการให้โดยเร็วที่สุด`}).then((result) => {
					});
				})
			}else{
				this.$store.commit('user/SET_LOADING', false)
				this.$swal({ icon: 'error', title: 'แจ้งสลิป', text: `ทีมงานกำลังตรวจสอบสลิปของท่านก่อนหน้าและจะรีบดำเนินการให้โดยเร็วที่สุด`}).then((result) => {
				});
			}
		});
		
	},
	openBrowseFile(){
    	document.getElementById('my_file').click();
	},
	openBrowseFileStep1(){
		if (this.$refs.fileInputStep1) {
			this.$refs.fileInputStep1.click();
		}
	},
	openBrowseFileStep2(){
		if (this.$refs.fileInputStep2) {
			this.$refs.fileInputStep2.click();
		}
	},
	openBrowseFileStep3(){
		if (this.$refs.fileInputStep3) {
			this.$refs.fileInputStep3.click();
		}
	},
	openBrowsePayBridgeFile(){
		if (this.$refs.fileInputPayBridge) {
			this.$refs.fileInputPayBridge.click();
		}
	},
	acknowledgePayBridgeTerms(){
		this.paybridgeAcknowledged = true;
		this.persistPayBridgeTask();
	},
	getPayBridgeTaskStorageKey(){
		return `funbeyond_paybridge_task_${(this.user && this.user.key) || 'guest'}`;
	},
	isPayBridgeTaskExpired(match = this.paybridgeMatch){
		const expiresAtMs = match && match.expiresAt ? Date.parse(match.expiresAt) : 0;
		return !!expiresAtMs && expiresAtMs <= this.paybridgeNow;
	},
	persistPayBridgeTask(){
		if(!this.paybridgeMatch || this.isPayBridgeTaskExpired()) return;
		localStorage.setItem(this.getPayBridgeTaskStorageKey(), JSON.stringify({ match:this.paybridgeMatch, localDepositId:this.paybridgeLocalDepositId || '', acknowledged:!!this.paybridgeAcknowledged }));
	},
	restorePayBridgeTask(){
		try{
			const payload = JSON.parse(localStorage.getItem(this.getPayBridgeTaskStorageKey()) || 'null');
			if(!payload || !payload.match || this.isPayBridgeTaskExpired(payload.match)){ localStorage.removeItem(this.getPayBridgeTaskStorageKey()); return false; }
			this.paybridgeMatch = payload.match; this.paybridgeLocalDepositId = payload.localDepositId || ''; this.paybridgeAcknowledged = !!payload.acknowledged; this.paybridgeExpiredNotified = false;
			return true;
		}catch(error){ localStorage.removeItem(this.getPayBridgeTaskStorageKey()); return false; }
	},
	clearPayBridgeTask(){
		localStorage.removeItem(this.getPayBridgeTaskStorageKey()); this.paybridgeMatch = null; this.paybridgeLocalDepositId = ''; this.paybridgeMessage = ''; this.paybridgeAcknowledged = false; this.paybridgeExpiredNotified = false;
	},
	expirePayBridgeTaskIfNeeded(){
		if(!this.paybridgeMatch || !this.isPayBridgeTaskExpired()) return;
		const modalOpen = $('#depositModal').hasClass('show'); this.clearPayBridgeTask();
		if(modalOpen) { $('#depositModal').modal('hide'); this.$swal({ icon:'warning', title:'PayBridge หมดเวลา', text:'ห้ามโอนเข้าบัญชีเดิม กรุณาเริ่มฝากใหม่อีกครั้ง' }); }
	},
	reopenPayBridgeTask(){
		if(!this.hasActivePayBridgeTask && !this.restorePayBridgeTask()) return;
		this.depositAmount = Number((this.paybridgeMatch && this.paybridgeMatch.amountMinor) || 0) / 100 || this.depositAmount;
		$('#depositModal').modal('show');
	},
	async cancelPayBridgeTask(options = {}){
		if (!options.skipConfirmation) {
			const result = await this.$swal({ icon:'warning', title:'ยกเลิกรายการ PayBridge?', text:'หากยกเลิก ห้ามโอนไปบัญชีที่แสดงไว้', showCancelButton:true, confirmButtonText:'ยืนยันยกเลิก', cancelButtonText:'ทำรายการต่อ' });
			if (!result.isConfirmed) return;
		}
		if (this.paybridgeLocalDepositId && this.user && this.user.key) {
			try {
				const response = await axios.post(`${this.getPayBridgeApiBase()}/paybridge/deposit/cancel`, {
					localDepositId: this.paybridgeLocalDepositId,
					userKey: this.user.key,
				}, { timeout: 15000 });
				const result = response.data || {};
				if (!result.ok) throw new Error(result.error || 'ไม่สามารถยกเลิกรายการ PayBridge ได้');
				if (result.alreadyCompleted) {
					await this.$swal({ icon:'info', title:'รายการฝากเดิมสำเร็จแล้ว', text:'ระบบได้รับยอดฝากของรายการเดิมแล้ว' });
				}
			} catch (error) {
				console.warn('PayBridge cancel failed:', error && error.message ? error.message : error);
				await this.$swal({ icon:'error', title:'ยังไม่สามารถสร้างรายการใหม่ได้', text:'ระบบปิดรายการ PayBridge เดิมไม่สำเร็จ กรุณาลองอีกครั้ง' });
				return false;
			}
		}
		this.clearPayBridgeTask();
		this.depositAmount = null;
		this.inputDepositAmount = null;
		$('#depositModal').modal('hide');
		return true;
	},

	openBrowseFileOld(){
		if (this.$refs.fileInputOld) {
			this.$refs.fileInputOld.click();
		}
	},
	async getBankDeposit(){
		this.bank = {};
		this.hideBankSection = false; // Reset hide flag ตั้งแต่ต้น
		// ตรวจสอบข้อมูลผู้ใช้ก่อนส่ง request
		if (!this.user || !this.user.key) {
			console.warn('getBankDeposit: Missing user data');
			return;
		}

		// ตรวจสอบจำนวนบัญชีที่อนุมัติแล้ว (status = true)
		const approvedAccounts = this.getApprovedAccounts();
		
		if(approvedAccounts.length === 0) {
			console.warn('getBankDeposit: No approved accounts found');
			return;
		}

		// ถ้ามีบัญชีที่อนุมัติแล้วมากกว่า 1 ให้แสดงให้เลือกก่อน
		if(approvedAccounts.length > 1) {
			this.showBankSelectionForDeposit = true;
			// โหลดข้อมูลธนาคารแรกไว้ก่อน เพื่อให้เร็วขึ้น
			await this.callGetBanksOnTimeAPI(approvedAccounts[0]);
			return;
		}

		// ถ้ามีแค่ 1 บัญชี ให้เรียก API โดยส่งธนาคารของบัญชีนั้นไป
		const selectedBank = approvedAccounts[0];
		await this.callGetBanksOnTimeAPI(selectedBank);
	},

	// Method แยกสำหรับเรียก API
	async callGetBanksOnTimeAPI(customerBank) {
		try {
			// Set loading state
			this.fa_spin = true;
			this.isBankLoading = true;

			if(!(await this.ensureActivePromotionDepositAllowed())){
				return;
			}

			if(!(await this.ensureDepositPromotionAllowed())){
				return;
			}

			const data = JSON.stringify({
				"bank": customerBank.bank,
				"key": this.user.key
			});
			const config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: 'https://asia-east2-fun-beyond.cloudfunctions.net/getBanksOnTime',
				headers: { 
					'x-api-key': 'LosnQ8W6uWoVs8N-ik_', 
					'Content-Type': 'application/json'
				},
				data: data,
				timeout: 8000 // ลดเวลาจาก 10 เป็น 8 วินาที
			};

			const response = await axios.request(config);
			// ตรวจสอบข้อมูลที่ได้รับ
			// console.log('response',response.data);
			if (response.data && response.data.banks && response.data.banks.length > 0) {
				const bankData = response.data.banks[0];
				// ใช้ Object.assign เพื่อ merge ข้อมูลใหม่เข้ากับ object เดิม เพื่อรักษา reactivity
				Object.assign(this.bank, bankData);
				
				// รีเซ็ต hide flag เมื่อมีข้อมูลธนาคาร
				this.hideBankSection = false;
				
				// console.log('Bank data loaded:', {
				// 	bankData: bankData,
				// 	hideBankSection: this.hideBankSection,
				// 	bank: this.bank
				// });
			} else {
				console.warn('No bank data received, hiding bank section');
				
				// ถ้าไม่มีธนาคารจาก API (เช่น เวลา 00:00) ให้ซ่อน deposit section
				this.hideBankSection = true;
			}

		} catch (error) {
			console.error('getBankDeposit error:', error);
			
			// แสดงข้อความแจ้งเตือนให้ผู้ใช้เมื่อเกิดข้อผิดพลาด
			if (error.code === 'ECONNABORTED') {
				this.$swal({ 
					icon: 'error', 
					title: 'ข้อผิดพลาด', 
					text: 'เครือข่ายช้า กรุณาลองใหม่อีกครั้ง' 
				});
			} else if (error.response) {
				// Server responded with error status
				this.$swal({ 
					icon: 'error', 
					title: 'ข้อผิดพลาด', 
					text: 'ไม่สามารถโหลดข้อมูลธนาคารได้ กรุณาลองใหม่อีกครั้ง' 
				});
			} else {
				// Network error or other issues
				this.$swal({ 
					icon: 'error', 
					title: 'ข้อผิดพลาด', 
					text: 'เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาตรวจสอบอินเทอร์เน็ต' 
				});
			}
		} finally {
			// Reset loading state
			this.fa_spin = false;
			this.isBankLoading = false;
		}
	},
	async callGetWithdrawCondition() {
		try {
			const condition = await getWithdrawConditionOnce(this.user.key);
			if (condition) {
				this.condition = condition;
			} else {
				console.warn('No bank data received, hiding bank section');
			}

		} catch (error) {
			console.error('getWithdrawCondition error:', error);
		}
	},

	// Method สำหรับเมื่อผู้ใช้เลือกธนาคารในการฝากเงิน (ระบบใหม่)
	async onDepositBankSelected() {
		if (this.selectedDepositAccount) {
			this.showBankSelectionForDeposit = false;
			// ไม่เรียก API ทันที รอให้ user กรอกจำนวนเงินก่อน
		}
	},

	// Set quick deposit amount
	setDepositAmount(amount) {
		this.inputDepositAmount = amount;
	},

	isTrueWalletDepositAccount(account) {
		return normalizePaymentBankCode(account && (account.bank || account.bank_name)) === 'truewallet';
	},

	parseSecurePayVisibleCodes(value) {
		if (Array.isArray(value)) {
			return value.map(item => String(item && item.value !== undefined ? item.value : item).trim().toUpperCase()).filter(Boolean);
		}
		return String(value || '').split(',').map(item => item.trim().toUpperCase()).filter(Boolean);
	},

	isSecurePayVisibleToUser(bank) {
		const codes = [
			...this.parseSecurePayVisibleCodes(bank && bank.visible_to_codes),
			...this.parseSecurePayVisibleCodes(bank && bank.visible_to)
		];
		const userCode = String(this.user && this.user.code || '').trim().toUpperCase();
		return codes.length === 0 || codes.includes('*') || codes.includes(userCode);
	},

	async loadSecurePayConfig() {
		try {
			const snapshot = await firebase.database().ref('/banks/securepay').once('value');
			const bank = snapshot.val();
			if (!bank) {
				this.securePayConfig = null;
				return null;
			}
			const usage = String(bank.payment_usage || 'both').trim().toLowerCase();
			this.securePayConfig = {
				...bank,
				enabled: this.isBankEnabled(bank),
				depositEnabled: usage === 'deposit' || usage === 'both',
				availableNow: this.isBankOpenNow(bank),
				depositMin: Number(bank.payment_deposit_min_amount || 50),
				depositMax: Number(bank.payment_deposit_max_amount || 0),
				blockedBanks: bank.payment_blocked_banks !== undefined
					? bank.payment_blocked_banks
					: (bank.blocked_banks !== undefined ? bank.blocked_banks : bank.available)
			};
			return this.securePayConfig;
		} catch (error) {
			console.warn('SecurePay config unavailable:', error);
			this.securePayConfig = null;
			return null;
		}
	},

	getAvailableConfiguredPaymentChannels(selectedAccount, options = {}) {
		const account = selectedAccount || this.selectedDepositAccount || this.getApprovedAccounts()[0] || null;
		const ignoreAccountRestrictions = options.ignoreAccountRestrictions === true;
		const channels = [];
		if (this.dypayConfig && this.dypayConfig.enabled && this.dypayConfig.depositEnabled && this.dypayConfig.availableNow !== false && this.dypayVisibleToUser && (ignoreAccountRestrictions || !this.isDyPayBlockedDepositAccount(account))) {
			channels.push({ type: 'dypay', min: Number(this.dypayConfig.depositMin || 300), max: Number(this.dypayConfig.depositMax || 100000) });
		}
		if (this.paykumoConfig && this.paykumoConfig.enabled && this.paykumoConfig.depositEnabled && this.paykumoConfig.availableNow === true && this.paykumoVisibleToUser && (ignoreAccountRestrictions || !this.isPaykumoBlockedDepositAccount(account))) {
			channels.push({ type: 'paykumo', min: Number(this.paykumoConfig.depositMin || 300), max: Number(this.paykumoConfig.depositMax || 100000) });
		}
		if (this.s3PayConfig && this.s3PayConfig.enabled && this.s3PayConfig.depositEnabled && this.s3PayVisibleToUser && (ignoreAccountRestrictions || !this.isS3PayBlockedDepositAccount(account))) {
			channels.push({ type: 's3pay', min: Number(this.s3PayConfig.depositMin || 300), max: Number(this.s3PayConfig.depositMax || 100000) });
		}
		if (this.copayConfig && this.copayConfig.enabled && this.copayConfig.depositEnabled && this.copayConfig.availableNow !== false && this.copayVisibleToUser && (ignoreAccountRestrictions || !this.isCopayBlockedDepositAccount(account))) {
			channels.push({ type: 'copay', min: Number(this.copayConfig.depositMin || 300), max: Number(this.copayConfig.depositMax || 100000) });
		}
		if (this.kisspayConfig && this.kisspayConfig.enabled && this.kisspayConfig.depositEnabled && this.kisspayConfig.availableNow !== false && this.kisspayVisibleToUser && (ignoreAccountRestrictions || !this.isKissPayBlockedDepositAccount(account))) {
			channels.push({ type: 'kisspay', min: Number(this.kisspayConfig.depositMin || 300), max: Number(this.kisspayConfig.depositMax || 200000) });
		}
		if (this.securePayConfig && this.securePayConfig.enabled && this.securePayConfig.depositEnabled && this.securePayConfig.availableNow !== false && this.isSecurePayVisibleToUser(this.securePayConfig) && (ignoreAccountRestrictions || !isPaymentBankBlocked(this.securePayConfig.blockedBanks, account))) {
			channels.push({ type: 'securepay', min: Number(this.securePayConfig.depositMin || 50), max: Number(this.securePayConfig.depositMax || 0) });
		}
		return channels;
	},

	formatConfiguredPaymentDepositRange(channels) {
		if (!Array.isArray(channels) || channels.length === 0) return '';
		const minimum = Math.min(...channels.map(channel => Number(channel.min || 0)).filter(value => value > 0));
		const maximum = Math.max(...channels.map(channel => Number(channel.max || 0)).filter(value => value > 0));
		if (!Number.isFinite(minimum) || !Number.isFinite(maximum)) return '';
		return `${minimum.toLocaleString()}-${maximum.toLocaleString()}`;
	},

	isConfiguredPaymentAmountAllowed(channel, amount) {
		const value = Number(amount || 0);
		return Number.isInteger(value) && value >= channel.min && (channel.max <= 0 || value <= channel.max);
	},

	async loadConfiguredPaymentChannels() {
		await Promise.all([
			typeof this.loadDyPayConfig === 'function' ? this.loadDyPayConfig() : Promise.resolve(),
			typeof this.loadPaykumoConfig === 'function' ? this.loadPaykumoConfig() : Promise.resolve(),
			typeof this.loadS3PayConfig === 'function' ? this.loadS3PayConfig() : Promise.resolve(),
			typeof this.loadCopayConfig === 'function' ? this.loadCopayConfig() : Promise.resolve(),
			typeof this.loadKissPayConfig === 'function' ? this.loadKissPayConfig() : Promise.resolve(),
			this.loadSecurePayConfig()
		]);
	},

	getDepositChannelLockContext() {
		return {
			storage: typeof window !== 'undefined' ? window.localStorage : null,
			userKey: this.user && this.user.key ? this.user.key : ''
		};
	},

	buildDepositCandidates(paymentChannels, receiverBanks) {
		return buildLockedDepositCandidates(paymentChannels, receiverBanks, this.getDepositChannelLockContext());
	},

	lockDepositCandidate(candidate) {
		const { storage, userKey } = this.getDepositChannelLockContext();
		return saveDepositChannelLock(storage, userKey, candidate);
	},

	releaseDepositChannelLock() {
		const { storage, userKey } = this.getDepositChannelLockContext();
		clearDepositChannelLock(storage, userKey);
	},

	async tryConfiguredPaymentDeposit(selectedAccount, amount) {
		const eligibleChannels = this.getAvailableConfiguredPaymentChannels(selectedAccount)
			.filter(channel => this.isConfiguredPaymentAmountAllowed(channel, amount));
		if (eligibleChannels.length === 0) return false;

		const candidates = this.buildDepositCandidates(eligibleChannels, []);
		for (const candidate of candidates) {
			const channel = candidate.channel;
			try {
				if (await this.tryConfiguredPaymentChannel(channel, selectedAccount)) return true;
				this.releaseDepositChannelLock();
			} catch (error) {
				if (!this.isConfiguredPaymentTemporarilyUnavailable(error)) throw error;
				this.releaseDepositChannelLock();
				console.info(`ข้าม ${channel.type} เนื่องจากอยู่นอกเวลาให้บริการ`);
			}
		}
		return false;
	},

	async tryConfiguredPaymentChannel(channel, selectedAccount) {
		if (!channel) return false;
		let created = false;
		if (channel.type === 'dypay') created = await this.tryDyPayDeposit(selectedAccount);
		if (channel.type === 'paykumo') created = await this.tryPaykumoDeposit(selectedAccount);
		if (channel.type === 's3pay') created = await this.tryS3PayDeposit(selectedAccount);
		if (channel.type === 'copay') created = await this.tryCopayDeposit(selectedAccount);
		if (channel.type === 'kisspay') created = await this.tryKissPayDeposit(selectedAccount);
		if (channel.type === 'securepay') created = await this.trySecurePayDeposit(selectedAccount);
		if (created) this.lockDepositCandidate({ type: 'payment', channel });
		return created;
	},

	securePayStorageKey() {
		return `funbeyond_securepay_deposit_${(this.user && this.user.key) || 'guest'}`;
	},

	clearSecurePayDepositCache() {
		if (typeof window !== 'undefined' && window.localStorage) {
			window.localStorage.removeItem(this.securePayStorageKey());
		}
	},

	persistSecurePayDeposit(transaction) {
		if (typeof window === 'undefined' || !window.localStorage || !transaction) return;
		window.localStorage.setItem(this.securePayStorageKey(), JSON.stringify({
			refId: transaction.ref_id || transaction.refId || this.securePayRefId,
			paymentLinkId: transaction.payment_link_id || transaction.paymentLinkId || this.securePayPaymentLinkId,
			pageUrl: transaction.qr_embed_url || transaction.payment_url || transaction.slip_upload_url || transaction.pageUrl || this.securePayPageUrl,
			storedAt: Date.now()
		}));
	},

	applySecurePayTransaction(transaction) {
		if (!transaction) return false;
		const refId = transaction.ref_id || transaction.refId || '';
		const paymentLinkId = transaction.payment_link_id || transaction.paymentLinkId || '';
		const pageUrl = transaction.qr_embed_url || transaction.payment_url || transaction.slip_upload_url || transaction.pageUrl || '';
		const hasDirectPaymentDetails = Boolean(
			transaction.qr_code_text ||
			transaction.qrCodeText ||
			transaction.destination_account_number
		);
		if (!refId || !paymentLinkId || !(pageUrl || hasDirectPaymentDetails)) return false;
		this.securePayTransaction = { ...(this.securePayTransaction || {}), ...transaction };
		this.securePayRefId = refId;
		this.securePayPaymentLinkId = paymentLinkId;
		this.securePayPageUrl = pageUrl;
		this.depositAmount = Number(transaction.amount_generated || transaction.amount || transaction.amount_requested || this.inputDepositAmount || 0);
		this.depositAmountWithDecimal = Number(this.depositAmount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		this.depositDecimal = '00';
		this.assignedBank = null;
		this.paybridgeMatch = null;
		this.persistSecurePayDeposit(this.securePayTransaction);
		this.startSecurePayTransactionListener(refId);
		return true;
	},

	resetSecurePayDepositState(options = {}) {
		this.stopSecurePayTransactionListener();
		this.securePayTransaction = null;
		this.securePayPageUrl = '';
		this.securePayRefId = '';
		this.securePayPaymentLinkId = '';
		this.securePayCompletionHandled = false;
		this.isSlipUploading = false;
		if (options.keepCache !== true) this.clearSecurePayDepositCache();
	},

	async uploadSecurePaySlip(event) {
		const file = event && event.target && event.target.files && event.target.files[0];
		if (!file || this.isSlipUploading) return false;
		if (!this.securePayRefId || !this.securePayPaymentLinkId) {
			await this.$swal({ icon: 'error', title: 'อัปโหลดสลิปไม่สำเร็จ', text: 'ไม่พบรายการ SecurePay กรุณาสร้างรายการฝากใหม่' });
			if (event && event.target) event.target.value = '';
			return false;
		}

		this.isSlipUploading = true;
		this.$store.commit('user/SET_LOADING', true);
		try {
			const resizedImage = await this.resizeImage(file, 800, 800);
			if (!resizedImage) throw new Error('ไม่สามารถเตรียมรูปสลิปได้');
			const extension = String(file.name || '').split('.').pop() || 'jpg';
			const storagePath = `images/securepay/${this.securePayRefId}-${Date.now()}.${extension}`;
			const uploadTask = await firebase.storage().ref(storagePath).put(resizedImage, {
				contentType: resizedImage.type || file.type || 'image/jpeg'
			});
			const imageUrl = await uploadTask.ref.getDownloadURL();
			const response = await axios.post('https://asia-east2-fun-beyond.cloudfunctions.net/securePayUploadSlip', {
				userKey: this.user && this.user.key,
				refId: this.securePayRefId,
				paymentLinkId: this.securePayPaymentLinkId,
				imageUrl,
				fileName: file.name || `${this.securePayRefId}.${extension}`,
				contentType: resizedImage.type || file.type || 'image/jpeg'
			}, {
				headers: { 'x-api-key': CLOUD_FUNCTIONS_API_KEY, 'Content-Type': 'application/json' },
				timeout: 60000
			});
			const result = response.data || {};
			if (!result.success) throw new Error(result.error || 'SecurePay ไม่สามารถรับสลิปได้');
			await this.$swal({
				icon: 'success',
				title: 'อัปโหลดสลิปเรียบร้อย',
				text: result.alreadyCompleted ? 'รายการฝากสำเร็จแล้ว' : 'ระบบกำลังตรวจสอบสลิป กรุณารอสักครู่'
			});
			return true;
		} catch (error) {
			console.error('SecurePay slip upload failed:', error);
			const message = error && error.response && error.response.data && error.response.data.error;
			await this.$swal({ icon: 'error', title: 'อัปโหลดสลิปไม่สำเร็จ', text: message || error.message || 'กรุณาลองใหม่อีกครั้ง' });
			return false;
		} finally {
			this.isSlipUploading = false;
			this.$store.commit('user/SET_LOADING', false);
			if (event && event.target) event.target.value = '';
		}
	},

	stopSecurePayTransactionListener() {
		if (this.securePayTransactionUnsubscribe) {
			this.securePayTransactionUnsubscribe();
			this.securePayTransactionUnsubscribe = null;
		}
	},

	startSecurePayTransactionListener(refId) {
		if (!refId) return;
		this.stopSecurePayTransactionListener();
		this.securePayCompletionHandled = false;
		this.securePayTransactionUnsubscribe = firebase.firestore().collection('securepay_transactions').doc(refId).onSnapshot(snapshot => {
			if (!snapshot.exists) return;
			const transaction = { id: snapshot.id, ...snapshot.data() };
			this.securePayTransaction = { ...(this.securePayTransaction || {}), ...transaction };
			const status = String(transaction.status || '').toUpperCase();
			if (transaction.credit_applied === true || status === 'SUCCESS') {
				this.handleSecurePayDepositSuccess();
			} else if (['FAILED', 'FAIL', 'EXPIRED', 'CANCELLED'].includes(status)) {
				this.handleSecurePayDepositFailure(transaction, status);
			}
		}, error => console.error('SecurePay transaction listener failed:', error));
	},

	async handleSecurePayDepositSuccess() {
		if (this.securePayCompletionHandled) return;
		this.securePayCompletionHandled = true;
		this.clearSecurePayDepositCache();
		this.stopSecurePayTransactionListener();
		window.$('#depositModal').modal('hide');
		await this.$swal({ icon: 'success', title: 'ฝากเงินสำเร็จ', text: 'ระบบ SecurePay เติมเครดิตเรียบร้อยแล้ว' });
		this.resetSecurePayDepositState();
	},

	async handleSecurePayDepositFailure(transaction, status) {
		if (this.securePayCompletionHandled) return;
		this.securePayCompletionHandled = true;
		this.clearSecurePayDepositCache();
		this.stopSecurePayTransactionListener();
		const reason = transaction.failed_reason || transaction.securepay_error || '';
		await this.$swal({
			icon: 'warning',
			title: status === 'EXPIRED' ? 'รายการ SecurePay หมดเวลา' : 'รายการ SecurePay ไม่สำเร็จ',
			text: reason || 'กรุณาสร้างรายการใหม่'
		});
		this.resetSecurePayDepositState();
	},

	async trySecurePayDeposit(selectedAccount) {
		if (!this.securePayConfig) await this.loadSecurePayConfig();
		const amount = Number.parseInt(this.inputDepositAmount, 10) || 0;
		if (!this.securePayConfig || !this.securePayConfig.enabled || !this.securePayConfig.depositEnabled || this.securePayConfig.availableNow === false) return false;
		if (!this.isSecurePayVisibleToUser(this.securePayConfig) || isPaymentBankBlocked(this.securePayConfig.blockedBanks, selectedAccount)) return false;
		if (normalizePaymentBankCode(selectedAccount && selectedAccount.bank) === 'kiatnakin') return false;
		const min = Number(this.securePayConfig.depositMin || 50);
		const max = Number(this.securePayConfig.depositMax || 0);
		if (amount < min || (max > 0 && amount > max)) return false;

		const response = await axios.post('https://asia-east2-fun-beyond.cloudfunctions.net/securePayCreateDeposit', {
			userKey: this.user.key,
			amount,
			account: selectedAccount,
			bonus: this.gotpro ? 'Y' : 'N',
			paymentBankId: 'securepay'
		}, {
			headers: { 'x-api-key': CLOUD_FUNCTIONS_API_KEY, 'Content-Type': 'application/json' },
			timeout: 45000
		});
		const data = response.data && response.data.data;
		if (!response.data || !response.data.success || !data || !this.applySecurePayTransaction(data)) {
			throw new Error(response.data && response.data.error ? response.data.error : 'SecurePay response ไม่ครบถ้วน');
		}
		return true;
	},

	async restoreSecurePayDepositFromCache() {
		if (typeof window === 'undefined' || !window.localStorage || !(this.user && this.user.key)) return false;
		try {
			const cached = JSON.parse(window.localStorage.getItem(this.securePayStorageKey()) || 'null');
			if (!cached || !cached.refId) return false;
			const snapshot = await firebase.firestore().collection('securepay_transactions').doc(cached.refId).get();
			if (!snapshot.exists) {
				this.clearSecurePayDepositCache();
				return false;
			}
			const transaction = { id: snapshot.id, ...snapshot.data(), pageUrl: cached.pageUrl };
			const status = String(transaction.status || '').toUpperCase();
			if (transaction.user_key !== this.user.key || transaction.credit_applied === true || ['SUCCESS', 'FAILED', 'FAIL', 'EXPIRED', 'CANCELLED'].includes(status)) {
				this.clearSecurePayDepositCache();
				return false;
			}
			return this.applySecurePayTransaction(transaction);
		} catch (error) {
			console.warn('Restore SecurePay deposit failed:', error);
			this.clearSecurePayDepositCache();
			return false;
		}
	},

	async cancelSecurePayDepositRemote() {
		if (!this.securePayRefId && !this.securePayPaymentLinkId) return { success: true, cancelled: false };
		const response = await axios.post('https://asia-east2-fun-beyond.cloudfunctions.net/securePayCancelDeposit', {
			userKey: this.user && this.user.key,
			refId: this.securePayRefId,
			paymentLinkId: this.securePayPaymentLinkId
		}, {
			headers: { 'x-api-key': CLOUD_FUNCTIONS_API_KEY, 'Content-Type': 'application/json' },
			timeout: 20000
		});
		const result = response.data || {};
		if (!result.success) throw new Error(result.error || 'ไม่สามารถยกเลิกรายการ SecurePay ได้');
		return result;
	},

	async confirmCancelSecurePayDeposit() {
		const confirmation = await this.$swal({
			icon: 'warning',
			title: 'ยกเลิกรายการ SecurePay?',
			text: 'หากชำระเงินแล้ว กรุณาอย่ายกเลิกและรอระบบตรวจสอบ',
			showCancelButton: true,
			confirmButtonText: 'ยืนยันยกเลิก',
			cancelButtonText: 'ทำรายการต่อ'
		});
		if (!confirmation || !confirmation.isConfirmed) return false;
		return this.cancelDeposit();
	},

	isConfiguredPaymentTemporarilyUnavailable(error) {
		const message = String(error && error.message || '').trim().toLowerCase();
		return message.includes('outside deposit service hours') ||
			(message.includes('outside') && message.includes('service hours')) ||
			message.includes('ปิดให้บริการตามเวลาที่กำหนด') ||
			message.includes('นอกเวลาให้บริการ');
	},

	isLegacyDepositReceiverBank(bank) {
		return isLegacyDepositReceiverBank(bank);
	},

	resetDepositFormScrollPosition() {
		this.$nextTick(() => {
			const reset = () => {
				const modal = this.$refs.depositModal;
				const nestedScrollContainers = modal
					? Array.from(modal.querySelectorAll([
						'.modal-dialog',
						'.modal-content',
						'.modal-body',
						'.x-pending',
						'.-animated-wrapper',
						'.-fake-bg-top-wrapper',
						'.-fake-bg-bottom-wrapper',
						'.x-modal-separator-container'
					].join(', ')))
					: [];

				[modal, this.$refs.depositModalBody, ...nestedScrollContainers].forEach((element) => {
					if (!element) return;
					element.scrollTop = 0;
					element.scrollLeft = 0;
				});
			};

			reset();
			if (typeof window !== 'undefined' && window.requestAnimationFrame) {
				window.requestAnimationFrame(() => {
					reset();
					window.requestAnimationFrame(reset);
				});
			}
		});
	},

	// Submit deposit amount and generate decimal
	async submitDepositAmount() {
		if (!(await ensureLatestBuild(true))) return;
		if (!this.inputDepositAmount || this.inputDepositAmount <= 0) {
			// Use alert if $vs is not available
			if (this.$vs && this.$vs.notify) {
				this.$vs.notify({
					title: 'ข้อผิดพลาด',
					text: 'กรุณาระบุจำนวนเงินที่ถูกต้อง',
					color: 'danger',
					position: 'top-right'
				});
			} else {
				alert('กรุณาระบุจำนวนเงินที่ถูกต้อง');
			}
			return;
		}

		try {
			this.isBankLoading = true;

			if (!(await this.ensureNoPendingWithdrawal())) {
				return;
			}

			if(!(await this.ensureActivePromotionDepositAllowed())){
				return;
			}

			if(!(await this.ensureDepositPromotionAllowed())){
				return;
			}
			
			// Get selected account or default to first approved account
			const selectedAccount = this.selectedDepositAccount || this.getApprovedAccounts()[0];
			
			// Check if approved account exists
			if (!selectedAccount) {
				throw new Error('กรุณาเพิ่มบัญชีธนาคารก่อนทำการฝากเงิน');
			}
			
			// Store account for transaction
			this.currentDepositAccount = selectedAccount;
			this.persistDepositCustomerAccount(selectedAccount);
			const isTrueWalletDeposit = this.isTrueWalletDepositAccount(selectedAccount);
			const amountInt = parseInt(this.inputDepositAmount) || 0;
			// PayBridge must get the first chance to match an active withdrawal.
			// When no match is available it returns false and the existing providers remain the fallback.
			if (!isTrueWalletDeposit && await this.tryPayBridgeDeposit(selectedAccount)) return;
			await this.loadConfiguredPaymentChannels();
			const configuredPaymentChannels = this.getAvailableConfiguredPaymentChannels(selectedAccount);
			const eligiblePaymentChannels = configuredPaymentChannels
				.filter(channel => this.isConfiguredPaymentAmountAllowed(channel, amountInt));

			// เช็คว่าลูกค้าใช้ truewallet ไหม (ทั้งบัญชีเดียวและหลายบัญชี)
			if(isTrueWalletDeposit){
				// Set deposit amount for truewallet
				this.depositAmount = amountInt;
				this.depositAmountWithDecimal = `${amountInt.toLocaleString('en-US')}.00`;
				this.depositDecimal = '00';
				const allBanks = await getBankPublicOptionsOnce(firebase.database());

				if (!allBanks) {
					throw new Error('ไม่พบบัญชี TrueWallet');
				}

				const availableTrueWalletBanks = Object.entries(allBanks)
					.filter(([, bank]) => bank && bank.bank_name === 'truewallet' && this.isBankOpenNow(bank))
					.map(([key, bank]) => ({ ...bank, id: key }));

				if (availableTrueWalletBanks.length === 0) {
					throw new Error('ไม่มีบัญชี TrueWallet ที่พร้อมให้บริการในขณะนี้');
				}

				const selectedTrueWalletCandidate = this.buildDepositCandidates([], availableTrueWalletBanks)[0];
				this.assignedBank = selectedTrueWalletCandidate.bank;
				this.lockDepositCandidate(selectedTrueWalletCandidate);
				this.isBankLoading = false;
				return;
			}
			// Get available banks from realtime database
			const allBanks = await getBankPublicOptionsOnce(firebase.database());
			
			if (!allBanks) {
				throw new Error('ไม่พบข้อมูลธนาคาร');
			}

			// Filter banks with status true and valid display_time
			const availableBanks = [];

			Object.entries(allBanks).forEach(([key, bank]) => {
				const bankWithId = { ...bank, id: key };
				if (bank.bank_name !== 'truewallet' && this.isLegacyDepositReceiverBank(bankWithId) && this.isBankOpenNow(bank)) {
					availableBanks.push(bankWithId);
				}
			});

			const receiverBanks = this.condition.disableDeposit ? [] : availableBanks;
			const candidates = this.buildDepositCandidates(eligiblePaymentChannels, receiverBanks);
			if (candidates.length === 0) {
				const range = this.formatConfiguredPaymentDepositRange(configuredPaymentChannels);
				throw new Error(this.condition.disableDeposit && range
					? `ไม่สามารถสร้างการฝากได้ ตอนนี้ระบบรองรับยอดฝาก ${range} บาท ต่อรายการเท่านั้น`
					: 'ไม่มีธนาคารที่พร้อมให้บริการในขณะนี้');
			}

			let selectedReceiverBank = null;
			for (const candidate of candidates) {
				if (candidate.type === 'bank') {
					selectedReceiverBank = candidate.bank;
					break;
				}
				try {
					if (await this.tryConfiguredPaymentChannel(candidate.channel, selectedAccount)) return;
					this.releaseDepositChannelLock();
				} catch (error) {
					if (!this.isConfiguredPaymentTemporarilyUnavailable(error)) throw error;
					this.releaseDepositChannelLock();
					console.info(`ข้าม ${candidate.channel.type} เนื่องจากอยู่นอกเวลาให้บริการ`);
				}
			}
			if (!selectedReceiverBank) throw new Error('ไม่มีธนาคารที่พร้อมให้บริการในขณะนี้');
			assertLegacyDepositReceiverBank(selectedReceiverBank);
			
			// Generate unique decimal
			const decimal = await this.generateUniqueDecimal(selectedReceiverBank, this.inputDepositAmount);
			
			// Set deposit data
			this.depositAmount = amountInt;
			this.depositAmountWithDecimal = `${amountInt.toLocaleString('en-US')}.${decimal}`;
			this.depositDecimal = decimal;
			this.assignedBank = selectedReceiverBank;
			
			// Start 10-minute timer
			this.startDepositTimer();
			
			// Save transaction to Firestore
			await this.saveDepositTransaction(selectedReceiverBank, decimal);
			this.lockDepositCandidate({ type: 'bank', bank: selectedReceiverBank });
			
		} catch (error) {
			this.releaseDepositChannelLock();
			console.error('Submit deposit error:', error);
			await this.$swal({
				icon: 'warning',
				title: 'แจ้งเตือน',
				text: error.message || 'เกิดข้อผิดพลาด กรุณาลองใหม่',
				confirmButtonText: 'ตกลง'
			});
		} finally {
			this.isBankLoading = false;
		}
	},

	async loadPayBridgePublicConfig() {
		try {
			const configSnap = await firebase.database().ref('/paybridge/public').once('value');
			return configSnap.val() || {};
		} catch (error) {
			console.warn('PayBridge public config unavailable; using existing deposit provider');
			return { enabled: false };
		}
	},

	async tryPayBridgeDeposit(selectedAccount) {
		try {
			const config = await this.loadPayBridgePublicConfig();
			this.paybridge = config.enabled === true;
			if(!this.paybridge) return false;
			this.paybridgeChecking = true;
			this.paybridgeMatch = null;
			this.paybridgeMessage = '';
			this.paybridgeAcknowledged = false;
			const amountInt = parseInt(this.inputDepositAmount) || 0;
			const response = await axios.post(`${this.getPayBridgeApiBase()}/paybridge/deposit/check`, {
				amount: amountInt,
				userKey: this.user.key,
				code: this.user.code || '',
				customerAccount: {
					bank: selectedAccount.bank || '',
					account_no: selectedAccount.account_no || '',
					firstname: selectedAccount.firstname || this.user.firstname || '',
					lastname: selectedAccount.lastname || this.user.lastname || '',
				},
			}, { timeout: 12000 });
			const result = response.data || {};
			this.paybridgeLocalDepositId = result.localDepositId || '';
			if(result.action === 'PAY_BRIDGE_RECIPIENT' && result.matchId && result.recipientAccount){
				this.depositAmount = amountInt;
				this.depositAmountWithDecimal = amountInt.toLocaleString('en-US');
				this.depositDecimal = '00';
				this.assignedBank = null;
				this.paybridgeMatch = result;
				this.paybridgeAcknowledged = false;
				this.persistPayBridgeTask();
				return true;
			}
			return false;
		} catch (error) {
			console.warn('PayBridge deposit check failed, fallback to local bank:', error && error.message ? error.message : error);
			this.paybridgeMessage = '';
			return false;
		} finally {
			this.paybridgeChecking = false;
		}
	},

	getPayBridgeApiBase() {
		return 'https://api.funbeyond.cc';
	},

	async uploadPayBridgeSlip(event){
		const imageData = event.target.files[0];
		if(!imageData || !this.paybridgeMatch){
			return;
		}
		this.$store.commit('user/SET_LOADING', true);
		try {
			const pending = await firebase.firestore().collection('slip').where('userkey','==',this.user.key).where('status','==','กำลังดำเนินการ').limit(1).get();
			if(!pending.empty){
				this.$swal({ icon: 'error', title: 'แจ้งสลิป', text: 'ทีมงานกำลังตรวจสอบสลิปของท่านก่อนหน้าและจะรีบดำเนินการให้โดยเร็วที่สุด'});
				return;
			}
			const selectedAccount = this.currentDepositAccount || this.selectedDepositAccount || this.getApprovedAccounts()[0] || {};
			const resizedImage = await this.resizeImage(imageData, 800, 800);
			const match = this.paybridgeMatch;
			const amountMinor = match.amountMinor || Math.round(Number(this.depositAmount || this.inputDepositAmount || 0) * 100);
			const recipientAccount = match.recipientAccount || {};
			const slipRef = await firebase.firestore().collection('slip').add({
				userkey:this.user.key,
				code:this.user.code,
				user:{
					code:this.user.code,
					firstname: selectedAccount.firstname || this.user.firstname,
					lastname: selectedAccount.lastname || this.user.lastname,
					bank: selectedAccount.bank || this.user.bank,
					account_no: selectedAccount.account_no || this.user.account_no,
					bonus:this.user.bonus,
				},
				created_at: firebase.firestore.FieldValue.serverTimestamp(),
				createdate_client: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
				createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
				status:'กำลังดำเนินการ',
				auto_read_status:'not_started',
				auto_read_reason:'',
				provider:'paybridge',
				paybridge_match_id: match.matchId,
				paybridge_deposit_id: match.depositId || '',
				paybridge_withdrawal_id: match.withdrawalId || '',
				paybridge_local_deposit_id: this.paybridgeLocalDepositId || '',
				paybridge_amount_minor: amountMinor,
				paybridge_amount: amountMinor / 100,
				paybridge_recipient_account: recipientAccount,
			});
			const imagetype = imageData.name.split('.');
			const extension = imagetype[imagetype.length - 1] || 'jpg';
			const storagePath = `images/slip/paybridge/${slipRef.id}.${extension}`;
			const uploadTask = firebase.storage().ref(storagePath).put(resizedImage);
			let slipImageUrl = '';
			await new Promise((resolve, reject) => {
				uploadTask.on('state_changed', snapshot => {
					this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
				}, reject, async () => {
					try {
						const url = await uploadTask.snapshot.ref.getDownloadURL();
						slipImageUrl = url;
						await firebase.firestore().collection('slip').doc(slipRef.id).update({
							image:url,
							storagePath,
						});
						resolve();
					} catch (uploadError) {
						reject(uploadError);
					}
				});
			});
			await axios.post(`${this.getPayBridgeApiBase()}/paybridge/slip/submit`, {
				slipId: slipRef.id,
				matchId: match.matchId,
				localDepositId: this.paybridgeLocalDepositId || '',
				slipRef: slipRef.id,
				slipStoragePath: storagePath,
				slipImageUrl,
				expectedSender: {
					accountNo: selectedAccount.account_no || this.user.account_no || '',
					bankCode: selectedAccount.bank || this.user.bank || '',
					accountName: `${selectedAccount.firstname || this.user.firstname || ''} ${selectedAccount.lastname || this.user.lastname || ''}`.trim(),
				},
			}, { timeout: 15000 }).catch(async (error) => {
				await firebase.firestore().collection('slip').doc(slipRef.id).update({
					paybridge_submit_error: error && error.message ? error.message : 'PayBridge submit failed',
					paybridge_submit_error_at: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
				});
			});
			this.clearPayBridgeTask();
			$("#depositModal").modal('hide');
			this.cancelDeposit();
			this.$swal({ icon: 'success', title: 'แจ้งสลิปเรียบร้อย', text: 'ระบบ PayBridge กำลังตรวจสอบสลิปและจะเติมเครดิตหลังยืนยันสำเร็จ'});
		} catch (error) {
			console.error('PayBridge slip upload failed:', error);
			this.$swal({ icon: 'error', title: 'แจ้งสลิป', text: 'ไม่สามารถอัปโหลดสลิป PayBridge ได้ กรุณาลองใหม่'});
		} finally {
			this.$store.commit('user/SET_LOADING', false);
			if(event && event.target) event.target.value = '';
		}
	},

	async getFirebaseServerNowMillis() {
		try {
			const offsetRef = firebase.database().ref('.info/serverTimeOffset');
			const snapshot = await offsetRef.once('value');
			return Date.now() + (snapshot.val() || 0);
		} catch (e) {
			console.warn('Could not get server time offset, using local time');
			return Date.now();
		}
	},

	// Generate unique decimal for the deposit
	async generateUniqueDecimal(receiverBank, amount) {
		const db = firebase.firestore();
		const decimalsRef = db.collection('deposit_decimals');

		const bankData = typeof receiverBank === 'string'
			? { bank_name: receiverBank, account_no: '' }
			: (receiverBank || {});
		const bankName = bankData.bank_name || bankData.bank || '';
		const receiverAccountNo = (bankData.account_no || '').toString();
		const amountInt = parseInt(amount) || 0;
		const serverNow = await this.getFirebaseServerNowMillis();
		const recentCutoff = new Date(serverNow - (16 * 60 * 1000));
		const statuses = ['pending', 'processing', 'completed', 'cancelled'];
		const decimalSnapshots = await Promise.all(statuses.map((status) => decimalsRef
			.where('bank', '==', bankName)
			.where('amount', '==', amountInt)
			.where('status', '==', status)
			.where('created_at', '>=', recentCutoff)
			.get()));
		
		// Collect recently used decimals so a repeated deposit cannot reuse the same amount inside the duplicate window.
		const usedDecimals = new Set();
		decimalSnapshots.forEach((snapshot) => {
			snapshot.forEach(doc => {
				const data = doc.data() || {};
				const docAccountNo = (data.bank_account || '').toString();
				if (receiverAccountNo && docAccountNo && docAccountNo !== receiverAccountNo) {
					return;
				}
				const decimal = data.decimal;
				// Ensure decimal is always string with 2 digits
				if (decimal !== null && decimal !== undefined) {
					usedDecimals.add(decimal.toString().padStart(2, '0'));
				}
			});
		});
		
		// Generate unique decimal (10-99) - always return as string
		let decimal;
		let attempts = 0;
		do {
			decimal = (Math.floor(Math.random() * 90) + 10).toString();
			attempts++;
			if (attempts > 90) {
				throw new Error('ไม่สามารถสร้างเลขทศนิยมได้ กรุณาลองใหม่');
			}
		} while (usedDecimals.has(decimal));
		
		return decimal;
	},

	// Save deposit transaction to Firestore
	async saveDepositTransaction(bank, decimal) {
		assertLegacyDepositReceiverBank(bank);
		const db = firebase.firestore();
		
		// Get selected account or default to first approved account
		const account = this.currentDepositAccount || this.getApprovedAccounts()[0] || {};
		
		// Ensure decimal is string and amount_with_decimal is consistent
		const formattedDecimal = decimal.toString();
		const amountInt = parseInt(this.inputDepositAmount) || 0;
		const amountWithDecimal = `${amountInt}.${formattedDecimal}`;
		
		// Validate data consistency before saving
		const decimalPart = formattedDecimal;
		const expectedAmountWithDecimal = `${amountInt}.${decimalPart}`;
		
		// Double check the values match
		if (amountWithDecimal !== expectedAmountWithDecimal) {
			console.warn('Data inconsistency detected:', {
				calculated: amountWithDecimal,
				expected: expectedAmountWithDecimal,
				original_decimal: decimal,
				formatted_decimal: formattedDecimal
			});
		}

		// Get server time offset to ensure expires_at is accurate even if client clock is wrong
		let serverTimeOffset = 0;
		try {
			const offsetRef = firebase.database().ref('.info/serverTimeOffset');
			const snapshot = await offsetRef.once('value');
			serverTimeOffset = snapshot.val() || 0;
		} catch (e) {
			console.warn('Could not get server time offset, using local time');
		}

		// Calculate expires_at using corrected server time
		const serverNow = Date.now() + serverTimeOffset;
		const expiresAtMillis = serverNow + (10 * 60 * 1000); // 10 minutes
		const transactionData = {
			user_id: this.user.key || '',
			code: this.user.code || '',
			bank: bank.bank_name || '',
			bank_account: bank.account_no || '',
			amount: amountInt,
			decimal: formattedDecimal,
			amount_with_decimal: amountWithDecimal,
			customer_bank: account.bank || '',
			customer_account: account.account_no || '',
			customer_firstname: account.firstname || '',
			customer_lastname: account.lastname || '',
			status: 'pending',
			created_at: firebase.firestore.FieldValue.serverTimestamp(),
			expires_at: firebase.firestore.Timestamp.fromMillis(expiresAtMillis)
		};
		
		const docRef = await db.collection('deposit_decimals').add(transactionData);
		this.depositTransactionId = docRef.id;
	},

	// Start countdown timer for deposit
	async startDepositTimer () {
		this.depositTimer = 600; // 10 minutes in seconds

		// Get server time offset for accurate deadline display
		let serverTimeOffset = 0;
		try {
			const offsetRef = firebase.database().ref('.info/serverTimeOffset');
			const snapshot = await offsetRef.once('value');
			serverTimeOffset = snapshot.val() || 0;
		} catch (e) {
			// fallback to local time
		}

		// Set deadline time using corrected server time
		const serverNow = Date.now() + serverTimeOffset;
		this.depositDeadline = new Date(serverNow + 10 * 60 * 1000);

		if (this.depositTimerInterval) {
			clearInterval(this.depositTimerInterval);
		}

		this.depositTimerInterval = setInterval(() => {
			this.depositTimer--;
			if (this.depositTimer <= 0) {
				this.cancelDeposit();
			}
		}, 1000);
	},

	// Format timer display
	formatTime(seconds) {
		const minutes = Math.floor(seconds / 60);
		const secs = seconds % 60;
		return `${minutes}:${secs.toString().padStart(2, '0')}`;
	},

	// Format deadline time (HH:MM)
	formatDeadlineTime() {
		if (!this.depositDeadline) return '';
		const now = new Date(this.depositDeadline);
		const hours = now.getHours().toString().padStart(2, '0');
		const minutes = now.getMinutes().toString().padStart(2, '0');
		return `${hours}:${minutes}`;
	},

	async confirmCancelBankDeposit() {
		if (this.isCancellingBankDeposit) return false;
		const result = await this.$swal({
			icon: 'warning',
			title: 'ยกเลิกรายการและสร้างรายการใหม่?',
			text: 'หากโอนไปแล้วอย่ายกเลิก กรุณารอระบบตรวจสอบหรืออัปโหลดสลิปของรายการเดิม',
			showCancelButton: true,
			confirmButtonText: 'ยืนยันยกเลิก',
			cancelButtonText: 'ทำรายการเดิมต่อ',
			allowOutsideClick: false,
			allowEscapeKey: false
		});
		if (!result || !result.isConfirmed) return false;

		this.isCancellingBankDeposit = true;
		try {
			return await this.cancelDeposit();
		} finally {
			this.isCancellingBankDeposit = false;
		}
	},

	// Cancel deposit
	async cancelDeposit() {
		if (this.hasActiveSecurePayDeposit) {
			try {
				const result = await this.cancelSecurePayDepositRemote();
				if (result.alreadyCompleted) {
					await this.$swal({ icon: 'info', title: 'รายการฝากสำเร็จแล้ว', text: 'SecurePay ยืนยันรายการนี้แล้ว กรุณารอเครดิตเข้าระบบ' });
					return false;
				}
				this.resetSecurePayDepositState();
			} catch (error) {
				console.warn('SecurePay cancel failed:', error);
				await this.$swal({ icon: 'error', title: 'ยกเลิก SecurePay ไม่สำเร็จ', text: error.message || 'กรุณาลองอีกครั้ง' });
				return false;
			}
		}
		try {
			// Update transaction status if exists
			if (this.depositTransactionId) {
				const db = firebase.firestore();
				await db.collection('deposit_decimals').doc(this.depositTransactionId).update({
					status: 'cancelled',
					cancelled_at: firebase.firestore.FieldValue.serverTimestamp()
				});
			}
		} catch (error) {
			console.warn('Failed to cancel active deposit:', error && error.message ? error.message : error);
			await this.$swal({ icon:'error', title:'ยังไม่สามารถสร้างรายการใหม่ได้', text:'ระบบปิดรายการฝากเดิมไม่สำเร็จ กรุณาลองอีกครั้ง' });
			return false;
		}

		if (this.depositTimerInterval) {
			clearInterval(this.depositTimerInterval);
			this.depositTimerInterval = null;
		}
		
		// Reset all deposit states
		this.inputDepositAmount = null;
		this.depositAmount = null;
		this.depositAmountWithDecimal = null;
		this.assignedBank = null;
		this.depositTimer = null;
		this.depositDecimal = null;
		this.depositTransactionId = null;
		this.currentDepositAccount = null;
		this.paybridgeMatch = null;
		this.paybridgeLocalDepositId = '';
		this.paybridgeMessage = '';
		this.paybridgeAcknowledged = false;
		
		// Check if need to show bank selection again
		const approvedAccounts = this.getApprovedAccounts();
		if (approvedAccounts.length > 1) {
			this.showBankSelectionForDeposit = true;
			this.selectedDepositAccount = null;
		}
		return true;
	},

	// Helper method to check if time is in range
	isTimeInRange(current, start, end) {
		const currentTime = moment(current, 'HH:mm');
		const startTime = moment(start, 'HH:mm');
		const endTime = moment(end, 'HH:mm');
		
		if (endTime.isBefore(startTime)) {
			// Range crosses midnight
			return currentTime.isAfter(startTime) || currentTime.isBefore(endTime);
		} else {
			return currentTime.isBetween(startTime, endTime, null, '[]');
		}
	},

	isBankEnabled(bank) {
		return !!bank && (bank.status === true || bank.status === 'Y');
	},

	getDisplayTimeRange(displayTime) {
		if (!displayTime) {
			return { startTime: null, endTime: null };
		}

		if (typeof displayTime === 'string') {
			const times = displayTime.split('-');
			if (times.length === 2) {
				return {
					startTime: times[0],
					endTime: times[1]
				};
			}
		}

		if (typeof displayTime === 'object' && displayTime.start_time && displayTime.end_time) {
			return {
				startTime: displayTime.start_time,
				endTime: displayTime.end_time
			};
		}

		return { startTime: null, endTime: null };
	},

	isBankOpenNow(bank) {
		if (!this.isBankEnabled(bank)) {
			return false;
		}

		const { startTime, endTime } = this.getDisplayTimeRange(bank.display_time);
		if (!startTime || !endTime) {
			return true;
		}

		return this.isTimeInRange(moment().format('HH:mm'), startTime, endTime);
	},

	getDepositReceiverStorageKey() {
		if (!this.user || !this.user.key) {
			return null;
		}

		return `preferred-deposit-receiver:${this.user.key}`;
	},

	getStoredDepositReceiver() {
		if (typeof window === 'undefined') {
			return null;
		}

		const storageKey = this.getDepositReceiverStorageKey();
		if (!storageKey) {
			return null;
		}

		try {
			const rawValue = window.localStorage.getItem(storageKey);
			return rawValue ? JSON.parse(rawValue) : null;
		} catch (error) {
			console.warn('Failed to parse preferred deposit receiver:', error);
			return null;
		}
	},

	storeDepositReceiver(bank) {
		if (typeof window === 'undefined' || !this.isLegacyDepositReceiverBank(bank) || isPaymentProviderBank(bank)) {
			return;
		}

		const storageKey = this.getDepositReceiverStorageKey();
		if (!storageKey) {
			return;
		}

		window.localStorage.setItem(storageKey, JSON.stringify({
			id: bank.id || '',
			bank_name: bank.bank_name || '',
			account_no: bank.account_no || '',
			firstname: bank.firstname || '',
			lastname: bank.lastname || '',
			type: 'deposit'
		}));
	},

	findPreferredDepositReceiver(availableBanks) {
		const preferredBank = this.getStoredDepositReceiver();
		if (!preferredBank) {
			return null;
		}

			return availableBanks.find((bank) =>
				bank &&
				(
					(preferredBank.id && bank.id === preferredBank.id) ||
					(bank.bank_name === preferredBank.bank_name && bank.account_no === preferredBank.account_no)
				) &&
				this.isBankOpenNow(bank)
			) || null;
		},

	selectDepositReceiverBank(availableBanks) {
		const preferredBank = this.findPreferredDepositReceiver(availableBanks);
		const selectedBank = preferredBank || availableBanks[Math.floor(Math.random() * availableBanks.length)];

		this.storeDepositReceiver(selectedBank);
		return selectedBank;
	},



	// Method สำหรับยกเลิกการเลือกธนาคารและใช้บัญชีแรก
	async cancelBankSelection() {
		this.showBankSelectionForDeposit = false;
		this.selectedDepositAccount = null;
		const approvedAccounts = this.getApprovedAccounts();
		if (approvedAccounts.length > 0) {
			await this.callGetBanksOnTimeAPI(approvedAccounts[0]);
		}
	},

	// Method สำหรับลองโหลดข้อมูลธนาคารใหม่
	async retryBankLoad() {
		this.hideBankSection = false;
		await this.getBankDeposit();
	},


	
	// Helper function to check if current time is within display time range
	isInTimeRange(currentTime, displayTime) {
		if (!displayTime || !displayTime.start_time || !displayTime.end_time) {
			return true; // If no time restriction, always visible
		}
		
		const current = moment(currentTime, 'HH:mm');
		const start = moment(displayTime.start_time, 'HH:mm');
		const end = moment(displayTime.end_time, 'HH:mm');
		
		// Handle case where end time is next day (e.g., 22:00 - 02:00)
		if (end.isBefore(start)) {
			return current.isSameOrAfter(start) || current.isSameOrBefore(end);
		}
		
		return current.isBetween(start, end, null, '[]');
	},
	
	// Helper function to check if bank is visible to current user
	isVisibleToUser(visibleTo) {
		if (!visibleTo || !Array.isArray(visibleTo)) {
			return true; // If no restriction, visible to all
		}
		
		// Check if user's bank is in visible_to array or if "other" is included
		return visibleTo.some(item => {
			if (typeof item === 'object' && item.value) {
				return item.value === this.user.bank || item.value === 'other';
			}
			return item === this.user.bank || item === 'other';
		});
	},
	isNumber(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 46) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
	checkLineLogin (data) {
		if(data.userId && this.user && this.user.key){
	  		firebase.database().ref(`users/${this.user.key}`).update({userId:data.userId,pictureUrl:data.pictureUrl});
			this.$swal({ icon: 'success', title: 'Line', text: 'เชื่อมต่อระบบ Line เรียบร้อยแล้วค่ะ' })
			const user = localStorage.getItem('userData');
			if(user){
				const _user = JSON.parse(user);
				this.$store.dispatch('user/setUser',_user).catch(err => { console.error(err) });
			}
		}
    },
	async getToken (code) {
      const data = qs.stringify({
        grant_type: 'authorization_code',
        code,
        redirect_uri: this.callbackUri,
        client_id: this.clientId,
        client_secret: this.clientSecret
      })
      let response
      await axios({
        method: 'post',
        url: 'https://api.line.me/oauth2/v2.1/token',
        data: data
      }).then(async res => {
        if (res.status !== 200) {
          this.error = 'โปรดติดต่อแอดมิน'
        } else if (res.data) {
          response = res.data
        }
      })
      return response
    },
	async getProfile (token) {
      return await axios.get('https://api.line.me/v2/profile', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    },
	lineLogin () {
      const url = 'https://access.line.me/oauth2/v2.1/authorize'
      let params = {
        response_type: 'code',
        client_id: this.clientId,
        redirect_uri: this.callbackUri,
        state: Math.random().toString(32).substring(2),
        scope: 'openid profile'
      }
      if (this.addFriend) {
        params = Object.assign(params, {
          prompt: 'consent',
          bot_prompt: 'aggressive'
        })
      }
      window.location.href = `${url}?${queryString.stringify(params)}`
    },
	async addLogin(user){
        await axios.get('https://api.ipify.org?format=json').then(x => {
          if(x.data.ip && user.key){
			axios({
				method: 'post',
				url: 'https://api.funbeyond.cc/api/addlogin',
				data: {
					key: user.key,
					ip: x.data.ip
				}
			})
          }
        });
        // await axios.get('https://checkip.amazonaws.com').then(x => {
        //   if(x){
        //     firebase.database().ref(`/users/${key}`).update({
        //       ip:x
        //     });
        //   }
        // });
	},
	nl2br (str, is_xhtml) {
		if (typeof str === 'undefined' || str === null) {
			return '';
		}
		var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
		return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
	},
	closePromotion(){
		this.$store.commit('user/SET_PROMOTION', [])
	},
	clipboardSuccessHandler () {
      this.$swal({ icon: 'success', title: 'Copy', text: this.$t('copy_success') })
    },
	gotoMain(){
		router.replace('/')
	},

	getUserId(){
	  	const user = localStorage.getItem('userData');
		if(user){
			const _user = JSON.parse(user);
			return _user;
		}else{
			firebase.auth().signOut()
			localStorage.removeItem('userData')
			router.replace('/login')
		}
	},
	async moveCreditToWallet(){
		this.selectedWithdrawAccount = null;
		if(this.disabled){
			return { status: false, promoHandled: false };
		}

		this.disabled = true;
		this.$store.commit('user/SET_LOADING', true)
		try {
			const user = this.getUserId();
			const moveResult = await this.$store.dispatch('user/moveCreditToWallet');
			if(!moveResult || moveResult.status !== true){
				throw new Error((moveResult && (moveResult.error || moveResult.message)) || 'ไม่สามารถโยกเครดิตกลับเข้ากระเป๋าหลักได้');
			}

			const promoResult = await this.$store.dispatch('user/preparePromoWithdrawal', user);
			if(!promoResult || promoResult.status !== true || promoResult.withdrawBlocked){
				this.$swal({
					icon: 'warning',
					title: 'ยังไม่สามารถถอนได้',
					text: (promoResult && promoResult.blockingMessage) || 'กรุณาลองใหม่อีกครั้ง'
				});
				return { status: false, promoHandled: Boolean(promoResult && promoResult.activePromotion) };
			}

			if(promoResult.activePromotion){
				this.$store.commit("user/SET_ALERT_WITHDRAWALL", true);
				return { status: true, promoHandled: true };
			}
			return { status: true, promoHandled: false };
		} catch (err) {
			console.error(err);
			this.$swal({
				icon: 'error',
				title: 'ไม่สามารถเตรียมรายการถอนได้',
				text: err.message || 'กรุณาลองใหม่อีกครั้ง'
			});
			return { status: false, promoHandled: false };
		} finally {
			this.$store.commit('user/SET_LOADING', false);
			setTimeout(() => {
				this.disabled = false;
			}, 2000);
		}
	},
	async checkPromotions(){
	  this.$store.commit('user/SET_LOADING', true)
	  // Note: All deposit state resets are now handled in the modal's show.bs.modal event
	  // The new deposit system doesn't need to call getBankDeposit immediately
	  try {
		return await this.$store.dispatch('user/checkPromotions')
	  } catch (err) {
		console.error(err)
		return { status: false, blocked: false }
	  } finally {
		this.$store.commit('user/SET_LOADING', false)
	  }
    },
	hasActiveDepositInProgress() {
		const hasBankDeposit = !!(this.depositAmount && (this.assignedBank || this.depositTransactionId));
		return !!(this.hasActiveSecurePayDeposit || this.hasActiveCopayDeposit || this.hasActiveDyPayDeposit || this.hasActivePaykumoDeposit || this.hasActiveS3PayDeposit || this.hasActiveKissPayDeposit || this.hasActivePayBridgeTask || hasBankDeposit);
	},
	async restoreActiveDepositInProgress() {
		if (this.hasActiveDepositInProgress()) return true;

		if (await this.restoreSecurePayDepositFromCache()) return true;
		if (typeof this.restoreCopayDeposit === 'function' && await this.restoreCopayDeposit()) return true;
		if (typeof this.restoreDyPayDeposit === 'function' && await this.restoreDyPayDeposit()) return true;
		if (typeof this.restorePaykumoDeposit === 'function' && await this.restorePaykumoDeposit()) return true;
		if (typeof this.restoreS3PayDeposit === 'function' && await this.restoreS3PayDeposit()) return true;
		if (typeof this.restoreKissPayDeposit === 'function' && await this.restoreKissPayDeposit()) return true;
		if (typeof this.restorePayBridgeTask === 'function' && this.restorePayBridgeTask()) return true;

		return this.hasActiveDepositInProgress();
	},
	async cancelActiveDepositForNewRequest() {
		if (this.hasActiveSecurePayDeposit) {
			await this.cancelDeposit();
			return !this.hasActiveSecurePayDeposit;
		}
		if (this.hasActiveCopayDeposit && typeof this.cancelCopayDeposit === 'function') {
			await this.cancelCopayDeposit({ skipConfirmation: true });
			return !this.hasActiveCopayDeposit;
		}
		if (this.hasActiveDyPayDeposit && typeof this.cancelDyPayDeposit === 'function') {
			await this.cancelDyPayDeposit({ skipConfirmation: true });
			return !this.hasActiveDyPayDeposit;
		}
		if (this.hasActivePaykumoDeposit && typeof this.cancelPaykumoDeposit === 'function') {
			await this.cancelPaykumoDeposit({ skipConfirmation: true });
			return !this.hasActivePaykumoDeposit;
		}
		if (this.hasActiveS3PayDeposit && typeof this.cancelS3PayDeposit === 'function') {
			await this.cancelS3PayDeposit({ skipConfirmation: true });
			return !this.hasActiveS3PayDeposit;
		}
		if (this.hasActiveKissPayDeposit && typeof this.cancelKissPayDeposit === 'function') {
			await this.cancelKissPayDeposit({ skipConfirmation: true });
			return !this.hasActiveKissPayDeposit;
		}
		if (this.hasActivePayBridgeTask && typeof this.cancelPayBridgeTask === 'function') {
			await this.cancelPayBridgeTask({ skipConfirmation: true });
			return !this.hasActivePayBridgeTask;
		}
		if (this.hasActiveDepositInProgress() && typeof this.cancelDeposit === 'function') {
			await this.cancelDeposit();
			return !this.hasActiveDepositInProgress();
		}
		return true;
	},
	async confirmActiveDepositBeforeNewRequest() {
		if (!(await this.restoreActiveDepositInProgress())) return true;

		const result = await this.$swal({
			icon: 'warning',
			title: 'คุณยังทำรายการฝากที่สร้างไว้ไม่สำเร็จ',
			text: 'กรุณาเลือกทำรายการฝากเดิมต่อ หรือยกเลิกรายการฝากเดิม',
			showCancelButton: true,
			confirmButtonText: 'ตกลง',
			cancelButtonText: 'ยกเลิกฝากเงิน',
			allowOutsideClick: false,
			allowEscapeKey: false
		});

		if (result.isConfirmed) {
			window.$('#depositModal').modal('show');
			return false;
		}
		if (result.dismiss === 'cancel') {
			return await this.cancelActiveDepositForNewRequest();
		}
		return false;
	},
	async ensureNoPendingWithdrawal() {
		const user = this.getUserId();
		const userKey = user && user.key;
		if (!userKey) {
			this.$swal({
				icon: 'error',
				title: 'ไม่สามารถตรวจสอบรายการถอนได้',
				text: 'กรุณาเข้าสู่ระบบใหม่แล้วลองอีกครั้ง'
			});
			return false;
		}

		try {
			const pendingWithdrawal = await getPendingWithdrawalStatus(userKey);
			if (!pendingWithdrawal) return true;

			this.$swal({
				icon: 'warning',
				title: this.$t('withdraw'),
				text: this.$t('withdraw_pending')
			});
			return false;
		} catch (error) {
			console.error('Pending withdrawal check failed:', error);
			this.$swal({
				icon: 'error',
				title: 'ไม่สามารถตรวจสอบรายการถอนได้',
				text: 'กรุณาลองใหม่อีกครั้ง'
			});
			return false;
		}
	},
	async handleDepositClick() {
		if (this.$store.state.user.user && this.$store.state.user.user.pending_approval) {
			this.$swal({
				icon: 'info',
				title: 'แจ้งเตือน',
				text: 'รบกวนรอ admin ตรวจสอบและอนุมัติการสมัครสมาชิกก่อนเริ่มทำรายการฝากครั้งแรกนะคะ (ใช้เวลาประมาณ 5 นาทีค่ะ)'
			});
			return;
		}
		if (!(await this.confirmActiveDepositBeforeNewRequest())) {
			return;
		}
		if (!(await this.ensureNoPendingWithdrawal())) {
			return;
		}
		if (!(await this.ensureActivePromotionDepositAllowed())) {
			return;
		}
		if (this.condition.disableDeposit) {
			await Promise.all([
				typeof this.loadDyPayConfig === 'function' ? this.loadDyPayConfig() : Promise.resolve(),
				typeof this.loadPaykumoConfig === 'function' ? this.loadPaykumoConfig() : Promise.resolve(),
				typeof this.loadS3PayConfig === 'function' ? this.loadS3PayConfig() : Promise.resolve(),
				typeof this.loadCopayConfig === 'function' ? this.loadCopayConfig() : Promise.resolve(),
				typeof this.loadKissPayConfig === 'function' ? this.loadKissPayConfig() : Promise.resolve(),
				this.loadSecurePayConfig()
			]);
			const trueWalletDepositAvailable = this.getApprovedAccounts()
				.some(account => this.isTrueWalletDepositAccount(account));
			if (trueWalletDepositAvailable || this.paymentOnlyDepositRangeText) {
				await this.checkPromotions();
				window.$('#depositModal').modal('show');
				return;
			}
			this.$swal({
				icon: 'warning',
				title: 'ระบบฝากเงินปิดปรับปรุง',
				text: 'กรุณารอสักครู่แล้วลองใหม่อีกครั้ง'
			});
			return;
		}
		await this.checkPromotions();
		window.$('#depositModal').modal('show');
	},
	async handleWithdrawClick() {
		if (this.condition.disableWithdraw) {
			this.$swal({
				icon: 'warning',
				title: 'ระบบถอนเงินปิดปรับปรุง',
				text: 'กรุณารอสักครู่แล้วลองใหม่อีกครั้ง'
			});
			return;
		}
		const result = await this.moveCreditToWallet();
		if(result && result.status && !result.promoHandled){
			window.$('#withdrawModal').modal('show');
		}
	},
	getBank(){
		if(this.user.bank){
			require(`../assets/images/${this.user.bank}.jpg`)
		}
	},
	numberWithCommas (x) {
	  if(!x) x = 0;
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
	numberWithCommas2 (x) {
	  if(!x) x = 0;
      return x.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  	},
	gotoPromotion(){
		$("#accountModal").modal('hide')
		router.replace('/promotion')
	},
	confirmLogout(){
      this.$swal({ icon: 'question', title: 'Log Out!', text: this.$t('confirm_logout'),showCancelButton: true,confirmButtonText: this.$t('confirm')}).then((result) => {
		if (result.isConfirmed) {
			$("#accountModal").modal('hide')
			firebase.auth().signOut()
			localStorage.removeItem('userData')
			router.replace('/login')
		}
      })
    },
	setWithdraw (value) {
		  if (value === 'plus') {
			  this.withdraw = (this.withdraw) ? this.withdraw + 10 : 10
		  } else if (value === 'minus') {
			  if (this.withdraw) { this.withdraw = (this.withdraw) ? this.withdraw - 10 : 0 }
		  } else if (value > 0) { this.withdraw = value } else { this.withdraw = 0 }
	},
	rand () {
    	return Math.random().toString(36).substr(2); // remove `0.`
	},
	token () {
    	return this.rand() + this.rand(); // to make it longer
	},
	async withdrawConfirm () {
		if(this.config.withdraw){
			this.$swal({ icon: 'error', title: this.$t('withdraw'), text: this.$t('withdraw_temporarily_closed') })
			return;
		}
		
		// Validate account selection for multiple approved accounts
		const approvedAccounts = this.getApprovedAccounts();
		if (approvedAccounts.length > 1 && !this.selectedWithdrawAccount) {
			this.$swal({ icon: 'error', title: this.$t('withdraw_modal.title'), text: this.$t('please_select_account') });
			return;
		}
		
		if (approvedAccounts.length === 0) {
			this.$swal({ icon: 'error', title: this.$t('withdraw_modal.title'), text: this.$t('add_bank_before_withdraw') });
			return;
		}
			
		const user = this.getUserId();
		if (user) {
			if (this.withdraw && this.withdraw >= Number(this.condition.minimum) && user.key && this.withdraw <= Number(this.condition.maximum)) {
				if (Number(this.withdraw) <= Number(this.user.credit)) {
					let check = false;
					await firebase.firestore().collection('history').where('userkey','==',user.key).where('status','not-in',['ดำเนินการแล้ว','ยกเลิก']).where('type','==','ถอน').limit(1).get().then((result)=>{
						if(result.size){
							check = true;
						}
					});
					if(!check){
						let total = 0;
						if(this.condition.qtyperday || this.condition.maximumperday){
							await firebase.firestore().collection('history').where('userkey','==',user.key).where('status','==','ดำเนินการแล้ว').where('type','==','ถอน').where('createdate','>=',moment().tz('Asia/Bangkok').format('YYYY-MM-DD')+' 00:00:00').get().then((result)=>{
								if(result.size >= Number(this.condition.qtyperday)){
									check = true;
								}
								result.forEach((doc)=>{
									total += Number(doc.data().qty);
								})
							});
						}
						if(check){
							this.$swal({ icon: 'error', title: this.$t('withdraw_modal.title'), text: this.$t('withdraw_modal.max_daily_count', { count: this.condition.qtyperday }) });
						}else if(total >= Number(this.condition.maximumperday)){
							this.$swal({ icon: 'error', title: this.$t('withdraw_modal.title'), text: this.$t('withdraw_modal.max_daily_amount', { amount: this.condition.maximumperday }) })
						}else{
							const selectedAccount = this.getSelectedWithdrawAccount();

							// ตรวจสอบเงื่อนไข TrueMoney Wallet
							if (selectedAccount.bank === 'truewallet') {
								const amount = Number(this.withdraw);
								if (amount < 100 || amount % 10 !== 0) {
									this.$swal({
										icon: 'error',
										title: this.$t('withdraw_modal.title'),
										text: this.$t('withdraw_modal.truewallet_amount_invalid')
									});
									return;
								}
							}

							axios({
								method: 'post',
								url: 'https://api.funbeyond.cc/quserwithdraw/userwithdraw',
								data: {
									key: user.key,
									tel: user.tel,
									token: this.token(),
									credit: Number(this.withdraw),
									// Add selected account information
									bank: selectedAccount.bank,
									accountno: selectedAccount.account_no,
								}
							}).then(({ data }) => {
								if (data && data.status) {
									const successText = (data.message)
										? data.message
										: this.$t('home_page.withdraw_success');
									this.$swal({ icon: 'success', title: this.$t('withdraw_modal.title'), text: successText });
									$("#withdrawModal").modal('hide');
								} else {
									this.$swal({
										icon: 'error',
										title: this.$t('withdraw_modal.title'),
										text: (data && data.message) ? data.message : this.$t('home_page.withdraw_waiting')
									});
								}
							}).catch(() => {
								this.$swal({
									icon: 'error',
									title: this.$t('withdraw_modal.title'),
									text: 'ไม่สามารถทำรายการถอนได้ กรุณาลองใหม่อีกครั้ง'
								});
							})
						}
						
					}else{
						this.$swal({ icon: 'error', title: this.$t('withdraw_modal.title'), text: this.$t('home_page.withdraw_waiting') })
					}
				}else {
					this.$swal({ icon: 'error', title: this.$t('withdraw_modal.error_title'), text: this.$t('home_page.withdraw_credit') })
				}
			}else{
				this.$swal({ icon: 'error', title: this.$t('withdraw_modal.error_title'), text: this.$t('withdraw_modal.check_credit_condition') })
			}
		}
	},
    reloadBalance() {
      this.fa_spin = true;
	  const user = localStorage.getItem('userData');
	  if(user){
		  const _user = JSON.parse(user);
		  this.$store.dispatch('user/setUser',_user).finally(() => { 
			  setTimeout(() => {
				  this.fa_spin = false
			  }, 1000);
		  }).catch(err => { console.error(err) });
	  }else{
		firebase.auth().signOut()
		localStorage.removeItem('userData')
		router.replace('/login')
	  }
    	},
	showTabAccount() {
      if(!this.accountOpen) this.accountOpen = true; else this.accountOpen = false;
    },
	async changePassword(){
		if(this.password && this.password1 && this.password2){
		console.log(this.password1);
		console.log(this.password2);
		console.log(this.password);
			if(this.password1.length<6){
				this.$swal({ icon: 'warning', title: 'Password', text: `โปรดระบุรหัสผ่านมากกว่า 6 หลักค่ะ`}).then((result) => {
				});
				return;
			}else if(this.password1 != this.password2){
				this.$swal({ icon: 'warning', title: 'Password', text: `โปรดตรวจสอบรหัสผ่านใหม่อีกครั้งค่ะ`}).then((result) => {
				});
				return;
			}
			const user = this.getUserId();
			firebase.auth().signInWithEmailAndPassword(user.tel.trim().toLowerCase() + '@funbeyond.com', this.password.trim()).then(async (res) => {
				if (res.user) {
					this.$store.commit('user/SET_LOADING', true)
					axios({
						method: 'post',
						url: 'https://api.funbeyond.cc/api/resetpassword',
						data: {
							key: user.key,
							password: this.password1
						}
					}).then(async (result)=>{
						if(result.data && result.data.status){
							await firebase.auth().signInWithEmailAndPassword(user.tel.trim().toLowerCase() + '@funbeyond.com', this.password1.trim()).then(async (res2) => {
								if (res2.user) {
									this.$swal({ icon: 'success', title: 'Password', text: `${this.$t('header.change_password')}เรียบร้อยแล้วค่ะ`}).then((result) => {});
									this.password = '';
									this.password1 = '';
									this.password2 = '';
									this.$store.commit('user/SET_LOADING', false)
								}
							}).catch(() => {
							})
						}
					}).catch(()=>{
						this.$store.commit('user/SET_LOADING', false)
					})
				}
			}).catch(() => {
				this.$swal({ icon: 'warning', title: 'Password', text: `โปรดตรวจสอบรหัสผ่านเดิมค่ะ`}).then((result) => {
				});
			})
			
			// this.$store.commit('user/SET_LOADING', true)
			// axios({
			// 	method: 'post',
			// 	url: 'https://api.funbeyond.cc/api/resetpassword',
			// 	data: {
			// 		key: user.key,
			// 		password: this.password1
			// 	}
			// }).then(async (result)=>{
			// 	if(result.data && result.data.status){
			// 		await firebase.auth().signInWithEmailAndPassword(user.tel.trim().toLowerCase() + '@funbeyond.com', this.password1.trim()).then(async (res2) => {
			// 			if (res2.user) {
			// 				this.$swal({ icon: 'success', title: 'Password', text: `${this.$t('header.change_password')}เรียบร้อยแล้วค่ะ`}).then((result) => {
			// 			});
			// 			}
			// 		}).catch(() => {
			// 		})
			// 	}
			// 	this.$store.commit('user/SET_LOADING', false)
			// }).catch(()=>{
			// 	this.$store.commit('user/SET_LOADING', false)
			// })
			$("#accountModalMobile").modal('hide')
			$("#accountModal").modal('hide')
		}
	},
	// Multiple bank accounts management methods
	setAccountActiveTab(tab) {
	  this.accountActiveTab = tab;
	},
	setMobileActiveTab(tab) {
	  this.mobileActiveTab = tab;
	  this.accountOpen = false; // Close sidebar immediately
	},
	resetMobileTabs() {
	  this.mobileActiveTab = null; // Reset to no active tab
	},
	getApprovedAccounts() {
	  if (!this.user.accounts || !Array.isArray(this.user.accounts)) {
		return [];
	  }
	  return this.user.accounts.filter(account => account.status === true);
	},
	getPendingAccounts() {
	  if (!this.user.accounts || !Array.isArray(this.user.accounts)) {
		return [];
	  }
	  return this.user.accounts.filter(account => account.status === false);
	},
	getBankImage(bankCode) {
	  const normalizedBankCode = (bankCode || '').toString().toLowerCase();
	  const bankAliases = {
		bbl: 'bankokbank',
		bangkokbank: 'bankokbank',
		kbnk: 'kbank',
		kbank: 'kbank',
		scba: 'scb',
		scb: 'scb',
		bay: 'krungsri',
		ktba: 'ktb',
		ktb: 'ktb',
		gsba: 'gsb',
		gsb: 'gsb',
		tmb: 'ttb',
		ttb: 'ttb',
		kkp: 'kiatnakin',
		kk: 'kiatnakin',
		lhb: 'lh',
	  };
	  const bankImages = {
		'truewallet': require('../assets/images/bank/tmw.png'),
		'bankokbank': require('../assets/images/bank/bankokbank.jpg'),
		'kbank': require('../assets/images/bank/kbank.jpg'),
		'scb': require('../assets/images/bank/scb.jpg'),
		'tisco': require('../assets/images/bank/tisco.jpg'),
		'ttb': require('../assets/images/bank/ttb.jpg'),
		'ktb': require('../assets/images/bank/ktb.jpg'),
		'krungsri': require('../assets/images/bank/krungsri.jpg'),
		'kiatnakin': require('../assets/images/bank/kiatnakin.jpg'),
		'gsb': require('../assets/images/bank/gsb.jpg'),
		'lh': require('../assets/images/bank/lh.jpg'),
		'uob': require('../assets/images/bank/uob.jpg'),
		'ธนาคารอิสลาม': require('../assets/images/bank/ธนาคารอิสลาม.jpg'),
		'ghbank': require('../assets/images/bank/ghbank.jpg'),
		'cimb': require('../assets/images/bank/cimb.jpg'),
		'baac': require('../assets/images/bank/baac.jpg'),
		'icbc': require('../assets/images/bank/icbc.jpg'),
		'standard': require('../assets/images/bank/standard.jpg')
	  };
	  
	  return bankImages[bankAliases[normalizedBankCode] || normalizedBankCode] || bankImages['scb']; // fallback to scb
	},
	getBankName(bankCode) {
	  return this.bankNames[bankCode] || bankCode;
	},
	onBankChange() {
	  if (this.newAccount.bank === 'truewallet') {
		this.newAccount.firstname = '';
		this.newAccount.lastname = '';
	  }
	},
	onBankChangeMobile() {
	  if (this.newAccountMobile.bank === 'truewallet') {
		this.newAccountMobile.firstname = '';
		this.newAccountMobile.lastname = '';
	  }
	},
	getSelectedWithdrawAccount() {
	  const approvedAccounts = this.getApprovedAccounts();
	  if (approvedAccounts.length === 0) {
		return {};
	  }
	  
	  // If multiple accounts and one is selected, return the selected one
	  if (approvedAccounts.length > 1 && this.selectedWithdrawAccount) {
		return this.selectedWithdrawAccount;
	  }
	  
	  // Default to first approved account
	  return approvedAccounts[0];
	},
	onWithdrawAccountChange() {
	  // This method is called when user selects a different account
	  // The selectedWithdrawAccount is automatically updated by v-model
	},
	normalizeAccountNumber(value) {
	  return String(value || '').replace(/\D/g, '').slice(0, 12);
	},
	onAccountNumberInput(event, platform) {
	  const accountData = platform === 'mobile' ? this.newAccountMobile : this.newAccount;
	  const normalizedAccountNo = this.normalizeAccountNumber(event.target.value);
	  accountData.account_no = normalizedAccountNo;
	  event.target.value = normalizedAccountNo;
	},
	onAccountNumberPaste(event, platform) {
	  const clipboard = event.clipboardData || window.clipboardData;
	  if (!clipboard) return;

	  event.preventDefault();
	  const accountData = platform === 'mobile' ? this.newAccountMobile : this.newAccount;
	  accountData.account_no = this.normalizeAccountNumber(clipboard.getData('text'));
	},
	async addNewAccount() {
	  await this.submitNewAccount('desktop');
	},
	async addNewAccountMobile() {
	  await this.submitNewAccount('mobile');
	},
	async submitNewAccount(platform) {
	  const accountData = platform === 'mobile' ? this.newAccountMobile : this.newAccount;
	  const showFormFlag = platform === 'mobile' ? 'showAddAccountFormMobile' : 'showAddAccountForm';
	  const normalizedAccountNo = this.normalizeAccountNumber(accountData.account_no);
	  accountData.account_no = normalizedAccountNo;

	  // Validation
	  if (!accountData.bank) {
		this.$swal({ icon: 'error', title: 'Error!', text: 'กรุณาเลือกธนาคารค่ะ!!!' });
		return;
	  }
	  if (!normalizedAccountNo) {
		this.$swal({ icon: 'error', title: 'Error!', text: 'กรุณากรอกหมายเลขบัญชีค่ะ!!!' });
		return;
	  }

	  this.$store.commit('user/SET_LOADING', true);
	  
	  try {
		const user = this.getUserId();
		const response = await axios({
		  method: 'post',
		  url: 'https://api.funbeyond.cc/api/addaccount',
		  data: {
			userkey: user.key,
			bank: accountData.bank,
			account_no: normalizedAccountNo,
			status: false
		  }
		});

		// เช็ค response จาก API
		if (response.data.status === false) {
		  this.$swal({
			icon: 'error',
			title: 'ไม่สามารถเพิ่มบัญชีได้',
			text: response.data.error || 'กรุณาลองใหม่อีกครั้ง'
		  })
		  this.$store.commit('user/SET_LOADING', false)
		  return
		}

		this.$swal({
		  icon: 'success',
		  title: 'เพิ่มบัญชีสำเร็จ',
		  text: 'บัญชีของท่านได้ถูกเพิ่มแล้ว รอการอนุมัติจากเจ้าหน้าที่'
		});

		// Reset form
		if (platform === 'mobile') {
		  this.newAccountMobile = {
			bank: '',
			account_no: '',
			firstname: '',
			lastname: '',
		  };
		} else {
		  this.newAccount = {
			bank: '',
			account_no: '',
			firstname: '',
			lastname: '',
		  };
		}
		
		this[showFormFlag] = false;

		// Reload user data
		const userData = localStorage.getItem('userData');
		if(userData){
		  const _user = JSON.parse(userData);
		  this.$store.dispatch('user/setUser',_user).catch(err => { console.error(err) });
		}

	  } catch (error) {
		this.$swal({ 
		  icon: 'error', 
		  title: 'เกิดข้อผิดพลาด', 
		  text: 'ไม่สามารถเพิ่มบัญชีได้ กรุณาลองใหม่อีกครั้ง' 
		});
	  }

	  this.$store.commit('user/SET_LOADING', false);
	},
	cancelAddAccount() {
	  this.newAccount = {
		bank: '',
		account_no: '',
		firstname: '',
		lastname: '',
	  };
	  this.showAddAccountForm = false;
	},
	cancelAddAccountMobile() {
	  this.newAccountMobile = {
		bank: '',
		account_no: '',
		firstname: '',
		lastname: '',
	  };
	  this.showAddAccountFormMobile = false;
	},
	formatWithdrawSummaryAmount(amount) {
		return Number(amount || 0).toLocaleString('th-TH', {
			minimumFractionDigits: 0,
			maximumFractionDigits: 2
		});
	},
	getPromoWithdrawSummary() {
		const walletCredit = Number(this.user.credit || 0);
		const bonusAmount = Number(this.lastbonus.bonus || 0);
		const canwithdraw = Number(this.lastbonus.canwithdraw || 0);
		const backbonus = Boolean(this.lastbonus.backbonus);
		const eligibleCredit = Number(Math.max(0, backbonus ? walletCredit - bonusAmount : walletCredit).toFixed(2));
		const cappedByMaxWithdraw = canwithdraw > 0 && eligibleCredit > canwithdraw;
		const withdrawBase = cappedByMaxWithdraw ? canwithdraw : eligibleCredit;
		const withdrawAmount = Math.max(0, Math.floor(Number(withdrawBase || 0)));

		return {
			promotionName: this.lastbonus.promotionName || 'โปรโมชั่นที่รับ',
			walletCredit,
			bonusAmount,
			backbonus,
			canwithdraw,
			cappedByMaxWithdraw,
			withdrawAmount
		};
	},
	buildPromoWithdrawSummaryHTML(extraHTML = '') {
		const summary = this.getPromoWithdrawSummary();
		const lines = [
			`<div style="font-size: 18px; font-weight: 600; margin-bottom: 12px;">${summary.promotionName}</div>`,
			`<div style="margin-bottom: 6px;">• ลูกค้ามีเครดิต ${this.formatWithdrawSummaryAmount(summary.walletCredit)} บาท</div>`
		];

		if (summary.backbonus) {
			lines.push(`<div style="margin-bottom: 6px;">• หักโบนัสช่วยเล่น ${this.formatWithdrawSummaryAmount(summary.bonusAmount)} บาท</div>`);
		}

		if (summary.cappedByMaxWithdraw) {
			lines.push(`<div style="margin-bottom: 6px;">• ยอดถอนสูงสุด ${this.formatWithdrawSummaryAmount(summary.canwithdraw)} บาท</div>`);
		}

		lines.push(`<div style="margin-bottom: 12px;">• ยอดเงินที่ได้รับ ${this.formatWithdrawSummaryAmount(summary.withdrawAmount)} บาท</div>`);
		lines.push('<div style="font-weight: 600; margin-bottom: 12px;">ยอดเครดิตคงเหลือ 0 บาท</div>');

		if (extraHTML) {
			lines.push(extraHTML);
		}

		return lines.join('');
	},
	// Method สำหรับสร้าง HTML dropdown เลือกบัญชี
	generateAccountDropdownHTML() {
		const accounts = this.getApprovedAccounts();
		let html = '<select id="swal-account-select" class="swal2-input" style="margin-bottom: 15px; padding: 10px; font-size: 16px; font-family: \'Kanit\', sans-serif; border: 1px solid #ddd; border-radius: 5px;">';
		html += '<option value="">เลือกบัญชีที่จะรับเงิน</option>';
		accounts.forEach((account, index) => {
			const bankName = this.getBankName(account.bank);
			html += `<option value="${index}">${bankName} (${account.account_no})</option>`;
		});
		html += '</select>';
		return html;
	},
	// Method สำหรับดึงชื่อธนาคาร
	getBankName(bankCode) {
		return this.bankNames[bankCode] || bankCode;
	},
	// Method สำหรับแสดง Swal alert พร้อมการเลือกบัญชี
	async showWithdrawConfirmWithAccountSelection() {
		const approvedAccounts = this.getApprovedAccounts();
		
		if (approvedAccounts.length === 0) {
			this.$swal({ 
				icon: 'error', 
				title: this.$t('withdraw'), 
				text: 'กรุณาเพิ่มบัญชีธนาคารก่อนทำการถอนเงิน' 
			});
			return;
		}

		// สร้าง HTML สำหรับ dropdown
		const dropdownHTML = this.generateAccountDropdownHTML();
		const messageHTML = this.buildPromoWithdrawSummaryHTML(`กรุณาเลือกบัญชีที่จะรับเงิน:<br>${dropdownHTML}`);
		const promoSummary = this.getPromoWithdrawSummary();
		
		const result = await this.$swal({
			icon: 'question',
			title: this.$t('withdraw'),
			html: messageHTML,
			showCancelButton: true,
			confirmButtonText: this.$t('confirm'),
			cancelButtonText: 'ยกเลิก',
			preConfirm: () => {
				const selectElement = document.getElementById('swal-account-select');
				if (!selectElement || !selectElement.value) {
					this.$swal.showValidationMessage('กรุณาเลือกบัญชีที่จะรับเงิน');
					return false;
				}
				return selectElement.value;
			}
		});

		if (result.isConfirmed && result.value !== undefined) {
			// ตั้งค่าบัญชีที่เลือก
			const selectedAccountIndex = parseInt(result.value);
			this.selectedWithdrawAccount = approvedAccounts[selectedAccountIndex];
			
			// ตั้งค่าจำนวนเงินที่จะถอน
			this.withdraw = promoSummary.withdrawAmount;
			
			// เรียกฟังก์ชัน withdrawConfirm
			this.withdrawConfirm();
		}
	}
  }
}
</script>
<style scoped>
.s3pay-deposit-range {
	display: block;
	margin-top: 8px;
	color: #bbf7d0;
	font-family: 'Kanit', sans-serif;
	font-size: 12px;
	text-align: center;
}

#depositModal > .modal-dialog.s3pay-modal-dialog--active {
	padding: 0 !important;
	border: 0 !important;
	background: transparent !important;
	box-shadow: none !important;
}

#depositModal > .modal-dialog > .-modal-content.s3pay-modal-content--active {
	overflow: visible;
	border: 0 !important;
	background: transparent !important;
	box-shadow: none !important;
}

#depositModal > .modal-dialog > .-modal-content.s3pay-modal-content--active::before,
#depositModal > .modal-dialog > .-modal-content.s3pay-modal-content--active::after {
	display: none !important;
}

#depositModal .-modal-content.s3pay-modal-content--active > .-modal-body.s3pay-modal-body--active {
	position: relative;
	inset: auto;
	padding: 0;
	overflow: visible;
	background: transparent;
}

@media (max-width: 991.98px) {
	#depositModal > .modal-dialog.-modal-size {
		display: block;
		height: 100vh;
		height: 100dvh;
		overflow: hidden;
	}

	#depositModal > .modal-dialog > .-modal-content {
		position: relative;
		inset: auto;
		width: 100%;
		height: 100%;
		max-height: 100%;
		min-height: 0;
		margin: 0;
		overflow: hidden;
		border-radius: 0;
	}

	#depositModal.-v2 .-modal-content .-modal-body.deposit-form-modal-body--scrollable {
		overflow-x: hidden;
		overflow-y: auto !important;
		overflow-anchor: none;
		-webkit-overflow-scrolling: touch;
		overscroll-behavior-y: contain;
		touch-action: pan-y;
		padding-top: calc(1rem + env(safe-area-inset-top)) !important;
		padding-bottom: max(16px, env(safe-area-inset-bottom));
	}

	#depositModal .deposit-promotion-hint,
	#depositModal .promotion-term-single-line {
		font-size: clamp(10px, 3vw, 12px) !important;
		white-space: nowrap;
	}

	#depositModal .-modal-body.s3pay-modal-body--active {
		display: flex;
		align-items: center;
		justify-content: center;
		bottom: 0;
		min-height: 0 !important;
		padding: 8px;
		overflow: hidden;
		-webkit-overflow-scrolling: touch;
		overscroll-behavior: none;
	}
}

.glow {
    color: #fff;
    text-align: center;
    -webkit-animation: glow 1s ease-in-out infinite alternate;
    -moz-animation: glow 1s ease-in-out infinite alternate;
    animation: glow 1s ease-in-out infinite alternate;
    }

    @-webkit-keyframes glow {
    from {
text-shadow: 0 0 5px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 5px #dbc47a, 0 0 5px #dbc47a, 0 0 5px #dbc47a;
    }
    
    to {
text-shadow: 0 0 5px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 5px #dbc47a, 0 0 5px #dbc47a, 0 0 5px #dbc47a;
    }
}
@media (max-width: 500px) { 
	.x-header #headerBrand .navbar-brand .-logo {
		width: 150px;
	}
}
.-balance-container .-user-balance .-inner-box-wrapper2 {
    position: relative;
    margin-right: 5px;
    margin-left: 15px;
    padding: 6px 24px 6px 0px;
    font-weight: 500;
    border-radius: 20px;
    color: #fff;
    text-align: right;
}
.x-logged .-profile-container .-btn-wrapper .-profile-name2 {
	font-family: 'Kanit', sans-serif;
    font-size: 1.2rem;
  /*  color: #e5e5e5; */
    font-weight: 200;
    margin-right: 2px;
    padding-left: 10px;
    color: #f9f9d6;
	text-align: center;
}
.x-logged .-profile-container .-btn-mobile-wrapper .-profile-name2 {
	font-family: 'Kanit', sans-serif;
    font-size: 1.1rem;
  /*  color: #e5e5e5; */
    font-weight: 200;
    margin-right: 2px;
    padding-left: 10px;
    color: #f9f9d6;
	text-align: center;
}

.-balance-container .-user-balance .-btn-balance2 {
    position: absolute;
    right: 10px;
    padding: 0;
    color: #FFFFFF;
    background: transparent;
    border: none;
}
.cCsozd {
    display: inline-block;
    padding: 0.5rem 1rem;
    height: 44px;
    font-size: 1em;
    line-height: 1.5;
    border: none;
    border-radius: 0.25rem;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
}
.ewHin {
    background: rgb(0, 187, 0);
    color: rgb(255, 255, 255);
    height: 50px;
    min-width: 180px;
    border-radius: 25px;
    padding-left: 34px;
    padding-right: 34px;
}
.ewHin .icon {
    height: 18px;
    margin: 0px 0.5rem;
    vertical-align: sub;
    border: 0px;
}

.mid {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Switch starts here */
.rocker {
  display: inline-block;
  position: relative;
  /*
  SIZE OF SWITCH
  ==============
  All sizes are in em - therefore
  changing the font-size here
  will change the size of the switch.
  See .rocker-small below as example.
  */
  font-size: 1em;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  color: #888;
  width: 7em;
  height: 4em;
  overflow: hidden;
  border-bottom: 0.5em solid #eee;
}

.rocker-small {
  font-size: 0.75em; /* Sizes the switch */
  margin: 1em;
}

.rocker::before {
  content: "";
  position: absolute;
  top: 0.5em;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #999;
  border: 0.5em solid #eee;
  border-bottom: 0;
}

.rocker input {
  opacity: 0;
  width: 0;
  height: 0;
}

.switch-left,
.switch-right {
  cursor: pointer;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5em;
  width: 3em;
  transition: 0.2s;
}

.switch-left {
  height: 2.4em;
  width: 2.75em;
  left: 0.85em;
  bottom: 0.4em;
  background-color: #ddd;
  transform: rotate(15deg) skewX(15deg);
}

.switch-right {
  right: 0.5em;
  bottom: 0;
  background-color: #bd5757;
  color: #fff;
}

.switch-left::before,
.switch-right::before {
  content: "";
  position: absolute;
  width: 0.4em;
  height: 2.45em;
  bottom: -0.45em;
  background-color: #ccc;
  transform: skewY(-65deg);
}

.switch-left::before {
  left: -0.4em;
}

.switch-right::before {
  right: -0.375em;
  background-color: transparent;
  transform: skewY(65deg);
}

input:checked + .switch-left {
  background-color: #0084d0;
  color: #fff;
  bottom: 0px;
  left: 0.5em;
  height: 2.5em;
  width: 3em;
  transform: rotate(0deg) skewX(0deg);
}

input:checked + .switch-left::before {
  background-color: transparent;
  width: 3.0833em;
}

input:checked + .switch-left + .switch-right {
  background-color: #ddd;
  color: #888;
  bottom: 0.4em;
  right: 0.8em;
  height: 2.4em;
  width: 2.75em;
  transform: rotate(-15deg) skewX(-15deg);
}

input:checked + .switch-left + .switch-right::before {
  background-color: #ccc;
}

/* Keyboard Users */
input:focus + .switch-left {
  color: #333;
}

input:checked:focus + .switch-left {
  color: #fff;
}

input:focus + .switch-left + .switch-right {
  color: #fff;
}

input:checked:focus + .switch-left + .switch-right {
  color: #333;
}
#my_file {
    display: none;
}

/* Multiple bank accounts styles */
.x-mobile-tabs {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.x-mobile-tabs .-tab-btn {
  background-color: #333;
  color: #fff;
  border: 1px solid #555;
  padding: 8px 16px;
  border-radius: 4px;
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  transition: all 0.3s ease;
}

.x-mobile-tabs .-tab-btn.active {
  background-color: #C320D6;
  border-color: #C320D6;
}

.x-modal-account-menu .nav-item.-account-bank {
  border-left: 4px solid transparent;
  transition: all 0.3s ease;
}

.x-modal-account-menu .nav-item.-account-bank.active {
  border-left-color: #C320D6;
  background-color: rgba(195, 32, 214, 0.1);
}

.x-customer-bank-info-container.-v2 .-content-wrapper .-bank-name {
  display: block;
  font-size: 12px;
  color: #999;
  margin-top: 2px;
}

.x-customer-bank-info-container.-v2 .-content-wrapper .-status {
  display: block;
  font-size: 11px;
  font-weight: bold;
  margin-top: 4px;
  padding: 2px 8px;
  border-radius: 12px;
  text-align: center;
  width: fit-content;
}

.x-customer-bank-info-container.-v2 .-content-wrapper .-status.approved {
  background-color: #4CAF50;
  color: white;
}

.x-customer-bank-info-container.-v2 .-content-wrapper .-status.pending {
  background-color: #FF9800;
  color: white;
}

.-add-account-container {
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.-approved-accounts,
.-pending-accounts {
  margin-bottom: 20px;
}

.btn.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
  color: white;
}

.btn.btn-secondary:hover {
  background-color: #545b62;
  border-color: #4e555b;
}

/* Border colors for account status */
.x-customer-bank-info-container.-v2.approved-border {
  border: 2px solid #4CAF50;
  border-radius: 8px;
  padding: 10px;
  background-color: rgba(76, 175, 80, 0.2);
  backdrop-filter: blur(5px);
}

.x-customer-bank-info-container.-v2.approved-border .-content-wrapper {
  color: #ffffff !important;
}

.x-customer-bank-info-container.-v2.approved-border .-name,
.x-customer-bank-info-container.-v2.approved-border .-number,
.x-customer-bank-info-container.-v2.approved-border .-bank-name {
  color: #ffffff !important;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
}

.x-customer-bank-info-container.-v2.pending-border {
  border: 2px solid #F44336;
  border-radius: 8px;
  padding: 10px;
  background-color: rgba(244, 67, 54, 0.2);
  backdrop-filter: blur(5px);
}

.x-customer-bank-info-container.-v2.pending-border .-content-wrapper {
  color: #ffffff !important;
}

.x-customer-bank-info-container.-v2.pending-border .-name,
.x-customer-bank-info-container.-v2.pending-border .-number,
.x-customer-bank-info-container.-v2.pending-border .-bank-name {
  color: #ffffff !important;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
}

.x-language{position:absolute;right:0;top:200px;z-index:6;margin-right: -14px;}
@media (max-width:1199.98px){
	.x-language{/*position:relative;top:unset;z-index:unset;display:flex*/}
}
.x-language .-link-wrapper{
	background-color:rgba(0,0,0,.5);border-top-left-radius:20px;border-bottom-left-radius:20px;display:flex;padding:.4rem .75rem;color:#fff;align-items: center;
}
@media (min-width:1200px){
	.x-language .-link-wrapper:hover{text-decoration:none;background-color:rgba(0,0,0,.4)}
}@media (max-width:1199.98px){
	.x-language .-link-wrapper{padding:5px;margin-right:.5rem}
}@media (max-width:575.98px){
	.x-language .-link-wrapper{margin-right:.25rem}
}
.x-language .-link-wrapper .-image-wrapper{
	align-items:center;display:flex
}
.x-language .-link-wrapper .-image-wrapper .-ic-right-star-rank{width:30px}
@media (max-width:370px){
	.x-language .-link-wrapper .-image-wrapper .-ic-right-star-rank{min-width:25px}
}
.x-language .-link-wrapper .-text-wrapper{
	line-height:16px;font-size:1.1rem;margin-left:.5rem;
	display: block;
}

.x-ranking-entrance{position:absolute;right:0;top:150px;z-index:6;margin-right: -14px;}
@media (max-width:1199.98px){
  .x-ranking-entrance{/*position:relative;top:unset;z-index:unset;display:flex*/}
}
.x-ranking-entrance .-link-wrapper{
  background-color:rgba(0,0,0,.5);border-top-left-radius:20px;border-bottom-left-radius:20px;display:flex;padding:.4rem .75rem;color:#fff;align-items: center;
}
@media (min-width:1200px){
  .x-ranking-entrance .-link-wrapper:hover{text-decoration:none;background-color:rgba(0,0,0,.4)}
}@media (max-width:1199.98px){
  .x-ranking-entrance .-link-wrapper{padding:5px;margin-right:.5rem}
}@media (max-width:575.98px){
  .x-ranking-entrance .-link-wrapper{margin-right:.25rem}
}
.x-ranking-entrance .-link-wrapper .-image-wrapper{
  align-items:center;display:flex
}
.x-ranking-entrance .-link-wrapper .-image-wrapper .-ic-right-star-rank{width:30px}
@media (max-width:370px){
  .x-ranking-entrance .-link-wrapper .-image-wrapper .-ic-right-star-rank{min-width:25px}
}
.x-ranking-entrance .-link-wrapper .-text-wrapper{
  line-height:16px;font-size:1.1rem;margin-left:.5rem;
  display: block;
}

/* Loading animation for skeleton */
@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
  }

/* PayBridge gold/high-tech deposit display */
.paybridge-panel { width: min(100%, 620px); margin: 0 auto 10px; padding: 16px; color: #0c2130; background: rgba(255,255,255,.82); border: 1px solid rgba(255,255,255,.88); border-radius: 24px; box-shadow: 0 16px 42px rgba(6,54,79,.15); position: relative; overflow: hidden; font-family: 'Kanit', sans-serif; }
.paybridge-panel:before { content: ""; position: absolute; inset: 0; padding: 2px; border-radius: 24px; background: linear-gradient(120deg, rgba(255,255,255,.2), rgba(255,255,255,.96), rgba(245,184,51,.96), rgba(255,255,255,.18), rgba(245,184,51,.82), rgba(255,255,255,.2)); background-size: 240% 240%; -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0); -webkit-mask-composite: xor; mask-composite: exclude; pointer-events: none; animation: paybridgeBorderRun 4.6s linear infinite; z-index: 2; }
.paybridge-panel:after { content: ""; position: absolute; left: 18px; right: 18px; top: 0; height: 1px; background: linear-gradient(90deg, transparent, rgba(255,255,255,.94), rgba(245,184,51,.94), transparent); box-shadow: 0 0 18px rgba(245,184,51,.55); animation: paybridgeTopGlint 2.8s ease-in-out infinite; z-index: 3; }
@keyframes paybridgeBorderRun { 0% { background-position: 0% 50%; } 100% { background-position: 240% 50%; } }
@keyframes paybridgeTopGlint { 0%,100% { opacity:.28; transform: scaleX(.72); } 50% { opacity:.98; transform: scaleX(1); } }
.paybridge-panel-header { text-align: center; background: linear-gradient(180deg, rgba(255,255,255,.98), rgba(237,250,255,.94)); border: 1px solid rgba(16,199,232,.16); border-radius: 18px; padding: 16px 16px 14px; box-shadow: 0 10px 26px rgba(13,82,110,.10); }
.paybridge-badge { display: inline-flex; align-items: center; justify-content: center; gap: 9px; height: 36px; padding: 0 15px; border-radius: 999px; background: linear-gradient(135deg, #052f48, #087f9b); color: #e9fbff; font-weight: 950; font-size: .88rem; box-shadow: 0 14px 24px rgba(6,58,82,.26); }
.paybridge-mark { width: 18px; height: 18px; display: inline-block; border-radius: 7px; background: linear-gradient(135deg, rgba(255,255,255,.85), transparent 42%), linear-gradient(135deg, #f5b833, #10c7e8); box-shadow: 0 0 16px rgba(16,199,232,.58); }
.paybridge-panel-header h3 { margin: 12px 0 5px; color: #0c2130; font-size: 1.52rem; font-weight: 950; line-height: 1.22; }
.paybridge-panel-header p { margin: 0; color: #607684; font-size: 1rem; line-height: 1.45; font-weight: 800; }
.paybridge-route { width: min(280px, 100%); margin: 13px auto 0; display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; color: #0b5c72; font-size: 10px; font-weight: 950; text-transform: uppercase; }
.paybridge-route span { min-height: 24px; display: grid; place-items: center; border-radius: 999px; background: #e8fbff; border: 1px solid #b8eef8; }
.paybridge-agreement-card { display: grid; gap: 12px; margin-top: 14px; padding: 0; background: transparent; color: #0c2130; text-align: left; }
.paybridge-agreement-list { display: grid; gap: 12px; margin: 0; }
.paybridge-agreement-item { display: grid; grid-template-columns: 60px 1fr; align-items: center; gap: 14px; min-height: 82px; padding: 14px 15px; border-radius: 20px; border: 1px solid; position: relative; overflow: hidden; }
.paybridge-agreement-item:after { content: ""; position: absolute; inset: auto 14px 0 88px; height: 1px; background: linear-gradient(90deg, currentColor, transparent); opacity: .18; }
.paybridge-agreement-item.-one { color: #745000; background: linear-gradient(135deg, #fff7d9, #fffdf6); border-color: #ffd66e; }
.paybridge-agreement-item.-two { color: #075d78; background: linear-gradient(135deg, #e8fbff, #fff); border-color: #b8eef8; }
.paybridge-agreement-item.-three { color: #076346; background: linear-gradient(135deg, #e9fff5, #fff); border-color: #bcefd8; }
.paybridge-agreement-item > strong { width: 60px; height: 60px; display: grid; place-items: center; border-radius: 20px; color: #fff; font-size: 31px; font-weight: 1000; box-shadow: 0 12px 20px rgba(0,24,36,.14); }
.paybridge-agreement-item.-one > strong { background: linear-gradient(135deg, #f5b833, #d98600); }
.paybridge-agreement-item.-two > strong { background: linear-gradient(135deg, #10c7e8, #1677ff); }
.paybridge-agreement-item.-three > strong { background: linear-gradient(135deg, #12b981, #07886e); }
.paybridge-agreement-item b { display: block; color: #0c2130; font-size: 1rem; line-height: 1.3; font-weight: 950; }
.paybridge-agreement-item small { display: block; margin-top: 2px; color: currentColor; font-size: .84rem; line-height: 1.35; font-weight: 850; }
.paybridge-agreement-final { margin: 0; padding: 11px 12px; border-radius: 16px; color: #8d2b33; background: linear-gradient(135deg, #fff2f3, #fff8f9); border: 1px solid #ffcdd4; font-size: .88rem; line-height: 1.45; font-weight: 900; text-align: center; }
.paybridge-ack-button, .paybridge-upload-button { width: 100%; min-height: 58px; border: none; border-radius: 18px; background: linear-gradient(135deg, rgba(255,255,255,.18), transparent 42%), linear-gradient(135deg, #0fb879, #087e63); color: #fff; display: inline-flex; align-items: center; justify-content: center; gap: 10px; font-size: 1.04rem; font-weight: 1000; box-shadow: 0 16px 30px rgba(8,126,99,.30), inset 0 0 0 1px rgba(255,255,255,.16); cursor: pointer; transition: transform .15s ease, box-shadow .15s ease; }
.paybridge-ack-button:hover, .paybridge-upload-button:hover { transform: translateY(-1px); box-shadow: 0 18px 34px rgba(8,126,99,.36); }
.paybridge-cancel-button { width: 100%; min-height: 46px; margin-top: 10px; border-radius: 14px; border: 1px solid #ffd4da; background: #fff4f5; color: #b91c1c; display: inline-flex; align-items: center; justify-content: center; gap: 8px; font-size: .95rem; font-weight: 900; cursor: pointer; }
.paybridge-cancel-button.-after-account { background: #fff4f5; color: #b91c1c; border-color: #ffd4da; box-shadow: 0 8px 18px rgba(185,28,28,.10); }
.paybridge-amount-card { margin: 14px 0; border-radius: 21px; background: linear-gradient(135deg, rgba(255,255,255,.16), transparent 42%), linear-gradient(135deg, #052f48, #1267d6); color: #fff; padding: 15px; display: grid; grid-template-columns: 1fr auto; align-items: center; gap: 12px; box-shadow: 0 15px 30px rgba(18,103,214,.25); }
.paybridge-amount-card span { display: block; color: rgba(255,255,255,.76); font-size: .86rem; font-weight: 850; }
.paybridge-amount-card strong { display: flex; align-items: center; gap: 8px; margin-top: 2px; font-size: 1.65rem; line-height: 1.05; font-weight: 1000; white-space: nowrap; }
.paybridge-timer { min-width: 96px; min-height: 56px; padding: 7px 10px; display: grid; place-items: center; align-content: center; border-radius: 16px; color: #07354f; background: #eafdff; border: 1px solid rgba(255,255,255,.68); font-variant-numeric: tabular-nums; box-shadow: 0 0 0 4px rgba(16,199,232,.12); animation: paybridgeTimerPulse 1.18s ease-in-out infinite; }
.paybridge-timer span { color: #456474; font-size: .7rem; font-weight: 800; line-height: 1.15; }
.paybridge-timer strong { display: block; margin: 2px 0 0; color: #07354f; font-size: 1.08rem; font-weight: 1000; line-height: 1.05; }
@keyframes paybridgeTimerPulse { 0%,100% { background:#eafdff; box-shadow:0 0 0 4px rgba(16,199,232,.12), 0 0 0 0 rgba(245,184,51,0); transform:scale(1); } 42% { background:#fff1b8; box-shadow:0 0 0 4px rgba(245,184,51,.18), 0 0 0 9px rgba(245,184,51,.16); transform:scale(1.035); } 58% { background:#fff8dc; box-shadow:0 0 0 4px rgba(245,184,51,.15), 0 0 0 3px rgba(245,184,51,.10); transform:scale(1.01); } }
.paybridge-account-card { display: grid; grid-template-columns: 64px 1fr; align-items: center; gap: 13px; padding: 15px; border-radius: 21px; background: #fff; box-shadow: 0 14px 30px rgba(6,54,79,.12); border: 1px solid rgba(16,199,232,.22); position: relative; overflow: hidden; }
.paybridge-account-card:before { content: ""; position: absolute; left: 15px; right: 15px; top: 0; height: 1px; background: linear-gradient(90deg, transparent, rgba(16,199,232,.86), transparent); }
.paybridge-bank-mark { width: 64px; height: 64px; padding: 8px; border-radius: 19px; background: #f5fbfd; display: flex; align-items: center; justify-content: center; border: 1px solid #dff1f7; }
.paybridge-bank-mark img { width: 100%; height: 100%; object-fit: contain; border-radius: 12px; }
.paybridge-account-detail { min-width: 0; display: flex; flex-direction: column; align-items: flex-start; }
.paybridge-bank-name { color: #607684; font-size: .78rem; font-weight: 900; text-transform: uppercase; }
.paybridge-account-name { color: #0c2130; font-size: 1.06rem; font-weight: 950; line-height: 1.25; word-break: break-word; }
.paybridge-account-number { margin-top: 5px; display: flex; align-items: center; gap: 8px; color: #087f8f; font-size: 1.5rem; line-height: 1.1; font-weight: 1000; letter-spacing: 0; word-break: break-all; font-variant-numeric: tabular-nums; }
.paybridge-icon-copy { flex: 0 0 auto; width: 34px; height: 34px; display: inline-grid; place-items: center; border-radius: 12px; color: currentColor; background: rgba(255,255,255,.20); border: 1px solid rgba(255,255,255,.54); box-shadow: 0 8px 16px rgba(3,30,48,.12); }
.paybridge-account-number .paybridge-icon-copy { color: #075a74; background: #e8fbff; border-color: #bcebf5; }
.paybridge-critical-warning { margin-top: 14px; padding: 11px; display: grid; grid-template-columns: 30px 1fr; align-items: start; gap: 10px; border-radius: 17px; background: #fff4f5; color: #8d2b33; border: 1px solid #ffd4da; box-shadow: none; }
.paybridge-warning-icon { width: 28px; height: 28px; border-radius: 11px; display: flex; align-items: center; justify-content: center; background: #d84a4f; color: #fff; font-size: .95rem; }
.paybridge-warning-copy { display: flex; flex-direction: column; align-items: flex-start; text-align: left; gap: 3px; }
.paybridge-warning-copy span { font-size: .94rem; font-weight: 850; line-height: 1.5; }
.paybridge-file-input { display: none; }
@media (max-width: 575.98px) {
  .paybridge-panel { padding: 10px; border-radius: 22px; }
  .paybridge-panel-header h3 { font-size: 1.34rem; }
  .paybridge-panel-header p { font-size: 1rem; }
  .paybridge-route { gap: 5px; font-size: 9px; }
  .paybridge-agreement-item { grid-template-columns: 54px 1fr; gap: 12px; min-height: 76px; padding: 12px; }
  .paybridge-agreement-item > strong { width: 54px; height: 54px; font-size: 28px; }
  .paybridge-agreement-item b { font-size: .96rem; }
  .paybridge-agreement-final { font-size: .86rem; }
  .paybridge-ack-button { min-height: 62px; font-size: 1.1rem; }
  .paybridge-cancel-button { min-height: 50px; font-size: 1rem; }
  .paybridge-amount-card { grid-template-columns: 1fr; }
  .paybridge-amount-card strong { align-items: flex-start; font-size: 1.42rem; }
  .paybridge-timer { width: 96px; }
  .paybridge-account-card { grid-template-columns: 56px 1fr; gap: 10px; padding: 12px; }
  .paybridge-bank-mark { width: 56px; height: 56px; border-radius: 16px; }
  .paybridge-account-number { align-items: flex-start; font-size: 1.2rem; }
}
.paybridge-task-button { margin-right:8px; padding:7px 10px; display:flex; align-items:center; gap:7px; color:#fff; background:#dc3545; border:2px solid #fff; border-radius:6px; }
.paybridge-task-button span:last-child { display:flex; flex-direction:column; text-align:left; line-height:1.05; }
.paybridge-task-button small { margin-top:3px; color:#fff4d6; }
.paybridge-task-dot { width:10px; height:10px; border-radius:50%; background:#ffe14d; }
.paybridge-customer-warning { margin-top:12px; padding:12px; color:#7f1d1d; background:#fff5f5; border:2px solid #dc3545; border-radius:7px; }
.paybridge-customer-warning-head { font-size:1.02rem; font-weight:900; }
.paybridge-customer-warning-grid { margin-top:9px; display:grid; grid-template-columns:1fr 1fr; gap:8px; }
.paybridge-customer-warning-item { padding:9px; display:grid; grid-template-columns:28px 1fr; gap:8px; background:#fff; border:1px solid #f5b8bd; border-radius:6px; }
.paybridge-customer-warning-item > b { width:27px; height:27px; display:grid; place-items:center; color:#fff; background:#dc3545; border-radius:4px; }
.paybridge-customer-warning-item strong, .paybridge-customer-warning-item small { display:block; text-align:left; }
.paybridge-customer-warning-item strong { font-size:.96rem; line-height:1.4; }
.paybridge-customer-warning-item small { margin-top:2px; font-size:.84rem; line-height:1.4; }
.paybridge-customer-warning-footer { margin-top:9px; text-align:center; font-size:.95rem; line-height:1.45; font-weight:850; }
@media(max-width:575px){ .paybridge-customer-warning-grid{grid-template-columns:1fr;} }
</style>
<style lang="scss" scoped>
.modal-window {
  position: fixed;
  background-color: rgba(255, 255, 255, 0.25);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s;
  
  &:target {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }
  & > div {
    width: 300px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 1em;
    background: black;
	border: 4px solid #C320D6;
  	border-radius: 30px;
  }
  header {
    font-weight: bold;
  }
  h1 {
    font-size: 150%;
    margin: 0 0 15px;
  }
}

.modal-close {
  color: #aaa;
  line-height: 50px;
  font-size: 80%;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  width: 70px;
  text-decoration: none;
  &:hover {
    color: black;
  }
}

/* Demo Styles */
.modal-window {
  & > div {
    border-radius: 1rem;
  }
}

.modal-window div:not(:last-of-type) {
  margin-bottom: 15px;
}

small {
  color: lightgray;
}

.x-ranking-entrance{position:absolute;right:0;top:150px;z-index:6;margin-right: -14px;}
@media (max-width:1199.98px){
	.x-ranking-entrance{/*position:relative;top:unset;z-index:unset;display:flex*/}
}
.x-ranking-entrance .-link-wrapper{
	background-color:rgba(0,0,0,.5);border-top-left-radius:20px;border-bottom-left-radius:20px;display:flex;padding:.4rem .75rem;color:#fff;align-items: center;
}
@media (min-width:1200px){
	.x-ranking-entrance .-link-wrapper:hover{text-decoration:none;background-color:rgba(0,0,0,.4)}
}@media (max-width:1199.98px){
	.x-ranking-entrance .-link-wrapper{padding:5px;margin-right:.5rem}
}@media (max-width:575.98px){
	.x-ranking-entrance .-link-wrapper{margin-right:.25rem}
}
.x-ranking-entrance .-link-wrapper .-image-wrapper{
	align-items:center;display:flex
}
.x-ranking-entrance .-link-wrapper .-image-wrapper .-ic-right-star-rank{width:30px}
@media (max-width:370px){
	.x-ranking-entrance .-link-wrapper .-image-wrapper .-ic-right-star-rank{min-width:25px}
}
.x-ranking-entrance .-link-wrapper .-text-wrapper{
	line-height:16px;font-size:1.1rem;margin-left:.5rem;
	display: block;
}

/* Enhanced copy button styles */
.-copy-wrapper .btn.-btn.js-copy-to-clipboard {
  padding: 12px 20px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  min-width: 50px !important;
  height: auto !important;
  background: linear-gradient(135deg, #ffc107, #ffab00) !important;
  color: #000 !important;
  border: 2px solid #ffc107 !important;
  box-shadow: 0 4px 12px rgba(255, 193, 7, 0.3) !important;
  transition: all 0.3s ease !important;
  font-family: 'Kanit', sans-serif !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  position: relative !important;
  overflow: hidden !important;
}

.-copy-wrapper .btn.-btn.js-copy-to-clipboard:hover {
  background: linear-gradient(135deg, #ffab00, #ff8f00) !important;
  color: #fff !important;
  border-color: #ffab00 !important;
  box-shadow: 0 6px 20px rgba(255, 193, 7, 0.5) !important;
  transform: translateY(-2px) !important;
}

.-copy-wrapper .btn.-btn.js-copy-to-clipboard:active {
  transform: translateY(0) !important;
  box-shadow: 0 2px 8px rgba(255, 193, 7, 0.4) !important;
}

/* Add animation effect */
.-copy-wrapper .btn.-btn.js-copy-to-clipboard::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.6s ease;
}

.-copy-wrapper .btn.-btn.js-copy-to-clipboard:hover::before {
  left: 100%;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .-copy-wrapper .btn.-btn.js-copy-to-clipboard {
    padding: 10px 16px !important;
    font-size: 14px !important;
    min-width: 100px !important;
  }
}

/* For smaller mobile screens */
@media (max-width: 480px) {
  .-copy-wrapper .btn.-btn.js-copy-to-clipboard {
    padding: 8px 12px !important;
    font-size: 13px !important;
    min-width: 80px !important;
  }
}

.securepay-deposit-panel {
  width: 100%;
  padding: 12px;
}

.securepay-cancel-button {
  width: 100%;
  margin-top: 12px;
  padding: 12px 16px;
  border: 0;
  border-radius: 10px;
  background: #fee2e2;
  color: #b91c1c;
  font-family: 'Kanit', sans-serif;
  font-weight: 600;
}
</style>
